/*! React InstantSearchDOM UNRELEASED | © Algolia, inc. | https://github.com/algolia/instantsearch.js */
!function (e, t) {
  "object" == typeof exports && "undefined" != typeof module ? t(exports, require("react")) : "function" == typeof define && define.amd ? define(["exports", "react"], t) : t((e = e || self).ReactInstantSearchDOM = {}, e.React);
}(this, function (e, S) {
  "use strict";

  var P = "default" in S ? S.default : S,
    A = "undefined" != typeof Element,
    M = "function" == typeof Map,
    D = "function" == typeof Set,
    H = "function" == typeof ArrayBuffer;
  var L = function (e, t) {
    try {
      return function e(t, n) {
        if (t === n) return !0;
        if (t && n && "object" == typeof t && "object" == typeof n) {
          if (t.constructor !== n.constructor) return !1;
          var r, i, a, o;
          if (Array.isArray(t)) {
            if ((r = t.length) != n.length) return !1;
            for (i = r; 0 != i--;) if (!e(t[i], n[i])) return !1;
          } else if (M && t instanceof Map && n instanceof Map) {
            if (t.size !== n.size) return !1;
            for (o = t.entries(); !(i = o.next()).done;) if (!n.has(i.value[0])) return !1;
            for (o = t.entries(); !(i = o.next()).done;) if (!e(i.value[1], n.get(i.value[0]))) return !1;
          } else if (D && t instanceof Set && n instanceof Set) {
            if (t.size !== n.size) return !1;
            for (o = t.entries(); !(i = o.next()).done;) if (!n.has(i.value[0])) return !1;
          } else if (H && ArrayBuffer.isView(t) && ArrayBuffer.isView(n)) {
            if ((r = t.length) != n.length) return !1;
            for (i = r; 0 != i--;) if (t[i] !== n[i]) return !1;
          } else {
            if (t.constructor === RegExp) return t.source === n.source && t.flags === n.flags;
            if (t.valueOf !== Object.prototype.valueOf) return t.valueOf() === n.valueOf();
            if (t.toString !== Object.prototype.toString) return t.toString() === n.toString();
            if ((r = (a = Object.keys(t)).length) !== Object.keys(n).length) return !1;
            for (i = r; 0 != i--;) if (!Object.prototype.hasOwnProperty.call(n, a[i])) return !1;
            if (A && t instanceof Element) return !1;
            for (i = r; 0 != i--;) if (!("_owner" === a[i] && t.$$typeof || e(t[a[i]], n[a[i]]))) return !1;
          }
          return !0;
        }
        return t != t && n != n;
      }(e, t);
    } catch (e) {
      if ((e.message || "").match(/stack|recursion/i)) return console.warn("react-fast-compare cannot handle circular refs"), !1;
      throw e;
    }
  };
  function $(t, e) {
    var n,
      r = Object.keys(t);
    return Object.getOwnPropertySymbols && (n = Object.getOwnPropertySymbols(t), e && (n = n.filter(function (e) {
      return Object.getOwnPropertyDescriptor(t, e).enumerable;
    })), r.push.apply(r, n)), r;
  }
  function B(r) {
    for (var e = 1; e < arguments.length; e++) {
      var i = null != arguments[e] ? arguments[e] : {};
      e % 2 ? $(Object(i), !0).forEach(function (e) {
        var t, n;
        t = r, n = i[e = e], (e = function (e) {
          e = function (e, t) {
            if ("object" !== Q(e) || null === e) return e;
            var n = e[Symbol.toPrimitive];
            if (void 0 === n) return ("string" === t ? String : Number)(e);
            n = n.call(e, t || "default");
            if ("object" !== Q(n)) return n;
            throw new TypeError("@@toPrimitive must return a primitive value.");
          }(e, "string");
          return "symbol" === Q(e) ? e : String(e);
        }(e)) in t ? Object.defineProperty(t, e, {
          value: n,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }) : t[e] = n;
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(r, Object.getOwnPropertyDescriptors(i)) : $(Object(i)).forEach(function (e) {
        Object.defineProperty(r, e, Object.getOwnPropertyDescriptor(i, e));
      });
    }
    return r;
  }
  function Q(e) {
    return (Q = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
      return typeof e;
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    })(e);
  }
  function q(e) {
    z.then(e);
  }
  var U = function (e, t) {
      if (e !== t) {
        var n = Object.keys(e),
          r = Object.keys(t);
        if (n.length !== r.length) return !1;
        for (var i = Object.prototype.hasOwnProperty, a = 0; a < n.length; a++) if (!i.call(t, n[a]) || e[n[a]] !== t[n[a]]) return !1;
      }
      return !0;
    },
    W = function (e) {
      return e.displayName || e.name || "UnknownComponent";
    },
    z = Promise.resolve(),
    Y = function r(i) {
      return Object.keys(i).forEach(function (e) {
        var t,
          n = i[e];
        "object" !== Q(t = n) || null === t || Array.isArray(t) || (G(n) ? r(n) : delete i[e]);
      }), i;
    };
  function J(e, n, r) {
    return e.map(function (e, t) {
      return B(B({}, e), {}, {
        __position: n * r + t + 1
      });
    });
  }
  function Z(e, t) {
    return t ? e.map(function (e) {
      return B(B({}, e), {}, {
        __queryID: t
      });
    }) : e;
  }
  function K(e, t) {
    if (Array.isArray(e)) for (var n = 0; n < e.length; n++) if (t(e[n])) return e[n];
  }
  function G(e) {
    return e && 0 < Object.keys(e).length;
  }
  function X(e, t) {
    if (null == e) return {};
    for (var n = {}, r = Object.keys(e), i = 0; i < r.length; i++) {
      var a = r[i];
      0 <= t.indexOf(a) || (n[a] = e[a]);
    }
    return n;
  }
  var ee = function (e, t) {
    return (Array.isArray(t) ? t : t.replace(/\[(\d+)]/g, ".$1").split(".")).reduce(function (e, t) {
      return e ? e[t] : void 0;
    }, e);
  };
  function te(e) {
    return e.replace(/^\\-/, "-");
  }
  var ne = S.createContext({
      onInternalStateUpdate: function () {},
      createHrefForState: function () {
        return "#";
      },
      onSearchForFacetValues: function () {},
      onSearchStateChange: function () {},
      onSearchParameters: function () {},
      store: {},
      widgetsManager: {},
      mainTargetedIndex: ""
    }),
    re = ne.Consumer,
    ie = ne.Provider,
    ae = S.createContext(void 0),
    oe = ae.Consumer,
    se = ae.Provider,
    ce = ["contextValue"];
  function ue(e) {
    return (ue = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
      return typeof e;
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    })(e);
  }
  function le() {
    return (le = Object.assign ? Object.assign.bind() : function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n,
          r = arguments[t];
        for (n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
      }
      return e;
    }).apply(this, arguments);
  }
  function fe(e, t) {
    if (null == e) return {};
    var n,
      r = function (e, t) {
        if (null == e) return {};
        var n,
          r,
          i = {},
          a = Object.keys(e);
        for (r = 0; r < a.length; r++) n = a[r], 0 <= t.indexOf(n) || (i[n] = e[n]);
        return i;
      }(e, t);
    if (Object.getOwnPropertySymbols) for (var i = Object.getOwnPropertySymbols(e), a = 0; a < i.length; a++) n = i[a], 0 <= t.indexOf(n) || Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
    return r;
  }
  function me(t, e) {
    var n,
      r = Object.keys(t);
    return Object.getOwnPropertySymbols && (n = Object.getOwnPropertySymbols(t), e && (n = n.filter(function (e) {
      return Object.getOwnPropertyDescriptor(t, e).enumerable;
    })), r.push.apply(r, n)), r;
  }
  function pe(t) {
    for (var e = 1; e < arguments.length; e++) {
      var n = null != arguments[e] ? arguments[e] : {};
      e % 2 ? me(Object(n), !0).forEach(function (e) {
        c(t, e, n[e]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : me(Object(n)).forEach(function (e) {
        Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
      });
    }
    return t;
  }
  function he(e, t) {
    for (var n = 0; n < t.length; n++) {
      var r = t[n];
      r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, ve(r.key), r);
    }
  }
  function de(e, t) {
    return (de = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
      return e.__proto__ = t, e;
    })(e, t);
  }
  function ye(n) {
    var r = function () {
      if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
      if (Reflect.construct.sham) return !1;
      if ("function" == typeof Proxy) return !0;
      try {
        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
      } catch (e) {
        return !1;
      }
    }();
    return function () {
      var e,
        t = ge(n),
        t = (e = r ? (e = ge(this).constructor, Reflect.construct(t, arguments, e)) : t.apply(this, arguments), this);
      if (e && ("object" === ue(e) || "function" == typeof e)) return e;
      if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
      return s(t);
    };
  }
  function s(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
  }
  function ge(e) {
    return (ge = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
      return e.__proto__ || Object.getPrototypeOf(e);
    })(e);
  }
  function c(e, t, n) {
    (t = ve(t)) in e ? Object.defineProperty(e, t, {
      value: n,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[t] = n;
  }
  function ve(e) {
    e = function (e, t) {
      if ("object" !== ue(e) || null === e) return e;
      var n = e[Symbol.toPrimitive];
      if (void 0 === n) return ("string" === t ? String : Number)(e);
      n = n.call(e, t || "default");
      if ("object" !== ue(n)) return n;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }(e, "string");
    return "symbol" === ue(e) ? e : String(e);
  }
  function be(u) {
    var o;
    if (u.displayName) return o = "function" == typeof u.getSearchParameters || "function" == typeof u.getMetadata || "function" == typeof u.transitionState, function (i) {
      var e = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : {},
        t = function (e) {
          var t = a;
          if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
          t.prototype = Object.create(e && e.prototype, {
            constructor: {
              value: t,
              writable: !0,
              configurable: !0
            }
          }), Object.defineProperty(t, "prototype", {
            writable: !1
          }), e && de(t, e);
          var n,
            r = ye(a);
          function a(e) {
            var i;
            if (this instanceof a) return c(s(i = r.call(this, e)), "unsubscribe", void 0), c(s(i), "unregisterWidget", void 0), c(s(i), "cleanupTimerRef", null), c(s(i), "isUnmounting", !1), c(s(i), "state", {
              providedProps: i.getProvidedProps(i.props)
            }), c(s(i), "refine", function () {
              for (var e, t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
              i.props.contextValue.onInternalStateUpdate((e = u.refine).call.apply(e, [s(i), i.props, i.props.contextValue.store.getState().widgets].concat(n)));
            }), c(s(i), "createURL", function () {
              for (var e, t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
              return i.props.contextValue.createHrefForState((e = u.refine).call.apply(e, [s(i), i.props, i.props.contextValue.store.getState().widgets].concat(n)));
            }), c(s(i), "searchForFacetValues", function () {
              for (var e, t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
              i.props.contextValue.onSearchForFacetValues((e = u.searchForFacetValues).call.apply(e, [s(i), i.props, i.props.contextValue.store.getState().widgets].concat(n)));
            }), u.getSearchParameters && i.props.contextValue.onSearchParameters(u.getSearchParameters.bind(s(i)), {
              ais: i.props.contextValue,
              multiIndexContext: i.props.indexContextValue
            }, i.props, u.getMetadata && u.getMetadata.bind(s(i)), u.displayName), i;
            throw new TypeError("Cannot call a class as a function");
          }
          return t = a, (e = [{
            key: "componentDidMount",
            value: function () {
              var e = this;
              this.cleanupTimerRef && (clearTimeout(this.cleanupTimerRef), this.cleanupTimerRef = null), this.unsubscribe = this.props.contextValue.store.subscribe(function () {
                e.isUnmounting || e.setState({
                  providedProps: e.getProvidedProps(e.props)
                });
              }), o && (this.unregisterWidget = this.props.contextValue.widgetsManager.registerWidget(this));
            }
          }, {
            key: "shouldComponentUpdate",
            value: function (e, t) {
              return "function" == typeof u.shouldComponentUpdate ? u.shouldComponentUpdate.call(this, this.props, e, this.state, t) : (e = U(this.props, e), null === this.state.providedProps || null === t.providedProps ? this.state.providedProps !== t.providedProps || !e : !e || !U(this.state.providedProps, t.providedProps));
            }
          }, {
            key: "componentDidUpdate",
            value: function (e) {
              L(e, this.props) || (this.setState({
                providedProps: this.getProvidedProps(this.props)
              }), o && (this.props.contextValue.widgetsManager.update(), "function" == typeof u.transitionState) && this.props.contextValue.onSearchStateChange(u.transitionState.call(this, this.props, this.props.contextValue.store.getState().widgets, this.props.contextValue.store.getState().widgets)));
            }
          }, {
            key: "componentWillUnmount",
            value: function () {
              var t = this;
              this.cleanupTimerRef = setTimeout(function () {
                var e;
                t.isUnmounting = !0, t.unsubscribe && t.unsubscribe(), t.unregisterWidget && (t.unregisterWidget(), "function" == typeof u.cleanUp) && (e = u.cleanUp.call(t, t.props, t.props.contextValue.store.getState().widgets), t.props.contextValue.store.setState(pe(pe({}, t.props.contextValue.store.getState()), {}, {
                  widgets: e
                })), t.props.contextValue.onSearchStateChange(Y(e)));
              });
            }
          }, {
            key: "getProvidedProps",
            value: function (e) {
              var t = this.props.contextValue.store.getState(),
                n = t.widgets,
                r = t.results,
                i = t.resultsFacetValues,
                a = t.searching,
                o = t.searchingForFacetValues,
                s = t.isSearchStalled,
                c = t.metadata,
                t = t.error;
              return u.getProvidedProps.call(this, e, n, {
                results: r,
                searching: a,
                searchingForFacetValues: o,
                isSearchStalled: s,
                error: t
              }, c, i);
            }
          }, {
            key: "getSearchParameters",
            value: function (e) {
              return "function" == typeof u.getSearchParameters ? u.getSearchParameters.call(this, e, this.props, this.props.contextValue.store.getState().widgets) : null;
            }
          }, {
            key: "getMetadata",
            value: function (e) {
              return "function" == typeof u.getMetadata ? u.getMetadata.call(this, this.props, e) : {};
            }
          }, {
            key: "transitionState",
            value: function (e, t) {
              return "function" == typeof u.transitionState ? u.transitionState.call(this, this.props, e, t) : t;
            }
          }, {
            key: "render",
            value: function () {
              var e,
                t,
                n = this.props,
                n = (n.contextValue, fe(n, ce)),
                r = this.state.providedProps;
              return null === r ? null : (e = "function" == typeof u.refine ? {
                refine: this.refine,
                createURL: this.createURL
              } : {}, t = "function" == typeof u.searchForFacetValues ? {
                searchForItems: this.searchForFacetValues
              } : {}, P.createElement(i, le({}, n, r, e, t)));
            }
          }]) && he(t.prototype, e), n && he(t, n), Object.defineProperty(t, "prototype", {
            writable: !1
          }), a;
        }(S.Component);
      return c(t, "displayName", "".concat(u.displayName, "(").concat(W(i), ")")), c(t, "$$type", u.$$type), c(t, "$$widgetType", e.$$widgetType), c(t, "propTypes", u.propTypes), c(t, "defaultProps", u.defaultProps), c(t, "_connectorDesc", u), t;
    };
    throw new Error("`createConnector` requires you to provide a `displayName` property.");
  }
  function t(n) {
    return function (e, t) {
      var r = be(n)(e, t);
      return function (n) {
        return P.createElement(re, null, function (t) {
          return P.createElement(oe, null, function (e) {
            return P.createElement(r, le({
              contextValue: t,
              indexContextValue: e
            }, n));
          });
        });
      };
    };
  }
  var xe = {
    highlightPreTag: "<ais-highlight-0000000000>",
    highlightPostTag: "</ais-highlight-0000000000>"
  };
  function Se(e) {
    var t,
      n = e.preTag,
      r = e.postTag,
      e = e.highlightedValue,
      e = (void 0 === e ? "" : e).split(n),
      i = e.shift(),
      a = "" === i ? [] : [{
        value: i,
        isHighlighted: !1
      }];
    return r === n ? (t = !0, e.forEach(function (e) {
      a.push({
        value: e,
        isHighlighted: t
      }), t = !t;
    })) : e.forEach(function (e) {
      e = e.split(r);
      a.push({
        value: e[0],
        isHighlighted: !0
      }), "" !== e[1] && a.push({
        value: e[1],
        isHighlighted: !1
      });
    }), a;
  }
  var Pe = "6.39.1";
  function we(e) {
    return (we = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
      return typeof e;
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    })(e);
  }
  function Re() {
    return (Re = Object.assign ? Object.assign.bind() : function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n,
          r = arguments[t];
        for (n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
      }
      return e;
    }).apply(this, arguments);
  }
  function Oe(e, t) {
    for (var n = 0; n < t.length; n++) {
      var r = t[n];
      r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, Ne(r.key), r);
    }
  }
  function je(e, t) {
    return (je = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
      return e.__proto__ = t, e;
    })(e, t);
  }
  function Ce(n) {
    var r = function () {
      if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
      if (Reflect.construct.sham) return !1;
      if ("function" == typeof Proxy) return !0;
      try {
        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
      } catch (e) {
        return !1;
      }
    }();
    return function () {
      var e,
        t = Fe(n),
        t = (e = r ? (e = Fe(this).constructor, Reflect.construct(t, arguments, e)) : t.apply(this, arguments), this);
      if (e && ("object" === we(e) || "function" == typeof e)) return e;
      if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
      return Ee(t);
    };
  }
  function Ee(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
  }
  function Fe(e) {
    return (Fe = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
      return e.__proto__ || Object.getPrototypeOf(e);
    })(e);
  }
  function Ne(e) {
    e = function (e, t) {
      if ("object" !== we(e) || null === e) return e;
      var n = e[Symbol.toPrimitive];
      if (void 0 === n) return ("string" === t ? String : Number)(e);
      n = n.call(e, t || "default");
      if ("object" !== we(n)) return n;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }(e, "string");
    return "symbol" === we(e) ? e : String(e);
  }
  function n(u) {
    return function (r) {
      var e = function (e) {
          var t = c;
          if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
          t.prototype = Object.create(e && e.prototype, {
            constructor: {
              value: t,
              writable: !0,
              configurable: !0
            }
          }), Object.defineProperty(t, "prototype", {
            writable: !1
          }), e && je(t, e);
          var n,
            s = Ce(c);
          function c() {
            var a,
              e = this,
              t = c;
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
            for (var n, r = arguments.length, i = new Array(r), o = 0; o < r; o++) i[o] = arguments[o];
            return a = s.call.apply(s, [this].concat(i)), e = Ee(a), t = function (e) {
              var t = a.props.translations,
                t = (t && t.hasOwnProperty(e) ? t : u)[e];
              if ("function" != typeof t) return t;
              for (var n = arguments.length, r = new Array(1 < n ? n - 1 : 0), i = 1; i < n; i++) r[i - 1] = arguments[i];
              return t.apply(void 0, r);
            }, (n = Ne(n = "translate")) in e ? Object.defineProperty(e, n, {
              value: t,
              enumerable: !0,
              configurable: !0,
              writable: !0
            }) : e[n] = t, a;
          }
          return t = c, (e = [{
            key: "render",
            value: function () {
              return P.createElement(r, Re({
                translate: this.translate
              }, this.props));
            }
          }]) && Oe(t.prototype, e), n && Oe(t, n), Object.defineProperty(t, "prototype", {
            writable: !1
          }), c;
        }(S.Component),
        t = r.displayName || r.name || "UnknownComponent";
      return e.displayName = "Translatable(".concat(t, ")"), e;
    };
  }
  function Ve(e) {
    return (Ve = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
      return typeof e;
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    })(e);
  }
  function Ie(t, e) {
    var n,
      r = Object.keys(t);
    return Object.getOwnPropertySymbols && (n = Object.getOwnPropertySymbols(t), e && (n = n.filter(function (e) {
      return Object.getOwnPropertyDescriptor(t, e).enumerable;
    })), r.push.apply(r, n)), r;
  }
  function m(t) {
    for (var e = 1; e < arguments.length; e++) {
      var n = null != arguments[e] ? arguments[e] : {};
      e % 2 ? Ie(Object(n), !0).forEach(function (e) {
        p(t, e, n[e]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : Ie(Object(n)).forEach(function (e) {
        Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
      });
    }
    return t;
  }
  function p(e, t, n) {
    return (t = function (e) {
      e = function (e, t) {
        if ("object" !== Ve(e) || null === e) return e;
        var n = e[Symbol.toPrimitive];
        if (void 0 === n) return ("string" === t ? String : Number)(e);
        n = n.call(e, t || "default");
        if ("object" !== Ve(n)) return n;
        throw new TypeError("@@toPrimitive must return a primitive value.");
      }(e, "string");
      return "symbol" === Ve(e) ? e : String(e);
    }(t)) in e ? Object.defineProperty(e, t, {
      value: n,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[t] = n, e;
  }
  function h(e) {
    return _e(e) ? e.multiIndexContext.targetedIndex : e.ais.mainTargetedIndex;
  }
  function d(e, t) {
    if (e.results) {
      if (e.results.hits) return e.results;
      t = h(t);
      if (e.results[t]) return e.results[t];
    }
    return null;
  }
  function _e(e) {
    return e && e.multiIndexContext;
  }
  function y(t, e, n, r, i) {
    var a, o, s, c, u, l, f;
    return _e(n) ? (n = h(n), i ? (s = e, c = n, l = i, u = (u = r) ? {
      page: 1
    } : void 0, f = (o = t).indices && o.indices[c] ? m(m({}, o.indices), {}, p({}, c, m(m({}, o.indices[c]), {}, (p(f = {}, l, m(m({}, o.indices[c][l]), s)), p(f, "page", 1), f)))) : m(m({}, o.indices), {}, p({}, c, m(p({}, l, s), u))), m(m({}, o), {}, {
      indices: f
    })) : (c = e, l = n, s = (s = r) ? {
      page: 1
    } : void 0, l = (u = t).indices && u.indices[l] ? m(m({}, u.indices), {}, p({}, l, m(m(m({}, u.indices[l]), c), s))) : m(m({}, u.indices), {}, p({}, l, m(m({}, c), s))), m(m({}, u), {}, {
      indices: l
    }))) : (t.indices && r && Object.keys(t.indices).forEach(function (e) {
      t = y(t, {
        page: 1
      }, {
        multiIndexContext: {
          targetedIndex: e
        }
      }, !0, i);
    }), i ? (o = e, f = i, n = (n = r) ? {
      page: 1
    } : void 0, m(m({}, a = t), {}, p({}, f, m(m({}, a[f]), o)), n)) : (a = e, n = (n = r) ? {
      page: 1
    } : void 0, m(m(m({}, t), a), n)));
  }
  function Te(e) {
    e = e.match(/^([^.]*)\.(.*)/);
    return {
      namespace: e && e[1],
      attributeName: e && e[2]
    };
  }
  function u(e, t, n, r, i) {
    var a,
      o = h(n),
      s = Te(r),
      c = s.namespace,
      s = s.attributeName,
      n = {
        multiIndex: _e(n),
        indexId: o,
        namespace: c,
        attributeName: s,
        id: r,
        searchState: t
      };
    return c = (o = n).multiIndex, s = o.indexId, r = o.namespace, t = o.attributeName, a = o.id, o = o.searchState, (c && r ? o.indices && o.indices[s] && o.indices[s][r] && Object.hasOwnProperty.call(o.indices[s][r], t) : c ? o.indices && o.indices[s] && Object.hasOwnProperty.call(o.indices[s], a) : r ? o[r] && Object.hasOwnProperty.call(o[r], t) : Object.hasOwnProperty.call(o, a)) ? (s = (c = n).multiIndex, r = c.indexId, t = c.namespace, o = c.attributeName, a = c.id, c = c.searchState, s && t ? c.indices[r][t][o] : s ? c.indices[r][a] : t ? c[t][o] : c[a]) : e.defaultRefinement || i;
  }
  function r(e, t, n) {
    var r,
      i,
      a,
      o,
      s = h(t),
      c = Te(n),
      u = c.namespace,
      c = c.attributeName;
    return _e(t) && Boolean(e.indices) ? (s = (t = {
      attribute: c,
      searchState: e,
      indexId: s,
      id: n,
      namespace: u
    }).searchState, i = t.indexId, r = t.id, o = t.namespace, t = t.attribute, a = s.indices[i], o && a ? m(m({}, s), {}, {
      indices: m(m({}, s.indices), {}, p({}, i, m(m({}, a), {}, p({}, o, X(a[o], [t])))))
    }) : a ? m(m({}, s), {}, {
      indices: m(m({}, s.indices), {}, p({}, i, X(a, [r])))
    }) : s) : (t = (o = {
      attribute: c,
      searchState: e,
      id: n,
      namespace: u
    }).searchState, i = o.id, a = o.namespace, o = o.attribute, a ? m(m({}, t), {}, p({}, a, X(t[a], [o]))) : X(t, [i]));
  }
  function ke(e) {
    return (ke = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
      return typeof e;
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    })(e);
  }
  var Ae = ["children", "contextValue", "indexContextValue"],
    Me = ["children", "contextValue", "indexContextValue"];
  function De(t, e) {
    var n,
      r = Object.keys(t);
    return Object.getOwnPropertySymbols && (n = Object.getOwnPropertySymbols(t), e && (n = n.filter(function (e) {
      return Object.getOwnPropertyDescriptor(t, e).enumerable;
    })), r.push.apply(r, n)), r;
  }
  function He(t) {
    for (var e = 1; e < arguments.length; e++) {
      var n = null != arguments[e] ? arguments[e] : {};
      e % 2 ? De(Object(n), !0).forEach(function (e) {
        Le(t, e, n[e]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : De(Object(n)).forEach(function (e) {
        Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
      });
    }
    return t;
  }
  function Le(e, t, n) {
    return (t = function (e) {
      e = function (e, t) {
        if ("object" !== ke(e) || null === e) return e;
        var n = e[Symbol.toPrimitive];
        if (void 0 === n) return ("string" === t ? String : Number)(e);
        n = n.call(e, t || "default");
        if ("object" !== ke(n)) return n;
        throw new TypeError("@@toPrimitive must return a primitive value.");
      }(e, "string");
      return "symbol" === ke(e) ? e : String(e);
    }(t)) in e ? Object.defineProperty(e, t, {
      value: n,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[t] = n, e;
  }
  function $e(e, t) {
    if (null == e) return {};
    var n,
      r = function (e, t) {
        if (null == e) return {};
        var n,
          r,
          i = {},
          a = Object.keys(e);
        for (r = 0; r < a.length; r++) n = a[r], 0 <= t.indexOf(n) || (i[n] = e[n]);
        return i;
      }(e, t);
    if (Object.getOwnPropertySymbols) for (var i = Object.getOwnPropertySymbols(e), a = 0; a < i.length; a++) n = i[a], 0 <= t.indexOf(n) || Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
    return r;
  }
  function Be() {
    return "configure";
  }
  var ae = t({
      displayName: "AlgoliaConfigure",
      $$type: "ais.configure",
      getProvidedProps: function () {
        return {};
      },
      getSearchParameters: function (e, t) {
        t.children, t.contextValue, t.indexContextValue;
        t = $e(t, Ae);
        return e.setQueryParameters(t);
      },
      transitionState: function (e, t, n) {
        var r = Be(),
          i = (e.children, e.contextValue, e.indexContextValue, $e(e, Me)),
          a = Object.keys(e),
          o = this._props ? Object.keys(this._props).filter(function (e) {
            return -1 === a.indexOf(e);
          }) : [];
        return this._props = e, y(n, Le({}, r, He(He({}, X(n[r], o)), i)), {
          ais: e.contextValue,
          multiIndexContext: e.indexContextValue
        });
      },
      cleanUp: function (n, e) {
        var r = Be(),
          t = h({
            ais: n.contextValue,
            multiIndexContext: n.indexContextValue
          }),
          i = _e({
            ais: n.contextValue,
            multiIndexContext: n.indexContextValue
          }) && e.indices ? e.indices[t] : e,
          t = (i && i[r] ? Object.keys(i[r]) : []).reduce(function (e, t) {
            return n[t] || (e[t] = i[r][t]), e;
          }, {});
        return y(e, Le({}, r, t), {
          ais: n.contextValue,
          multiIndexContext: n.indexContextValue
        });
      }
    }),
    Qe = ae(function () {
      return null;
    }, {
      $$widgetType: "ais.configure"
    }),
    qe = ("undefined" != typeof global ? global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {}).performance || {};
  qe.now || qe.mozNow || qe.msNow || qe.oNow || qe.webkitNow;
  function Ue(e) {
    return "function" == typeof e || Array.isArray(e) || "[object Object]" === Object.prototype.toString.call(e);
  }
  function We(e, t) {
    var n, r;
    if (e !== t) for (var i in t) Object.prototype.hasOwnProperty.call(t, i) && "__proto__" !== i && "constructor" !== i && (n = t[i], void 0 !== (r = e[i]) && void 0 === n || (Ue(r) && Ue(n) ? e[i] = We(r, n) : e[i] = "object" == typeof (r = n) && null !== r ? We(Array.isArray(r) ? [] : {}, r) : r));
    return e;
  }
  function ze() {
    return Array.prototype.slice.call(arguments).reduceRight(function (t, n) {
      return Object.keys(Object(n)).forEach(function (e) {
        void 0 !== n[e] && (void 0 !== t[e] && delete t[e], t[e] = n[e]);
      }), t;
    }, {});
  }
  var Ye = function (e) {
    Ue(e) || (e = {});
    for (var t = 1, n = arguments.length; t < n; t++) {
      var r = arguments[t];
      Ue(r) && We(e, r);
    }
    return e;
  };
  var Je = function (n, r) {
      return n.filter(function (e, t) {
        return -1 < r.indexOf(e) && n.indexOf(e) === t;
      });
    },
    g = function (e, t) {
      if (Array.isArray(e)) for (var n = 0; n < e.length; n++) if (t(e[n])) return e[n];
    };
  var Ze = function e(t) {
    if ("number" == typeof t) return t;
    if ("string" == typeof t) return parseFloat(t);
    if (Array.isArray(t)) return t.map(e);
    throw new Error("The value should be a number, a parsable string or an array of those.");
  };
  var Ke = function (e, t) {
    if (null === e) return {};
    for (var n, r = {}, i = Object.keys(e), a = 0; a < i.length; a++) n = i[a], 0 <= t.indexOf(n) || (r[n] = e[n]);
    return r;
  };
  var Ge = function (e) {
      return e && 0 < Object.keys(e).length;
    },
    Xe = {
      addRefinement: function (e, t, n) {
        var r;
        return Xe.isRefined(e, t, n) ? e : (n = "" + n, n = e[t] ? e[t].concat(n) : [n], (r = {})[t] = n, ze({}, r, e));
      },
      removeRefinement: function (e, n, t) {
        var r;
        return void 0 === t ? Xe.clearRefinement(e, function (e, t) {
          return n === t;
        }) : (r = "" + t, Xe.clearRefinement(e, function (e, t) {
          return n === t && r === e;
        }));
      },
      toggleRefinement: function (e, t, n) {
        if (void 0 === n) throw new Error("toggleRefinement should be used with a value");
        return Xe.isRefined(e, t, n) ? Xe.removeRefinement(e, t, n) : Xe.addRefinement(e, t, n);
      },
      clearRefinement: function (i, a, o) {
        var s, e;
        return void 0 === a ? Ge(i) ? {} : i : "string" == typeof a ? Ke(i, [a]) : "function" == typeof a ? (s = !1, e = Object.keys(i).reduce(function (e, t) {
          var n = i[t] || [],
            r = n.filter(function (e) {
              return !a(e, t, o);
            });
          return r.length !== n.length && (s = !0), e[t] = r, e;
        }, {}), s ? e : i) : void 0;
      },
      isRefined: function (e, t, n) {
        var r = !!e[t] && 0 < e[t].length;
        return void 0 !== n && r ? -1 !== e[t].indexOf("" + n) : r;
      }
    },
    i = Xe;
  function et(e, n) {
    return Array.isArray(e) && Array.isArray(n) ? e.length === n.length && e.every(function (e, t) {
      return et(n[t], e);
    }) : e === n;
  }
  function o(e) {
    var r = e ? o._parseNumbers(e) : {},
      i = (void 0 === r.userToken || null !== (e = r.userToken) && /^[a-zA-Z0-9_-]{1,64}$/.test(e) || console.warn("[algoliasearch-helper] The `userToken` parameter is invalid. This can lead to wrong analytics.\n  - Format: [a-zA-Z0-9_-]{1,64}"), this.facets = r.facets || [], this.disjunctiveFacets = r.disjunctiveFacets || [], this.hierarchicalFacets = r.hierarchicalFacets || [], this.facetsRefinements = r.facetsRefinements || {}, this.facetsExcludes = r.facetsExcludes || {}, this.disjunctiveFacetsRefinements = r.disjunctiveFacetsRefinements || {}, this.numericRefinements = r.numericRefinements || {}, this.tagRefinements = r.tagRefinements || [], this.hierarchicalFacetsRefinements = r.hierarchicalFacetsRefinements || {}, this);
    Object.keys(r).forEach(function (e) {
      var t = -1 !== o.PARAMETERS.indexOf(e),
        n = void 0 !== r[e];
      !t && n && (i[e] = r[e]);
    });
  }
  o.PARAMETERS = Object.keys(new o()), o._parseNumbers = function (i) {
    var r, a;
    return i instanceof o ? i : (r = {}, ["aroundPrecision", "aroundRadius", "getRankingInfo", "minWordSizefor2Typos", "minWordSizefor1Typo", "page", "maxValuesPerFacet", "distinct", "minimumAroundRadius", "hitsPerPage", "minProximity"].forEach(function (e) {
      var t,
        n = i[e];
      "string" == typeof n && (t = parseFloat(n), r[e] = isNaN(t) ? n : t);
    }), Array.isArray(i.insideBoundingBox) && (r.insideBoundingBox = i.insideBoundingBox.map(function (e) {
      return Array.isArray(e) ? e.map(function (e) {
        return parseFloat(e);
      }) : e;
    })), i.numericRefinements && (a = {}, Object.keys(i.numericRefinements).forEach(function (n) {
      var r = i.numericRefinements[n] || {};
      a[n] = {}, Object.keys(r).forEach(function (e) {
        var t = r[e].map(function (e) {
          return Array.isArray(e) ? e.map(function (e) {
            return "string" == typeof e ? parseFloat(e) : e;
          }) : "string" == typeof e ? parseFloat(e) : e;
        });
        a[n][e] = t;
      });
    }), r.numericRefinements = a), Ye({}, i, r));
  }, o.make = function (e) {
    var n = new o(e);
    return (e.hierarchicalFacets || []).forEach(function (e) {
      var t;
      e.rootPath && 0 === (t = (n = 0 < (t = n.getHierarchicalRefinement(e.name)).length && 0 !== t[0].indexOf(e.rootPath) ? n.clearRefinements(e.name) : n).getHierarchicalRefinement(e.name)).length && (n = n.toggleHierarchicalFacetRefinement(e.name, e.rootPath));
    }), n;
  }, o.validate = function (e, t) {
    t = t || {};
    return e.tagFilters && t.tagRefinements && 0 < t.tagRefinements.length ? new Error("[Tags] Cannot switch from the managed tag API to the advanced API. It is probably an error, if it is really what you want, you should first clear the tags with clearTags method.") : 0 < e.tagRefinements.length && t.tagFilters ? new Error("[Tags] Cannot switch from the advanced tag API to the managed API. It is probably an error, if it is not, you should first clear the tags with clearTags method.") : e.numericFilters && t.numericRefinements && Ge(t.numericRefinements) ? new Error("[Numeric filters] Can't switch from the advanced to the managed API. It is probably an error, if this is really what you want, you have to first clear the numeric filters.") : Ge(e.numericRefinements) && t.numericFilters ? new Error("[Numeric filters] Can't switch from the managed API to the advanced. It is probably an error, if this is really what you want, you have to first clear the numeric filters.") : null;
  }, o.prototype = {
    constructor: o,
    clearRefinements: function (e) {
      e = {
        numericRefinements: this._clearNumericRefinements(e),
        facetsRefinements: i.clearRefinement(this.facetsRefinements, e, "conjunctiveFacet"),
        facetsExcludes: i.clearRefinement(this.facetsExcludes, e, "exclude"),
        disjunctiveFacetsRefinements: i.clearRefinement(this.disjunctiveFacetsRefinements, e, "disjunctiveFacet"),
        hierarchicalFacetsRefinements: i.clearRefinement(this.hierarchicalFacetsRefinements, e, "hierarchicalFacet")
      };
      return e.numericRefinements === this.numericRefinements && e.facetsRefinements === this.facetsRefinements && e.facetsExcludes === this.facetsExcludes && e.disjunctiveFacetsRefinements === this.disjunctiveFacetsRefinements && e.hierarchicalFacetsRefinements === this.hierarchicalFacetsRefinements ? this : this.setQueryParameters(e);
    },
    clearTags: function () {
      return void 0 === this.tagFilters && 0 === this.tagRefinements.length ? this : this.setQueryParameters({
        tagFilters: void 0,
        tagRefinements: []
      });
    },
    setIndex: function (e) {
      return e === this.index ? this : this.setQueryParameters({
        index: e
      });
    },
    setQuery: function (e) {
      return e === this.query ? this : this.setQueryParameters({
        query: e
      });
    },
    setPage: function (e) {
      return e === this.page ? this : this.setQueryParameters({
        page: e
      });
    },
    setFacets: function (e) {
      return this.setQueryParameters({
        facets: e
      });
    },
    setDisjunctiveFacets: function (e) {
      return this.setQueryParameters({
        disjunctiveFacets: e
      });
    },
    setHitsPerPage: function (e) {
      return this.hitsPerPage === e ? this : this.setQueryParameters({
        hitsPerPage: e
      });
    },
    setTypoTolerance: function (e) {
      return this.typoTolerance === e ? this : this.setQueryParameters({
        typoTolerance: e
      });
    },
    addNumericRefinement: function (e, t, n) {
      var r,
        n = Ze(n);
      return this.isNumericRefined(e, t, n) ? this : ((r = Ye({}, this.numericRefinements))[e] = Ye({}, r[e]), r[e][t] ? (r[e][t] = r[e][t].slice(), r[e][t].push(n)) : r[e][t] = [n], this.setQueryParameters({
        numericRefinements: r
      }));
    },
    getConjunctiveRefinements: function (e) {
      return this.isConjunctiveFacet(e) && this.facetsRefinements[e] || [];
    },
    getDisjunctiveRefinements: function (e) {
      return this.isDisjunctiveFacet(e) && this.disjunctiveFacetsRefinements[e] || [];
    },
    getHierarchicalRefinement: function (e) {
      return this.hierarchicalFacetsRefinements[e] || [];
    },
    getExcludeRefinements: function (e) {
      return this.isConjunctiveFacet(e) && this.facetsExcludes[e] || [];
    },
    removeNumericRefinement: function (n, r, i) {
      return void 0 !== i ? this.isNumericRefined(n, r, i) ? this.setQueryParameters({
        numericRefinements: this._clearNumericRefinements(function (e, t) {
          return t === n && e.op === r && et(e.val, Ze(i));
        })
      }) : this : void 0 !== r ? this.isNumericRefined(n, r) ? this.setQueryParameters({
        numericRefinements: this._clearNumericRefinements(function (e, t) {
          return t === n && e.op === r;
        })
      }) : this : this.isNumericRefined(n) ? this.setQueryParameters({
        numericRefinements: this._clearNumericRefinements(function (e, t) {
          return t === n;
        })
      }) : this;
    },
    getNumericRefinements: function (e) {
      return this.numericRefinements[e] || {};
    },
    getNumericRefinement: function (e, t) {
      return this.numericRefinements[e] && this.numericRefinements[e][t];
    },
    _clearNumericRefinements: function (o) {
      var s, t, e;
      return void 0 === o ? Ge(this.numericRefinements) ? {} : this.numericRefinements : "string" == typeof o ? Ke(this.numericRefinements, [o]) : "function" == typeof o ? (s = !1, t = this.numericRefinements, e = Object.keys(t).reduce(function (e, r) {
        var i = t[r],
          a = {},
          i = i || {};
        return Object.keys(i).forEach(function (t) {
          var e = i[t] || [],
            n = [];
          e.forEach(function (e) {
            o({
              val: e,
              op: t
            }, r, "numeric") || n.push(e);
          }), n.length !== e.length && (s = !0), a[t] = n;
        }), e[r] = a, e;
      }, {}), s ? e : this.numericRefinements) : void 0;
    },
    addFacet: function (e) {
      return this.isConjunctiveFacet(e) ? this : this.setQueryParameters({
        facets: this.facets.concat([e])
      });
    },
    addDisjunctiveFacet: function (e) {
      return this.isDisjunctiveFacet(e) ? this : this.setQueryParameters({
        disjunctiveFacets: this.disjunctiveFacets.concat([e])
      });
    },
    addHierarchicalFacet: function (e) {
      if (this.isHierarchicalFacet(e.name)) throw new Error("Cannot declare two hierarchical facets with the same name: `" + e.name + "`");
      return this.setQueryParameters({
        hierarchicalFacets: this.hierarchicalFacets.concat([e])
      });
    },
    addFacetRefinement: function (e, t) {
      if (this.isConjunctiveFacet(e)) return i.isRefined(this.facetsRefinements, e, t) ? this : this.setQueryParameters({
        facetsRefinements: i.addRefinement(this.facetsRefinements, e, t)
      });
      throw new Error(e + " is not defined in the facets attribute of the helper configuration");
    },
    addExcludeRefinement: function (e, t) {
      if (this.isConjunctiveFacet(e)) return i.isRefined(this.facetsExcludes, e, t) ? this : this.setQueryParameters({
        facetsExcludes: i.addRefinement(this.facetsExcludes, e, t)
      });
      throw new Error(e + " is not defined in the facets attribute of the helper configuration");
    },
    addDisjunctiveFacetRefinement: function (e, t) {
      if (this.isDisjunctiveFacet(e)) return i.isRefined(this.disjunctiveFacetsRefinements, e, t) ? this : this.setQueryParameters({
        disjunctiveFacetsRefinements: i.addRefinement(this.disjunctiveFacetsRefinements, e, t)
      });
      throw new Error(e + " is not defined in the disjunctiveFacets attribute of the helper configuration");
    },
    addTagRefinement: function (e) {
      return this.isTagRefined(e) ? this : (e = {
        tagRefinements: this.tagRefinements.concat(e)
      }, this.setQueryParameters(e));
    },
    removeFacet: function (t) {
      return this.isConjunctiveFacet(t) ? this.clearRefinements(t).setQueryParameters({
        facets: this.facets.filter(function (e) {
          return e !== t;
        })
      }) : this;
    },
    removeDisjunctiveFacet: function (t) {
      return this.isDisjunctiveFacet(t) ? this.clearRefinements(t).setQueryParameters({
        disjunctiveFacets: this.disjunctiveFacets.filter(function (e) {
          return e !== t;
        })
      }) : this;
    },
    removeHierarchicalFacet: function (t) {
      return this.isHierarchicalFacet(t) ? this.clearRefinements(t).setQueryParameters({
        hierarchicalFacets: this.hierarchicalFacets.filter(function (e) {
          return e.name !== t;
        })
      }) : this;
    },
    removeFacetRefinement: function (e, t) {
      if (this.isConjunctiveFacet(e)) return i.isRefined(this.facetsRefinements, e, t) ? this.setQueryParameters({
        facetsRefinements: i.removeRefinement(this.facetsRefinements, e, t)
      }) : this;
      throw new Error(e + " is not defined in the facets attribute of the helper configuration");
    },
    removeExcludeRefinement: function (e, t) {
      if (this.isConjunctiveFacet(e)) return i.isRefined(this.facetsExcludes, e, t) ? this.setQueryParameters({
        facetsExcludes: i.removeRefinement(this.facetsExcludes, e, t)
      }) : this;
      throw new Error(e + " is not defined in the facets attribute of the helper configuration");
    },
    removeDisjunctiveFacetRefinement: function (e, t) {
      if (this.isDisjunctiveFacet(e)) return i.isRefined(this.disjunctiveFacetsRefinements, e, t) ? this.setQueryParameters({
        disjunctiveFacetsRefinements: i.removeRefinement(this.disjunctiveFacetsRefinements, e, t)
      }) : this;
      throw new Error(e + " is not defined in the disjunctiveFacets attribute of the helper configuration");
    },
    removeTagRefinement: function (t) {
      var e;
      return this.isTagRefined(t) ? (e = {
        tagRefinements: this.tagRefinements.filter(function (e) {
          return e !== t;
        })
      }, this.setQueryParameters(e)) : this;
    },
    toggleRefinement: function (e, t) {
      return this.toggleFacetRefinement(e, t);
    },
    toggleFacetRefinement: function (e, t) {
      if (this.isHierarchicalFacet(e)) return this.toggleHierarchicalFacetRefinement(e, t);
      if (this.isConjunctiveFacet(e)) return this.toggleConjunctiveFacetRefinement(e, t);
      if (this.isDisjunctiveFacet(e)) return this.toggleDisjunctiveFacetRefinement(e, t);
      throw new Error("Cannot refine the undeclared facet " + e + "; it should be added to the helper options facets, disjunctiveFacets or hierarchicalFacets");
    },
    toggleConjunctiveFacetRefinement: function (e, t) {
      if (this.isConjunctiveFacet(e)) return this.setQueryParameters({
        facetsRefinements: i.toggleRefinement(this.facetsRefinements, e, t)
      });
      throw new Error(e + " is not defined in the facets attribute of the helper configuration");
    },
    toggleExcludeFacetRefinement: function (e, t) {
      if (this.isConjunctiveFacet(e)) return this.setQueryParameters({
        facetsExcludes: i.toggleRefinement(this.facetsExcludes, e, t)
      });
      throw new Error(e + " is not defined in the facets attribute of the helper configuration");
    },
    toggleDisjunctiveFacetRefinement: function (e, t) {
      if (this.isDisjunctiveFacet(e)) return this.setQueryParameters({
        disjunctiveFacetsRefinements: i.toggleRefinement(this.disjunctiveFacetsRefinements, e, t)
      });
      throw new Error(e + " is not defined in the disjunctiveFacets attribute of the helper configuration");
    },
    toggleHierarchicalFacetRefinement: function (e, t) {
      var n, r;
      if (this.isHierarchicalFacet(e)) return n = this._getHierarchicalFacetSeparator(this.getHierarchicalFacetByName(e)), r = {}, void 0 !== this.hierarchicalFacetsRefinements[e] && 0 < this.hierarchicalFacetsRefinements[e].length && (this.hierarchicalFacetsRefinements[e][0] === t || 0 === this.hierarchicalFacetsRefinements[e][0].indexOf(t + n)) ? -1 === t.indexOf(n) ? r[e] = [] : r[e] = [t.slice(0, t.lastIndexOf(n))] : r[e] = [t], this.setQueryParameters({
        hierarchicalFacetsRefinements: ze({}, r, this.hierarchicalFacetsRefinements)
      });
      throw new Error(e + " is not defined in the hierarchicalFacets attribute of the helper configuration");
    },
    addHierarchicalFacetRefinement: function (e, t) {
      if (this.isHierarchicalFacetRefined(e)) throw new Error(e + " is already refined.");
      var n;
      if (this.isHierarchicalFacet(e)) return (n = {})[e] = [t], this.setQueryParameters({
        hierarchicalFacetsRefinements: ze({}, n, this.hierarchicalFacetsRefinements)
      });
      throw new Error(e + " is not defined in the hierarchicalFacets attribute of the helper configuration.");
    },
    removeHierarchicalFacetRefinement: function (e) {
      var t;
      return this.isHierarchicalFacetRefined(e) ? ((t = {})[e] = [], this.setQueryParameters({
        hierarchicalFacetsRefinements: ze({}, t, this.hierarchicalFacetsRefinements)
      })) : this;
    },
    toggleTagRefinement: function (e) {
      return this.isTagRefined(e) ? this.removeTagRefinement(e) : this.addTagRefinement(e);
    },
    isDisjunctiveFacet: function (e) {
      return -1 < this.disjunctiveFacets.indexOf(e);
    },
    isHierarchicalFacet: function (e) {
      return void 0 !== this.getHierarchicalFacetByName(e);
    },
    isConjunctiveFacet: function (e) {
      return -1 < this.facets.indexOf(e);
    },
    isFacetRefined: function (e, t) {
      return !!this.isConjunctiveFacet(e) && i.isRefined(this.facetsRefinements, e, t);
    },
    isExcludeRefined: function (e, t) {
      return !!this.isConjunctiveFacet(e) && i.isRefined(this.facetsExcludes, e, t);
    },
    isDisjunctiveFacetRefined: function (e, t) {
      return !!this.isDisjunctiveFacet(e) && i.isRefined(this.disjunctiveFacetsRefinements, e, t);
    },
    isHierarchicalFacetRefined: function (e, t) {
      return !!this.isHierarchicalFacet(e) && (e = this.getHierarchicalRefinement(e), t ? -1 !== e.indexOf(t) : 0 < e.length);
    },
    isNumericRefined: function (e, t, n) {
      var r, i;
      return void 0 === n && void 0 === t ? !!this.numericRefinements[e] : (r = this.numericRefinements[e] && void 0 !== this.numericRefinements[e][t], void 0 !== n && r ? (n = Ze(n), t = void 0 !== (e = this.numericRefinements[e][t], i = n, g(e, function (e) {
        return et(e, i);
      })), r && t) : r);
    },
    isTagRefined: function (e) {
      return -1 !== this.tagRefinements.indexOf(e);
    },
    getRefinedDisjunctiveFacets: function () {
      var t = this,
        e = Je(Object.keys(this.numericRefinements).filter(function (e) {
          return 0 < Object.keys(t.numericRefinements[e]).length;
        }), this.disjunctiveFacets);
      return Object.keys(this.disjunctiveFacetsRefinements).filter(function (e) {
        return 0 < t.disjunctiveFacetsRefinements[e].length;
      }).concat(e).concat(this.getRefinedHierarchicalFacets());
    },
    getRefinedHierarchicalFacets: function () {
      var t = this;
      return Je(this.hierarchicalFacets.map(function (e) {
        return e.name;
      }), Object.keys(this.hierarchicalFacetsRefinements).filter(function (e) {
        return 0 < t.hierarchicalFacetsRefinements[e].length;
      }));
    },
    getUnrefinedDisjunctiveFacets: function () {
      var t = this.getRefinedDisjunctiveFacets();
      return this.disjunctiveFacets.filter(function (e) {
        return -1 === t.indexOf(e);
      });
    },
    managedParameters: ["index", "facets", "disjunctiveFacets", "facetsRefinements", "hierarchicalFacets", "facetsExcludes", "disjunctiveFacetsRefinements", "numericRefinements", "tagRefinements", "hierarchicalFacetsRefinements"],
    getQueryParams: function () {
      var n = this.managedParameters,
        r = {},
        i = this;
      return Object.keys(this).forEach(function (e) {
        var t = i[e];
        -1 === n.indexOf(e) && void 0 !== t && (r[e] = t);
      }), r;
    },
    setQueryParameter: function (e, t) {
      var n;
      return this[e] === t ? this : ((n = {})[e] = t, this.setQueryParameters(n));
    },
    setQueryParameters: function (e) {
      if (!e) return this;
      var t = o.validate(this, e);
      if (t) throw t;
      var n = this,
        i = o._parseNumbers(e),
        t = Object.keys(this).reduce(function (e, t) {
          return e[t] = n[t], e;
        }, {}),
        e = Object.keys(i).reduce(function (e, t) {
          var n = void 0 !== e[t],
            r = void 0 !== i[t];
          return n && !r ? Ke(e, [t]) : (r && (e[t] = i[t]), e);
        }, t);
      return new this.constructor(e);
    },
    resetPage: function () {
      return void 0 === this.page ? this : this.setPage(0);
    },
    _getHierarchicalFacetSortBy: function (e) {
      return e.sortBy || ["isRefined:desc", "name:asc"];
    },
    _getHierarchicalFacetSeparator: function (e) {
      return e.separator || " > ";
    },
    _getHierarchicalRootPath: function (e) {
      return e.rootPath || null;
    },
    _getHierarchicalShowParentLevel: function (e) {
      return "boolean" != typeof e.showParentLevel || e.showParentLevel;
    },
    getHierarchicalFacetByName: function (t) {
      return g(this.hierarchicalFacets, function (e) {
        return e.name === t;
      });
    },
    getHierarchicalFacetBreadcrumb: function (e) {
      var t;
      return this.isHierarchicalFacet(e) && (t = this.getHierarchicalRefinement(e)[0]) ? (e = this._getHierarchicalFacetSeparator(this.getHierarchicalFacetByName(e)), t.split(e).map(function (e) {
        return e.trim();
      })) : [];
    },
    toString: function () {
      return JSON.stringify(this, null, 2);
    }
  };
  var tt = o;
  function nt(e) {
    return Array.isArray(e) ? e.filter(Boolean) : [];
  }
  function rt(e, t) {
    if (Array.isArray(e)) for (var n = 0; n < e.length; n++) if (t(e[n])) return n;
    return -1;
  }
  function it(e, t) {
    var r = (t || []).map(function (e) {
      return e.split(":");
    });
    return e.reduce(function (e, t) {
      var n = t.split(":"),
        t = g(r, function (e) {
          return e[0] === n[0];
        });
      return 1 < n.length || !t ? (e[0].push(n[0]), e[1].push(n[1])) : (e[0].push(t[0]), e[1].push(t[1])), e;
    }, [[], []]);
  }
  var at = function (e, n, i) {
    return Array.isArray(e) ? (Array.isArray(i) || (i = []), (e = e.map(function (t, e) {
      return {
        criteria: n.map(function (e) {
          return t[e];
        }),
        index: e,
        value: t
      };
    })).sort(function (e, t) {
      for (var n = -1; ++n < e.criteria.length;) {
        var r = function (e, t) {
          if (e !== t) {
            var n = void 0 !== e,
              r = null === e,
              i = void 0 !== t,
              a = null === t;
            if (!a && t < e || r && i || !n) return 1;
            if (!r && e < t || a && n || !i) return -1;
          }
          return 0;
        }(e.criteria[n], t.criteria[n]);
        if (r) return !(n >= i.length) && "desc" === i[n] ? -r : r;
      }
      return e.index - t.index;
    }), e.map(function (e) {
      return e.value;
    })) : [];
  };
  var qe = function (e) {
      return "string" != typeof e ? e : String(e).replace(/^-/, "\\-");
    },
    a = function (e) {
      return "string" != typeof e ? e : e.replace(/^\\-/, "-");
    },
    ot = function (h) {
      return function (e, t) {
        function n(e, o, t) {
          var n,
            s = e;
          if (0 < t) {
            var r = 0;
            for (s = e; r < t;) {
              var i = s && Array.isArray(s.data) ? s.data : [],
                s = g(i, function (e) {
                  return e.isRefined;
                });
              r++;
            }
          }
          return s && (n = Object.keys(o.data).map(function (e) {
            return [e, o.data[e]];
          }).filter(function (e) {
            var t,
              n,
              r,
              i,
              a,
              e = e[0];
            return e = e, t = s.path || u, n = f, r = c, a = l, (!(i = u) || 0 === e.indexOf(i) && i !== e) && (!i && -1 === e.indexOf(r) || i && e.split(r).length - i.split(r).length == 1 || -1 === e.indexOf(r) && -1 === n.indexOf(r) || 0 === n.indexOf(e) || 0 === e.indexOf(t + r) && (a || 0 === e.indexOf(n)));
          }), s.data = at(n.map(function (e) {
            var t,
              n,
              r,
              i,
              a = e[0],
              e = e[1];
            return e = e, a = a, t = c, n = ct(f), r = o.exhaustive, {
              name: (i = a.split(t))[i.length - 1].trim(),
              path: a,
              escapedValue: st(a),
              count: e,
              isRefined: n === a || 0 === n.indexOf(a + t),
              exhaustive: r,
              data: null
            };
          }), a[0], a[1])), e;
        }
        var a,
          c,
          u,
          l,
          f,
          r = h.hierarchicalFacets[t],
          i = h.hierarchicalFacetsRefinements[r.name] && h.hierarchicalFacetsRefinements[r.name][0] || "",
          o = h._getHierarchicalFacetSeparator(r),
          s = h._getHierarchicalRootPath(r),
          m = h._getHierarchicalShowParentLevel(r),
          r = it(h._getHierarchicalFacetSortBy(r)),
          p = e.every(function (e) {
            return e.exhaustive;
          }),
          r = (a = r, c = o, l = m, f = i, e);
        return (r = (u = s) ? e.slice(s.split(o).length) : r).reduce(n, {
          name: h.hierarchicalFacets[t].name,
          count: null,
          isRefined: !0,
          path: null,
          escapedValue: null,
          exhaustive: p,
          data: null
        });
      };
    },
    st = qe,
    ct = a;
  var ut = qe,
    lt = a;
  function ft(e) {
    var n = {};
    return e.forEach(function (e, t) {
      n[e] = t;
    }), n;
  }
  function mt(e, t, n) {
    t && t[n] && (e.stats = t[n]);
  }
  function pt(l, t, n) {
    var s = t[0],
      f = (this._rawResults = t, this),
      e = (Object.keys(s).forEach(function (e) {
        f[e] = s[e];
      }), Object.keys(n || {}).forEach(function (e) {
        f[e] = n[e];
      }), this.processingTimeMS = t.reduce(function (e, t) {
        return void 0 === t.processingTimeMS ? e : e + t.processingTimeMS;
      }, 0), this.disjunctiveFacets = [], this.hierarchicalFacets = l.hierarchicalFacets.map(function () {
        return [];
      }), this.facets = [], l.getRefinedDisjunctiveFacets()),
      c = ft(l.facets),
      u = ft(l.disjunctiveFacets),
      r = 1,
      m = s.facets || {};
    Object.keys(m).forEach(function (e) {
      var t,
        n,
        r,
        i,
        a = m[e],
        o = (r = l.hierarchicalFacets, t = e, g(r, function (e) {
          return -1 < (e.attributes || []).indexOf(t);
        }));
      o ? (r = o.attributes.indexOf(e), n = rt(l.hierarchicalFacets, function (e) {
        return e.name === o.name;
      }), f.hierarchicalFacets[n][r] = {
        attribute: e,
        data: a,
        exhaustive: s.exhaustiveFacetsCount
      }) : (n = -1 !== l.disjunctiveFacets.indexOf(e), r = -1 !== l.facets.indexOf(e), n && (i = u[e], f.disjunctiveFacets[i] = {
        name: e,
        data: a,
        exhaustive: s.exhaustiveFacetsCount
      }, mt(f.disjunctiveFacets[i], s.facets_stats, e)), r && (i = c[e], f.facets[i] = {
        name: e,
        data: a,
        exhaustive: s.exhaustiveFacetsCount
      }, mt(f.facets[i], s.facets_stats, e)));
    }), this.hierarchicalFacets = nt(this.hierarchicalFacets), e.forEach(function (e) {
      var i = t[r],
        a = i && i.facets ? i.facets : {},
        o = l.getHierarchicalFacetByName(e);
      Object.keys(a).forEach(function (t) {
        var n,
          e,
          r = a[t];
        o ? (n = rt(l.hierarchicalFacets, function (e) {
          return e.name === o.name;
        }), -1 !== (e = rt(f.hierarchicalFacets[n], function (e) {
          return e.attribute === t;
        })) && (f.hierarchicalFacets[n][e].data = Ye({}, f.hierarchicalFacets[n][e].data, r))) : (n = u[t], e = s.facets && s.facets[t] || {}, f.disjunctiveFacets[n] = {
          name: t,
          data: ze({}, r, e),
          exhaustive: i.exhaustiveFacetsCount
        }, mt(f.disjunctiveFacets[n], i.facets_stats, t), l.disjunctiveFacetsRefinements[t] && l.disjunctiveFacetsRefinements[t].forEach(function (e) {
          !f.disjunctiveFacets[n].data[e] && -1 < l.disjunctiveFacetsRefinements[t].indexOf(lt(e)) && (f.disjunctiveFacets[n].data[e] = 0);
        }));
      }), r++;
    }), l.getRefinedHierarchicalFacets().forEach(function (e) {
      var s = l.getHierarchicalFacetByName(e),
        c = l._getHierarchicalFacetSeparator(s),
        u = l.getHierarchicalRefinement(e);
      0 === u.length || u[0].split(c).length < 2 || t.slice(r).forEach(function (e) {
        var o = e && e.facets ? e.facets : {};
        Object.keys(o).forEach(function (t) {
          var e,
            n,
            r = o[t],
            i = rt(l.hierarchicalFacets, function (e) {
              return e.name === s.name;
            }),
            a = rt(f.hierarchicalFacets[i], function (e) {
              return e.attribute === t;
            });
          -1 !== a && (e = {}, 0 < u.length && (e[n = u[0].split(c)[0]] = f.hierarchicalFacets[i][a].data[n]), f.hierarchicalFacets[i][a].data = ze(e, r, f.hierarchicalFacets[i][a].data));
        }), r++;
      });
    }), Object.keys(l.facetsExcludes).forEach(function (t) {
      var e = l.facetsExcludes[t],
        n = c[t];
      f.facets[n] = {
        name: t,
        data: s.facets[t],
        exhaustive: s.exhaustiveFacetsCount
      }, e.forEach(function (e) {
        f.facets[n] = f.facets[n] || {
          name: t
        }, f.facets[n].data = f.facets[n].data || {}, f.facets[n].data[e] = 0;
      });
    }), this.hierarchicalFacets = this.hierarchicalFacets.map(ot(l)), this.facets = nt(this.facets), this.disjunctiveFacets = nt(this.disjunctiveFacets), this._state = l;
  }
  function ht(n, r) {
    function e(e) {
      return e.name === r;
    }
    var i, a, t, o;
    return n._state.isConjunctiveFacet(r) ? (i = g(n.facets, e)) ? Object.keys(i.data).map(function (e) {
      var t = ut(e);
      return {
        name: e,
        escapedValue: t,
        count: i.data[e],
        isRefined: n._state.isFacetRefined(r, t),
        isExcluded: n._state.isExcludeRefined(r, e)
      };
    }) : [] : n._state.isDisjunctiveFacet(r) ? (a = g(n.disjunctiveFacets, e)) ? Object.keys(a.data).map(function (e) {
      var t = ut(e);
      return {
        name: e,
        escapedValue: t,
        count: a.data[e],
        isRefined: n._state.isDisjunctiveFacetRefined(r, t)
      };
    }) : [] : n._state.isHierarchicalFacet(r) ? ((t = g(n.hierarchicalFacets, e)) && (o = n._state.getHierarchicalFacetByName(r), (o = lt(n._state.getHierarchicalRefinement(r)[0] || "").split(n._state._getHierarchicalFacetSeparator(o))).unshift(r), function t(e, n, r) {
      e.isRefined = e.name === n[r];
      e.data && e.data.forEach(function (e) {
        t(e, n, r + 1);
      });
    }(t, o, 0)), t) : void 0;
  }
  function dt(e, t) {
    e = g(e, function (e) {
      return e.name === t;
    });
    return e && e.stats;
  }
  function yt(e, t, n, r, i) {
    var i = g(i, function (e) {
        return e.name === n;
      }),
      a = i && i.data && i.data[r] ? i.data[r] : 0,
      i = i && i.exhaustive || !1;
    return {
      type: t,
      attributeName: n,
      name: r,
      count: a,
      exhaustive: i
    };
  }
  pt.prototype.getFacetByName = function (t) {
    function e(e) {
      return e.name === t;
    }
    return g(this.facets, e) || g(this.disjunctiveFacets, e) || g(this.hierarchicalFacets, e);
  }, pt.DEFAULT_SORT = ["isRefined:desc", "count:desc", "name:asc"], pt.prototype.getFacetValues = function (e, t) {
    var o,
      s,
      n = ht(this, e);
    if (n) return o = ze({}, t, {
      sortBy: pt.DEFAULT_SORT,
      facetOrdering: !(t && t.sortBy)
    }), s = this, function t(n, e, r, i) {
      var a;
      return i = i || 0, Array.isArray(e) ? n(e, r[i]) : e.data && 0 !== e.data.length ? (a = e.data.map(function (e) {
        return t(n, e, r, i + 1);
      }), a = n(a, r[i]), ze({
        data: a
      }, e)) : e;
    }(function (e, t) {
      if (o.facetOrdering) {
        t = t;
        a = (a = s).renderingContent && a.renderingContent.facetOrdering && a.renderingContent.facetOrdering.values && a.renderingContent.facetOrdering.values[t];
        if (Boolean(a)) return t = e, n = [], r = [], i = ((a = a).order || []).reduce(function (e, t, n) {
          return e[t] = n, e;
        }, {}), t.forEach(function (e) {
          var t = e.path || e.name;
          void 0 !== i[t] ? n[i[t]] = e : r.push(e);
        }), n = n.filter(function (e) {
          return e;
        }), "hidden" === (t = a.sortRemainingBy) ? n : n.concat(at(r, (a = "alpha" === t ? [["path", "name"], ["asc", "asc"]] : [["count"], ["desc"]])[0], a[1]));
      }
      var n, r, i, a;
      if (Array.isArray(o.sortBy)) return t = it(o.sortBy, pt.DEFAULT_SORT), at(e, t[0], t[1]);
      if ("function" == typeof o.sortBy) return a = o.sortBy, e.sort(a);
      throw new Error("options.sortBy is optional but if defined it must be either an array of string (predicates) or a sorting function");
    }, n, Array.isArray(n) ? [e] : s._state.getHierarchicalFacetByName(n.name).attributes);
  }, pt.prototype.getFacetStats = function (e) {
    return this._state.isConjunctiveFacet(e) ? dt(this.facets, e) : this._state.isDisjunctiveFacet(e) ? dt(this.disjunctiveFacets, e) : void 0;
  }, pt.prototype.getRefinements = function () {
    var o = this._state,
      s = this,
      c = [];
    return Object.keys(o.facetsRefinements).forEach(function (t) {
      o.facetsRefinements[t].forEach(function (e) {
        c.push(yt(0, "facet", t, e, s.facets));
      });
    }), Object.keys(o.facetsExcludes).forEach(function (t) {
      o.facetsExcludes[t].forEach(function (e) {
        c.push(yt(0, "exclude", t, e, s.facets));
      });
    }), Object.keys(o.disjunctiveFacetsRefinements).forEach(function (t) {
      o.disjunctiveFacetsRefinements[t].forEach(function (e) {
        c.push(yt(0, "disjunctive", t, e, s.disjunctiveFacets));
      });
    }), Object.keys(o.hierarchicalFacetsRefinements).forEach(function (a) {
      o.hierarchicalFacetsRefinements[a].forEach(function (e) {
        var t, n, r, i;
        c.push((t = o, n = a, e = e, r = s.hierarchicalFacets, i = t.getHierarchicalFacetByName(n), t = t._getHierarchicalFacetSeparator(i), i = e.split(t), e = g(r, function (e) {
          return e.name === n;
        }), t = i.reduce(function (e, t) {
          var n = e && g(e.data, function (e) {
            return e.name === t;
          });
          return void 0 !== n ? n : e;
        }, e), r = t && t.count || 0, i = t && t.exhaustive || !1, e = t && t.path || "", {
          type: "hierarchical",
          attributeName: n,
          name: e,
          count: r,
          exhaustive: i
        }));
      });
    }), Object.keys(o.numericRefinements).forEach(function (n) {
      var e = o.numericRefinements[n];
      Object.keys(e).forEach(function (t) {
        e[t].forEach(function (e) {
          c.push({
            type: "numeric",
            attributeName: n,
            name: e,
            numericValue: e,
            operator: t
          });
        });
      });
    }), o.tagRefinements.forEach(function (e) {
      c.push({
        type: "tag",
        attributeName: "_tags",
        name: e
      });
    }), c;
  };
  var gt = pt;
  function l() {
    this._events = this._events || {}, this._maxListeners = this._maxListeners || void 0;
  }
  a = l;
  function vt(e) {
    return "function" == typeof e;
  }
  function bt(e) {
    return "object" == typeof e && null !== e;
  }
  function xt(e) {
    return void 0 === e;
  }
  l.prototype._events = void 0, l.prototype._maxListeners = void 0, l.defaultMaxListeners = 10, l.prototype.setMaxListeners = function (e) {
    if ("number" != typeof e || e < 0 || isNaN(e)) throw TypeError("n must be a positive number");
    return this._maxListeners = e, this;
  }, l.prototype.emit = function (e) {
    var t, n, r, i, a, o, s;
    if ((this._events || (this._events = {}), "error" === e) && (!this._events.error || bt(this._events.error) && !this._events.error.length)) throw (s = arguments[1]) instanceof Error ? s : ((o = new Error('Uncaught, unspecified "error" event. (' + s + ")")).context = s, o);
    if (xt(t = this._events[e])) return !1;
    if (vt(t)) switch (arguments.length) {
      case 1:
        t.call(this);
        break;
      case 2:
        t.call(this, arguments[1]);
        break;
      case 3:
        t.call(this, arguments[1], arguments[2]);
        break;
      default:
        r = Array.prototype.slice.call(arguments, 1), t.apply(this, r);
    } else if (bt(t)) for (r = Array.prototype.slice.call(arguments, 1), n = (a = t.slice()).length, i = 0; i < n; i++) a[i].apply(this, r);
    return !0;
  }, l.prototype.on = l.prototype.addListener = function (e, t) {
    if (vt(t)) return this._events || (this._events = {}), this._events.newListener && this.emit("newListener", e, vt(t.listener) ? t.listener : t), this._events[e] ? bt(this._events[e]) ? this._events[e].push(t) : this._events[e] = [this._events[e], t] : this._events[e] = t, bt(this._events[e]) && !this._events[e].warned && (t = xt(this._maxListeners) ? l.defaultMaxListeners : this._maxListeners) && 0 < t && this._events[e].length > t && (this._events[e].warned = !0, console.error("(node) warning: possible EventEmitter memory leak detected. %d listeners added. Use emitter.setMaxListeners() to increase limit.", this._events[e].length), "function" == typeof console.trace) && console.trace(), this;
    throw TypeError("listener must be a function");
  }, l.prototype.once = function (e, t) {
    var n;
    if (vt(t)) return n = !1, r.listener = t, this.on(e, r), this;
    throw TypeError("listener must be a function");
    function r() {
      this.removeListener(e, r), n || (n = !0, t.apply(this, arguments));
    }
  }, l.prototype.removeListener = function (e, t) {
    var n, r, i, a;
    if (!vt(t)) throw TypeError("listener must be a function");
    if (this._events && this._events[e]) if (i = (n = this._events[e]).length, r = -1, n === t || vt(n.listener) && n.listener === t) delete this._events[e], this._events.removeListener && this.emit("removeListener", e, t);else if (bt(n)) {
      for (a = i; 0 < a--;) if (n[a] === t || n[a].listener && n[a].listener === t) {
        r = a;
        break;
      }
      if (r < 0) return this;
      1 === n.length ? (n.length = 0, delete this._events[e]) : n.splice(r, 1), this._events.removeListener && this.emit("removeListener", e, t);
    }
    return this;
  }, l.prototype.removeAllListeners = function (e) {
    var t, n;
    if (this._events) if (this._events.removeListener) {
      if (0 === arguments.length) {
        for (t in this._events) "removeListener" !== t && this.removeAllListeners(t);
        this.removeAllListeners("removeListener"), this._events = {};
      } else {
        if (vt(n = this._events[e])) this.removeListener(e, n);else if (n) for (; n.length;) this.removeListener(e, n[n.length - 1]);
        delete this._events[e];
      }
    } else 0 === arguments.length ? this._events = {} : this._events[e] && delete this._events[e];
    return this;
  }, l.prototype.listeners = function (e) {
    e = this._events && this._events[e] ? vt(this._events[e]) ? [this._events[e]] : this._events[e].slice() : [];
    return e;
  }, l.prototype.listenerCount = function (e) {
    if (this._events) {
      e = this._events[e];
      if (vt(e)) return 1;
      if (e) return e.length;
    }
    return 0;
  }, l.listenerCount = function (e, t) {
    return e.listenerCount(t);
  };
  var f = function (e, t) {
    e.prototype = Object.create(t.prototype, {
      constructor: {
        value: e,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    });
  };
  function St(e, t) {
    this.main = e, this.fn = t, this.lastResults = null;
  }
  f(St, a), St.prototype.detach = function () {
    this.removeAllListeners(), this.main.detachDerivedHelper(this);
  }, St.prototype.getModifiedState = function (e) {
    return this.fn(e);
  };
  var Pt = St;
  function wt(n) {
    return Object.keys(n).sort(function (e, t) {
      return e.localeCompare(t);
    }).reduce(function (e, t) {
      return e[t] = n[t], e;
    }, {});
  }
  var v = {
      _getQueries: function (s, c) {
        var u = [];
        return u.push({
          indexName: s,
          params: v._getHitsSearchParams(c)
        }), c.getRefinedDisjunctiveFacets().forEach(function (e) {
          u.push({
            indexName: s,
            params: v._getDisjunctiveFacetSearchParams(c, e)
          });
        }), c.getRefinedHierarchicalFacets().forEach(function (e) {
          var a,
            o = c.getHierarchicalFacetByName(e),
            e = c.getHierarchicalRefinement(e),
            r = c._getHierarchicalFacetSeparator(o);
          0 < e.length && 1 < e[0].split(r).length && (a = e[0].split(r).slice(0, -1).reduce(function (e, t, n) {
            return e.concat({
              attribute: o.attributes[n],
              value: 0 === n ? t : [e[e.length - 1].value, t].join(r)
            });
          }, [])).forEach(function (e, t) {
            e = v._getDisjunctiveFacetSearchParams(c, e.attribute, 0 === t);
            function r(t) {
              return o.attributes.some(function (e) {
                return e === t.split(":")[0];
              });
            }
            var n = (e.facetFilters || []).reduce(function (e, t) {
                var n;
                return Array.isArray(t) && 0 < (n = t.filter(function (e) {
                  return !r(e);
                })).length && e.push(n), "string" != typeof t || r(t) || e.push(t), e;
              }, []),
              i = a[t - 1];
            e.facetFilters = 0 < t ? n.concat(i.attribute + ":" + i.value) : 0 < n.length ? n : void 0, u.push({
              indexName: s,
              params: e
            });
          });
        }), u;
      },
      _getHitsSearchParams: function (e) {
        var t = e.facets.concat(e.disjunctiveFacets).concat(v._getHitsHierarchicalFacetsAttributes(e)),
          n = v._getFacetFilters(e),
          r = v._getNumericFilters(e),
          i = v._getTagFilters(e),
          t = {
            facets: -1 < t.indexOf("*") ? ["*"] : t,
            tagFilters: i
          };
        return 0 < n.length && (t.facetFilters = n), 0 < r.length && (t.numericFilters = r), wt(Ye({}, e.getQueryParams(), t));
      },
      _getDisjunctiveFacetSearchParams: function (e, t, n) {
        var r = v._getFacetFilters(e, t, n),
          i = v._getNumericFilters(e, t),
          a = v._getTagFilters(e),
          o = {
            hitsPerPage: 0,
            page: 0,
            analytics: !1,
            clickAnalytics: !1
          },
          a = (0 < a.length && (o.tagFilters = a), e.getHierarchicalFacetByName(t));
        return o.facets = a ? v._getDisjunctiveHierarchicalFacetAttribute(e, a, n) : t, 0 < i.length && (o.numericFilters = i), 0 < r.length && (o.facetFilters = r), wt(Ye({}, e.getQueryParams(), o));
      },
      _getNumericFilters: function (e, i) {
        var a;
        return e.numericFilters || (a = [], Object.keys(e.numericRefinements).forEach(function (r) {
          var t = e.numericRefinements[r] || {};
          Object.keys(t).forEach(function (n) {
            var e = t[n] || [];
            i !== r && e.forEach(function (e) {
              var t;
              Array.isArray(e) ? (t = e.map(function (e) {
                return r + n + e;
              }), a.push(t)) : a.push(r + n + e);
            });
          });
        }), a);
      },
      _getTagFilters: function (e) {
        return e.tagFilters || e.tagRefinements.join(",");
      },
      _getFacetFilters: function (o, s, c) {
        var u = [],
          e = o.facetsRefinements || {},
          n = (Object.keys(e).forEach(function (t) {
            (e[t] || []).forEach(function (e) {
              u.push(t + ":" + e);
            });
          }), o.facetsExcludes || {}),
          r = (Object.keys(n).forEach(function (t) {
            (n[t] || []).forEach(function (e) {
              u.push(t + ":-" + e);
            });
          }), o.disjunctiveFacetsRefinements || {}),
          l = (Object.keys(r).forEach(function (t) {
            var n,
              e = r[t] || [];
            t !== s && e && 0 !== e.length && (n = [], e.forEach(function (e) {
              n.push(t + ":" + e);
            }), u.push(n));
          }), o.hierarchicalFacetsRefinements || {});
        return Object.keys(l).forEach(function (e) {
          var t = (l[e] || [])[0];
          if (void 0 !== t) {
            var n,
              r = o.getHierarchicalFacetByName(e),
              i = o._getHierarchicalFacetSeparator(r),
              a = o._getHierarchicalRootPath(r);
            if (s === e) {
              if (-1 === t.indexOf(i) || !a && !0 === c || a && a.split(i).length === t.split(i).length) return;
              t = a ? (n = a.split(i).length - 1, a) : (n = t.split(i).length - 2, t.slice(0, t.lastIndexOf(i)));
            } else n = t.split(i).length - 1;
            (e = r.attributes[n]) && u.push([e + ":" + t]);
          }
        }), u;
      },
      _getHitsHierarchicalFacetsAttributes: function (i) {
        return i.hierarchicalFacets.reduce(function (e, t) {
          var n,
            r = i.getHierarchicalRefinement(t.name)[0];
          return r ? (n = i._getHierarchicalFacetSeparator(t), r = r.split(n).length, n = t.attributes.slice(0, r + 1), e.concat(n)) : (e.push(t.attributes[0]), e);
        }, []);
      },
      _getDisjunctiveHierarchicalFacetAttribute: function (e, t, n) {
        var r,
          i = e._getHierarchicalFacetSeparator(t);
        return !0 === n ? (n = 0, (r = e._getHierarchicalRootPath(t)) && (n = r.split(i).length), [t.attributes[n]]) : (r = (e.getHierarchicalRefinement(t.name)[0] || "").split(i).length - 1, t.attributes.slice(0, 1 + r));
      },
      getSearchForFacetQuery: function (e, t, n, r) {
        r = r.isDisjunctiveFacet(e) ? r.clearRefinements(e) : r, t = {
          facetQuery: t,
          facetName: e
        };
        return "number" == typeof n && (t.maxFacetHits = n), wt(Ye({}, v._getHitsSearchParams(r), t));
      }
    },
    Rt = v,
    b = "3.11.3",
    Ot = qe;
  function x(e, t, n) {
    "function" == typeof e.addAlgoliaAgent && e.addAlgoliaAgent("JS Helper (3.11.3)"), this.setClient(e);
    e = n || {};
    e.index = t, this.state = tt.make(e), this.lastResults = null, this._queryId = 0, this._lastQueryIdReceived = -1, this.derivedHelpers = [], this._currentNbQueries = 0;
  }
  function jt(e) {
    if (e < 0) throw new Error("Page requested below 0.");
    return this._change({
      state: this.state.setPage(e),
      isPageReset: !1
    }), this;
  }
  function Ct() {
    return this.state.page;
  }
  f(x, a), x.prototype.search = function () {
    return this._search({
      onlyWithDerivedHelpers: !1
    }), this;
  }, x.prototype.searchOnlyWithDerivedHelpers = function () {
    return this._search({
      onlyWithDerivedHelpers: !0
    }), this;
  }, x.prototype.getQuery = function () {
    var e = this.state;
    return Rt._getHitsSearchParams(e);
  }, x.prototype.searchOnce = function (e, t) {
    var n = e ? this.state.setQueryParameters(e) : this.state,
      e = Rt._getQueries(n.index, n),
      r = this;
    if (this._currentNbQueries++, this.emit("searchOnce", {
      state: n
    }), !t) return this.client.search(e).then(function (e) {
      return r._currentNbQueries--, 0 === r._currentNbQueries && r.emit("searchQueueEmpty"), {
        content: new gt(n, e.results),
        state: n,
        _originalResponse: e
      };
    }, function (e) {
      throw r._currentNbQueries--, 0 === r._currentNbQueries && r.emit("searchQueueEmpty"), e;
    });
    this.client.search(e).then(function (e) {
      r._currentNbQueries--, 0 === r._currentNbQueries && r.emit("searchQueueEmpty"), t(null, new gt(n, e.results), n);
    }).catch(function (e) {
      r._currentNbQueries--, 0 === r._currentNbQueries && r.emit("searchQueueEmpty"), t(e, null, n);
    });
  }, x.prototype.findAnswers = function (e) {
    console.warn("[algoliasearch-helper] answers is no longer supported");
    var t = this.state,
      n = this.derivedHelpers[0];
    if (!n) return Promise.resolve([]);
    var n = n.getModifiedState(t),
      t = Ye({
        attributesForPrediction: e.attributesForPrediction,
        nbHits: e.nbHits
      }, {
        params: Ke(Rt._getHitsSearchParams(n), ["attributesToSnippet", "hitsPerPage", "restrictSearchableAttributes", "snippetEllipsisText"])
      }),
      r = "search for answers was called, but this client does not have a function client.initIndex(index).findAnswers";
    if ("function" != typeof this.client.initIndex) throw new Error(r);
    var i = this.client.initIndex(n.index);
    if ("function" != typeof i.findAnswers) throw new Error(r);
    return i.findAnswers(n.query, e.queryLanguages, t);
  }, x.prototype.searchForFacetValues = function (t, e, n, r) {
    var i,
      a,
      o,
      s = "function" == typeof this.client.searchForFacetValues,
      c = "function" == typeof this.client.initIndex;
    if (s || c || "function" == typeof this.client.search) return i = this.state.setQueryParameters(r || {}), a = i.isDisjunctiveFacet(t), r = Rt.getSearchForFacetQuery(t, e, n, i), this._currentNbQueries++, o = this, n = s ? this.client.searchForFacetValues([{
      indexName: i.index,
      params: r
    }]) : c ? this.client.initIndex(i.index).searchForFacetValues(r) : (delete r.facetName, this.client.search([{
      type: "facet",
      facet: t,
      indexName: i.index,
      params: r
    }]).then(function (e) {
      return e.results[0];
    })), this.emit("searchForFacetValues", {
      state: i,
      facet: t,
      query: e
    }), n.then(function (e) {
      return o._currentNbQueries--, 0 === o._currentNbQueries && o.emit("searchQueueEmpty"), (e = Array.isArray(e) ? e[0] : e).facetHits.forEach(function (e) {
        e.escapedValue = Ot(e.value), e.isRefined = a ? i.isDisjunctiveFacetRefined(t, e.escapedValue) : i.isFacetRefined(t, e.escapedValue);
      }), e;
    }, function (e) {
      throw o._currentNbQueries--, 0 === o._currentNbQueries && o.emit("searchQueueEmpty"), e;
    });
    throw new Error("search for facet values (searchable) was called, but this client does not have a function client.searchForFacetValues or client.initIndex(index).searchForFacetValues");
  }, x.prototype.setQuery = function (e) {
    return this._change({
      state: this.state.resetPage().setQuery(e),
      isPageReset: !0
    }), this;
  }, x.prototype.clearRefinements = function (e) {
    return this._change({
      state: this.state.resetPage().clearRefinements(e),
      isPageReset: !0
    }), this;
  }, x.prototype.clearTags = function () {
    return this._change({
      state: this.state.resetPage().clearTags(),
      isPageReset: !0
    }), this;
  }, x.prototype.addDisjunctiveFacetRefinement = function (e, t) {
    return this._change({
      state: this.state.resetPage().addDisjunctiveFacetRefinement(e, t),
      isPageReset: !0
    }), this;
  }, x.prototype.addDisjunctiveRefine = function () {
    return this.addDisjunctiveFacetRefinement.apply(this, arguments);
  }, x.prototype.addHierarchicalFacetRefinement = function (e, t) {
    return this._change({
      state: this.state.resetPage().addHierarchicalFacetRefinement(e, t),
      isPageReset: !0
    }), this;
  }, x.prototype.addNumericRefinement = function (e, t, n) {
    return this._change({
      state: this.state.resetPage().addNumericRefinement(e, t, n),
      isPageReset: !0
    }), this;
  }, x.prototype.addFacetRefinement = function (e, t) {
    return this._change({
      state: this.state.resetPage().addFacetRefinement(e, t),
      isPageReset: !0
    }), this;
  }, x.prototype.addRefine = function () {
    return this.addFacetRefinement.apply(this, arguments);
  }, x.prototype.addFacetExclusion = function (e, t) {
    return this._change({
      state: this.state.resetPage().addExcludeRefinement(e, t),
      isPageReset: !0
    }), this;
  }, x.prototype.addExclude = function () {
    return this.addFacetExclusion.apply(this, arguments);
  }, x.prototype.addTag = function (e) {
    return this._change({
      state: this.state.resetPage().addTagRefinement(e),
      isPageReset: !0
    }), this;
  }, x.prototype.removeNumericRefinement = function (e, t, n) {
    return this._change({
      state: this.state.resetPage().removeNumericRefinement(e, t, n),
      isPageReset: !0
    }), this;
  }, x.prototype.removeDisjunctiveFacetRefinement = function (e, t) {
    return this._change({
      state: this.state.resetPage().removeDisjunctiveFacetRefinement(e, t),
      isPageReset: !0
    }), this;
  }, x.prototype.removeDisjunctiveRefine = function () {
    return this.removeDisjunctiveFacetRefinement.apply(this, arguments);
  }, x.prototype.removeHierarchicalFacetRefinement = function (e) {
    return this._change({
      state: this.state.resetPage().removeHierarchicalFacetRefinement(e),
      isPageReset: !0
    }), this;
  }, x.prototype.removeFacetRefinement = function (e, t) {
    return this._change({
      state: this.state.resetPage().removeFacetRefinement(e, t),
      isPageReset: !0
    }), this;
  }, x.prototype.removeRefine = function () {
    return this.removeFacetRefinement.apply(this, arguments);
  }, x.prototype.removeFacetExclusion = function (e, t) {
    return this._change({
      state: this.state.resetPage().removeExcludeRefinement(e, t),
      isPageReset: !0
    }), this;
  }, x.prototype.removeExclude = function () {
    return this.removeFacetExclusion.apply(this, arguments);
  }, x.prototype.removeTag = function (e) {
    return this._change({
      state: this.state.resetPage().removeTagRefinement(e),
      isPageReset: !0
    }), this;
  }, x.prototype.toggleFacetExclusion = function (e, t) {
    return this._change({
      state: this.state.resetPage().toggleExcludeFacetRefinement(e, t),
      isPageReset: !0
    }), this;
  }, x.prototype.toggleExclude = function () {
    return this.toggleFacetExclusion.apply(this, arguments);
  }, x.prototype.toggleRefinement = function (e, t) {
    return this.toggleFacetRefinement(e, t);
  }, x.prototype.toggleFacetRefinement = function (e, t) {
    return this._change({
      state: this.state.resetPage().toggleFacetRefinement(e, t),
      isPageReset: !0
    }), this;
  }, x.prototype.toggleRefine = function () {
    return this.toggleFacetRefinement.apply(this, arguments);
  }, x.prototype.toggleTag = function (e) {
    return this._change({
      state: this.state.resetPage().toggleTagRefinement(e),
      isPageReset: !0
    }), this;
  }, x.prototype.nextPage = function () {
    var e = this.state.page || 0;
    return this.setPage(e + 1);
  }, x.prototype.previousPage = function () {
    var e = this.state.page || 0;
    return this.setPage(e - 1);
  }, x.prototype.setCurrentPage = jt, x.prototype.setPage = jt, x.prototype.setIndex = function (e) {
    return this._change({
      state: this.state.resetPage().setIndex(e),
      isPageReset: !0
    }), this;
  }, x.prototype.setQueryParameter = function (e, t) {
    return this._change({
      state: this.state.resetPage().setQueryParameter(e, t),
      isPageReset: !0
    }), this;
  }, x.prototype.setState = function (e) {
    return this._change({
      state: tt.make(e),
      isPageReset: !1
    }), this;
  }, x.prototype.overrideStateWithoutTriggeringChangeEvent = function (e) {
    return this.state = new tt(e), this;
  }, x.prototype.hasRefinements = function (e) {
    return !!Ge(this.state.getNumericRefinements(e)) || (this.state.isConjunctiveFacet(e) ? this.state.isFacetRefined(e) : this.state.isDisjunctiveFacet(e) ? this.state.isDisjunctiveFacetRefined(e) : !!this.state.isHierarchicalFacet(e) && this.state.isHierarchicalFacetRefined(e));
  }, x.prototype.isExcluded = function (e, t) {
    return this.state.isExcludeRefined(e, t);
  }, x.prototype.isDisjunctiveRefined = function (e, t) {
    return this.state.isDisjunctiveFacetRefined(e, t);
  }, x.prototype.hasTag = function (e) {
    return this.state.isTagRefined(e);
  }, x.prototype.isTagRefined = function () {
    return this.hasTagRefinements.apply(this, arguments);
  }, x.prototype.getIndex = function () {
    return this.state.index;
  }, x.prototype.getCurrentPage = Ct, x.prototype.getPage = Ct, x.prototype.getTags = function () {
    return this.state.tagRefinements;
  }, x.prototype.getRefinements = function (e) {
    var n = [],
      r = (this.state.isConjunctiveFacet(e) ? (this.state.getConjunctiveRefinements(e).forEach(function (e) {
        n.push({
          value: e,
          type: "conjunctive"
        });
      }), this.state.getExcludeRefinements(e).forEach(function (e) {
        n.push({
          value: e,
          type: "exclude"
        });
      })) : this.state.isDisjunctiveFacet(e) && this.state.getDisjunctiveRefinements(e).forEach(function (e) {
        n.push({
          value: e,
          type: "disjunctive"
        });
      }), this.state.getNumericRefinements(e));
    return Object.keys(r).forEach(function (e) {
      var t = r[e];
      n.push({
        value: t,
        operator: e,
        type: "numeric"
      });
    }), n;
  }, x.prototype.getNumericRefinement = function (e, t) {
    return this.state.getNumericRefinement(e, t);
  }, x.prototype.getHierarchicalFacetBreadcrumb = function (e) {
    return this.state.getHierarchicalFacetBreadcrumb(e);
  }, x.prototype._search = function (e) {
    var r = this.state,
      i = [],
      t = [],
      e = (e.onlyWithDerivedHelpers || (t = Rt._getQueries(r.index, r), i.push({
        state: r,
        queriesCount: t.length,
        helper: this
      }), this.emit("search", {
        state: r,
        results: this.lastResults
      })), this.derivedHelpers.map(function (e) {
        var t = e.getModifiedState(r),
          n = Rt._getQueries(t.index, t);
        return i.push({
          state: t,
          queriesCount: n.length,
          helper: e
        }), e.emit("search", {
          state: t,
          results: e.lastResults
        }), n;
      })),
      t = Array.prototype.concat.apply(t, e),
      e = this._queryId++;
    this._currentNbQueries++;
    try {
      this.client.search(t).then(this._dispatchAlgoliaResponse.bind(this, i, e)).catch(this._dispatchAlgoliaError.bind(this, e));
    } catch (e) {
      this.emit("error", {
        error: e
      });
    }
  }, x.prototype._dispatchAlgoliaResponse = function (e, t, n) {
    var r;
    t < this._lastQueryIdReceived || (this._currentNbQueries -= t - this._lastQueryIdReceived, this._lastQueryIdReceived = t, 0 === this._currentNbQueries && this.emit("searchQueueEmpty"), r = n.results.slice(), e.forEach(function (e) {
      var t = e.state,
        n = e.queriesCount,
        e = e.helper,
        n = r.splice(0, n),
        n = e.lastResults = new gt(t, n);
      e.emit("result", {
        results: n,
        state: t
      });
    }));
  }, x.prototype._dispatchAlgoliaError = function (e, t) {
    e < this._lastQueryIdReceived || (this._currentNbQueries -= e - this._lastQueryIdReceived, this._lastQueryIdReceived = e, this.emit("error", {
      error: t
    }), 0 === this._currentNbQueries && this.emit("searchQueueEmpty"));
  }, x.prototype.containsRefinement = function (e, t, n, r) {
    return e || 0 !== t.length || 0 !== n.length || 0 !== r.length;
  }, x.prototype._hasDisjunctiveRefinements = function (e) {
    return this.state.disjunctiveRefinements[e] && 0 < this.state.disjunctiveRefinements[e].length;
  }, x.prototype._change = function (e) {
    var t = e.state,
      e = e.isPageReset;
    t !== this.state && (this.state = t, this.emit("change", {
      state: this.state,
      results: this.lastResults,
      isPageReset: e
    }));
  }, x.prototype.clearCache = function () {
    return this.client.clearCache && this.client.clearCache(), this;
  }, x.prototype.setClient = function (e) {
    return this.client !== e && ("function" == typeof e.addAlgoliaAgent && e.addAlgoliaAgent("JS Helper (3.11.3)"), this.client = e), this;
  }, x.prototype.getClient = function () {
    return this.client;
  }, x.prototype.derive = function (e) {
    e = new Pt(this, e);
    return this.derivedHelpers.push(e), e;
  }, x.prototype.detachDerivedHelper = function (e) {
    e = this.derivedHelpers.indexOf(e);
    if (-1 === e) throw new Error("Derived helper already detached");
    this.derivedHelpers.splice(e, 1);
  }, x.prototype.hasPendingRequests = function () {
    return 0 < this._currentNbQueries;
  };
  var Et = x;
  function Ft(e, t, n) {
    return new Et(e, t, n);
  }
  Ft.version = b, Ft.AlgoliaSearchHelper = Et, Ft.SearchParameters = tt, Ft.SearchResults = gt;
  var Nt = Ft;
  function Vt(e) {
    return (Vt = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
      return typeof e;
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    })(e);
  }
  function It(e) {
    return function (e) {
      if (Array.isArray(e)) return _t(e);
    }(e) || function (e) {
      if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
    }(e) || function (e, t) {
      var n;
      if (e) return "string" == typeof e ? _t(e, t) : "Map" === (n = "Object" === (n = Object.prototype.toString.call(e).slice(8, -1)) && e.constructor ? e.constructor.name : n) || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? _t(e, t) : void 0;
    }(e) || function () {
      throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }();
  }
  function _t(e, t) {
    (null == t || t > e.length) && (t = e.length);
    for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
    return r;
  }
  function Tt(t, e) {
    var n,
      r = Object.keys(t);
    return Object.getOwnPropertySymbols && (n = Object.getOwnPropertySymbols(t), e && (n = n.filter(function (e) {
      return Object.getOwnPropertyDescriptor(t, e).enumerable;
    })), r.push.apply(r, n)), r;
  }
  function kt(t) {
    for (var e = 1; e < arguments.length; e++) {
      var n = null != arguments[e] ? arguments[e] : {};
      e % 2 ? Tt(Object(n), !0).forEach(function (e) {
        At(t, e, n[e]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : Tt(Object(n)).forEach(function (e) {
        Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
      });
    }
    return t;
  }
  function At(e, t, n) {
    return (t = function (e) {
      e = function (e, t) {
        if ("object" !== Vt(e) || null === e) return e;
        var n = e[Symbol.toPrimitive];
        if (void 0 === n) return ("string" === t ? String : Number)(e);
        n = n.call(e, t || "default");
        if ("object" !== Vt(n)) return n;
        throw new TypeError("@@toPrimitive must return a primitive value.");
      }(e, "string");
      return "symbol" === Vt(e) ? e : String(e);
    }(t)) in e ? Object.defineProperty(e, t, {
      value: n,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[t] = n, e;
  }
  function Mt(e) {
    var t = e.attributeName,
      n = e.attributeValue,
      e = e.attributeScore;
    return "".concat(t, ":").concat(n, "<score=").concat(e || 1, ">");
  }
  function Dt() {
    return "configure";
  }
  function Ht(a) {
    var e = Object.keys(a.matchingPatterns).reduce(function (e, t) {
      var n = a.matchingPatterns[t],
        r = ee(a.hit, t),
        i = n.score;
      return Array.isArray(r) ? [].concat(It(e), [r.map(function (e) {
        return Mt({
          attributeName: t,
          attributeValue: e,
          attributeScore: i
        });
      })]) : "string" == typeof r ? [].concat(It(e), [Mt({
        attributeName: t,
        attributeValue: r,
        attributeScore: i
      })]) : e;
    }, []);
    return a.transformSearchParameters(new Nt.SearchParameters({
      sumOrFiltersScores: !0,
      facetFilters: ["objectID:-".concat(a.hit.objectID)],
      optionalFilters: e
    }));
  }
  qe = t({
    displayName: "AlgoliaConfigureRelatedItems",
    $$type: "ais.configureRelatedItems",
    defaultProps: {
      transformSearchParameters: function (e) {
        return kt({}, e);
      }
    },
    getProvidedProps: function () {
      return {};
    },
    getSearchParameters: function (e, t) {
      return e.setQueryParameters(Ht(t));
    },
    transitionState: function (e, t, n) {
      var r,
        i = Dt(),
        a = (r = Y(Ht(e)), Object.keys(r).forEach(function (e) {
          var t = r[e];
          Array.isArray(t) && 0 === t.length && delete r[e];
        }), r),
        o = Object.keys(a),
        s = this._searchParameters ? Object.keys(this._searchParameters).filter(function (e) {
          return -1 === o.indexOf(e);
        }) : [];
      return this._searchParameters = a, y(n, At({}, i, kt(kt({}, X(n[i], s)), a)), {
        ais: e.contextValue,
        multiIndexContext: e.indexContextValue
      });
    },
    cleanUp: function (e, t) {
      var n = this,
        r = Dt(),
        i = h({
          ais: e.contextValue,
          multiIndexContext: e.indexContextValue
        }),
        a = _e({
          ais: e.contextValue,
          multiIndexContext: e.indexContextValue
        }) && t.indices ? t.indices[i] : t,
        i = (a && a[r] ? Object.keys(a[r]) : []).reduce(function (e, t) {
          return n._searchParameters[t] || (e[t] = a[r][t]), e;
        }, {});
      return y(t, At({}, r, i), {
        ais: e.contextValue,
        multiIndexContext: e.indexContextValue
      });
    }
  });
  function Lt(e, t) {
    return e(t = {
      exports: {}
    }, t.exports), t.exports;
  }
  var f = "function" == typeof Symbol && Symbol.for,
    $t = f ? Symbol.for("react.element") : 60103,
    Bt = f ? Symbol.for("react.portal") : 60106,
    Qt = f ? Symbol.for("react.fragment") : 60107,
    qt = f ? Symbol.for("react.strict_mode") : 60108,
    Ut = f ? Symbol.for("react.profiler") : 60114,
    Wt = f ? Symbol.for("react.provider") : 60109,
    zt = f ? Symbol.for("react.context") : 60110,
    Yt = f ? Symbol.for("react.async_mode") : 60111,
    Jt = f ? Symbol.for("react.concurrent_mode") : 60111,
    Zt = f ? Symbol.for("react.forward_ref") : 60112,
    Kt = f ? Symbol.for("react.suspense") : 60113,
    Gt = f ? Symbol.for("react.suspense_list") : 60120,
    Xt = f ? Symbol.for("react.memo") : 60115,
    en = f ? Symbol.for("react.lazy") : 60116,
    tn = f ? Symbol.for("react.block") : 60121,
    nn = f ? Symbol.for("react.fundamental") : 60117,
    rn = f ? Symbol.for("react.responder") : 60118,
    an = f ? Symbol.for("react.scope") : 60119;
  function w(e) {
    if ("object" == typeof e && null !== e) {
      var t = e.$$typeof;
      switch (t) {
        case $t:
          switch (e = e.type) {
            case Yt:
            case Jt:
            case Qt:
            case Ut:
            case qt:
            case Kt:
              return e;
            default:
              switch (e = e && e.$$typeof) {
                case zt:
                case Zt:
                case en:
                case Xt:
                case Wt:
                  return e;
                default:
                  return t;
              }
          }
        case Bt:
          return t;
      }
    }
  }
  function on(e) {
    return w(e) === Jt;
  }
  var sn = {
      AsyncMode: Yt,
      ConcurrentMode: Jt,
      ContextConsumer: zt,
      ContextProvider: Wt,
      Element: $t,
      ForwardRef: Zt,
      Fragment: Qt,
      Lazy: en,
      Memo: Xt,
      Portal: Bt,
      Profiler: Ut,
      StrictMode: qt,
      Suspense: Kt,
      isAsyncMode: function (e) {
        return on(e) || w(e) === Yt;
      },
      isConcurrentMode: on,
      isContextConsumer: function (e) {
        return w(e) === zt;
      },
      isContextProvider: function (e) {
        return w(e) === Wt;
      },
      isElement: function (e) {
        return "object" == typeof e && null !== e && e.$$typeof === $t;
      },
      isForwardRef: function (e) {
        return w(e) === Zt;
      },
      isFragment: function (e) {
        return w(e) === Qt;
      },
      isLazy: function (e) {
        return w(e) === en;
      },
      isMemo: function (e) {
        return w(e) === Xt;
      },
      isPortal: function (e) {
        return w(e) === Bt;
      },
      isProfiler: function (e) {
        return w(e) === Ut;
      },
      isStrictMode: function (e) {
        return w(e) === qt;
      },
      isSuspense: function (e) {
        return w(e) === Kt;
      },
      isValidElementType: function (e) {
        return "string" == typeof e || "function" == typeof e || e === Qt || e === Jt || e === Ut || e === qt || e === Kt || e === Gt || "object" == typeof e && null !== e && (e.$$typeof === en || e.$$typeof === Xt || e.$$typeof === Wt || e.$$typeof === zt || e.$$typeof === Zt || e.$$typeof === nn || e.$$typeof === rn || e.$$typeof === an || e.$$typeof === tn);
      },
      typeOf: w
    },
    a = Lt(function (e, t) {});
  a.AsyncMode, a.ConcurrentMode, a.ContextConsumer, a.ContextProvider, a.Element, a.ForwardRef, a.Fragment, a.Lazy, a.Memo, a.Portal, a.Profiler, a.StrictMode, a.Suspense, a.isAsyncMode, a.isConcurrentMode, a.isContextConsumer, a.isContextProvider, a.isElement, a.isForwardRef, a.isFragment, a.isLazy, a.isMemo, a.isPortal, a.isProfiler, a.isStrictMode, a.isSuspense, a.isValidElementType, a.typeOf, Lt(function (e) {
    e.exports = sn;
  });
  function cn(t, e) {
    var n,
      r = Object.keys(t);
    return Object.getOwnPropertySymbols && (n = Object.getOwnPropertySymbols(t), e && (n = n.filter(function (e) {
      return Object.getOwnPropertyDescriptor(t, e).enumerable;
    })), r.push.apply(r, n)), r;
  }
  function R(t) {
    for (var e = 1; e < arguments.length; e++) {
      var n = null != arguments[e] ? arguments[e] : {};
      e % 2 ? cn(Object(n), !0).forEach(function (e) {
        C(t, e, n[e]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : cn(Object(n)).forEach(function (e) {
        Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
      });
    }
    return t;
  }
  function O(e, t) {
    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
  }
  function un(e, t) {
    for (var n = 0; n < t.length; n++) {
      var r = t[n];
      r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, vn(r.key), r);
    }
  }
  function j(e, t, n) {
    t && un(e.prototype, t), n && un(e, n), Object.defineProperty(e, "prototype", {
      writable: !1
    });
  }
  function C(e, t, n) {
    return (t = vn(t)) in e ? Object.defineProperty(e, t, {
      value: n,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[t] = n, e;
  }
  function ln() {
    return (ln = Object.assign ? Object.assign.bind() : function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n,
          r = arguments[t];
        for (n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
      }
      return e;
    }).apply(this, arguments);
  }
  function E(e, t) {
    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
    e.prototype = Object.create(t && t.prototype, {
      constructor: {
        value: e,
        writable: !0,
        configurable: !0
      }
    }), Object.defineProperty(e, "prototype", {
      writable: !1
    }), t && mn(e, t);
  }
  function fn(e) {
    return (fn = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
      return e.__proto__ || Object.getPrototypeOf(e);
    })(e);
  }
  function mn(e, t) {
    return (mn = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
      return e.__proto__ = t, e;
    })(e, t);
  }
  function pn(e, t) {
    if (null == e) return {};
    var n,
      r = function (e, t) {
        if (null == e) return {};
        for (var n, r = {}, i = Object.keys(e), a = 0; a < i.length; a++) n = i[a], 0 <= t.indexOf(n) || (r[n] = e[n]);
        return r;
      }(e, t);
    if (Object.getOwnPropertySymbols) for (var i = Object.getOwnPropertySymbols(e), a = 0; a < i.length; a++) n = i[a], 0 <= t.indexOf(n) || Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
    return r;
  }
  function F(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
  }
  function N(n) {
    var r = function () {
      if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
      if (Reflect.construct.sham) return !1;
      if ("function" == typeof Proxy) return !0;
      try {
        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
      } catch (e) {
        return !1;
      }
    }();
    return function () {
      var e,
        t = fn(n),
        t = (e = r ? (e = fn(this).constructor, Reflect.construct(t, arguments, e)) : t.apply(this, arguments), this);
      if (e && ("object" == typeof e || "function" == typeof e)) return e;
      if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
      return F(t);
    };
  }
  function hn(e, t) {
    return function (e) {
      if (Array.isArray(e)) return e;
    }(e) || function (e, t) {
      var n = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
      if (null != n) {
        var r,
          i,
          a,
          o,
          s = [],
          c = !0,
          u = !1;
        try {
          if (a = (n = n.call(e)).next, 0 === t) {
            if (Object(n) !== n) return;
            c = !1;
          } else for (; !(c = (r = a.call(n)).done) && (s.push(r.value), s.length !== t); c = !0);
        } catch (e) {
          u = !0, i = e;
        } finally {
          try {
            if (!c && null != n.return && (o = n.return(), Object(o) !== o)) return;
          } finally {
            if (u) throw i;
          }
        }
        return s;
      }
    }(e, t) || yn(e, t) || function () {
      throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }();
  }
  function dn(e) {
    return function (e) {
      if (Array.isArray(e)) return gn(e);
    }(e) || function (e) {
      if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
    }(e) || yn(e) || function () {
      throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }();
  }
  function yn(e, t) {
    var n;
    if (e) return "string" == typeof e ? gn(e, t) : "Map" === (n = "Object" === (n = Object.prototype.toString.call(e).slice(8, -1)) && e.constructor ? e.constructor.name : n) || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? gn(e, t) : void 0;
  }
  function gn(e, t) {
    (null == t || t > e.length) && (t = e.length);
    for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
    return r;
  }
  function vn(e) {
    e = function (e, t) {
      if ("object" != typeof e || null === e) return e;
      var n = e[Symbol.toPrimitive];
      if (void 0 === n) return ("string" === t ? String : Number)(e);
      if ("object" != typeof (n = n.call(e, t || "default"))) return n;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }(e, "string");
    return "symbol" == typeof e ? e : String(e);
  }
  function bn() {}
  function xn() {}
  xn.resetWarningCache = bn;
  b = Lt(function (e) {
    function t(e, t, n, r, i, a) {
      if ("SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED" !== a) throw (a = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types")).name = "Invariant Violation", a;
    }
    function n() {
      return t;
    }
    e.exports = (e = {
      array: t.isRequired = t,
      bigint: t,
      bool: t,
      func: t,
      number: t,
      object: t,
      string: t,
      symbol: t,
      any: t,
      arrayOf: n,
      element: t,
      elementType: t,
      instanceOf: n,
      node: t,
      objectOf: n,
      oneOf: n,
      oneOfType: n,
      shape: n,
      exact: n,
      checkPropTypes: xn,
      resetWarningCache: bn
    }).PropTypes = e;
  });
  function Sn() {
    return null;
  }
  Sn.propTypes = {
    hit: b.object.isRequired,
    matchingPatterns: b.object.isRequired,
    transformSearchParameters: b.func
  };
  f = qe(Sn, {
    $$widgetType: "ais.configureRelatedItems"
  }), a = t({
    displayName: "AlgoliaDynamicWidgets",
    $$type: "ais.dynamicWidgets",
    defaultProps: {
      transformItems: function (e) {
        return e;
      },
      maxValuesPerFacet: 20
    },
    propTypes: {
      transformItems: b.func,
      facets: b.arrayOf(b.string),
      maxValuesPerFacet: b.number
    },
    getProvidedProps: function (e, t, n) {
      var r,
        n = d(n, {
          ais: e.contextValue,
          multiIndexContext: e.indexContextValue
        });
      if (!e.facets || Array.isArray(e.facets) && e.facets.length <= 1 && ("*" === e.facets[0] || void 0 === e.facets[0])) return n ? (r = n.renderingContent && n.renderingContent.facetOrdering && n.renderingContent.facetOrdering.facets && n.renderingContent.facetOrdering.facets.order || [], 20 < (r = e.transformItems(r, {
        results: n
      })).length && !e.facets && console.warn("More than ".concat(20, " facets are requested to be displayed without explicitly setting which facets to retrieve. This could have a performance impact. Set \"facets\" to [] to do two smaller network requests, or explicitly to ['*'] to avoid this warning.")), e.maxValuesPerFacet < n._state.maxValuesPerFacet && console.warn("The maxValuesPerFacet set by dynamic widgets (".concat(e.maxValuesPerFacet, ") is smaller than one of the limits set by a widget (").concat(n._state.maxValuesPerFacet, "). This causes a mismatch in query parameters and thus an extra network request when that widget is mounted.")), {
        attributesToRender: r
      }) : {
        attributesToRender: []
      };
      throw new Error('The `facets` prop only accepts [] or ["*"], you passed '.concat(JSON.stringify(e.facets)));
    },
    getSearchParameters: function (e, t) {
      return (t.facets || ["*"]).reduce(function (e, t) {
        return e.addFacet(t);
      }, e.setQueryParameters({
        maxValuesPerFacet: Math.max(t.maxValuesPerFacet || 0, e.maxValuesPerFacet || 0)
      }));
    }
  });
  function Pn(e) {
    return (Pn = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
      return typeof e;
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    })(e);
  }
  function wn(e) {
    var t;
    if ("object" === Pn(t = e) && t.props) return e.props.attribute || (Array.isArray(e.props.attributes) ? e.props.attributes[0] : e.props.children ? wn(P.Children.only(e.props.children)) : void 0);
  }
  var Rn = a(function (e) {
    var t = e.children,
      n = e.attributesToRender,
      r = void 0 === (e = e.fallbackComponent) ? function () {
        return null;
      } : e,
      i = new Map();
    return P.Children.forEach(t, function (e) {
      var t = wn(e);
      if (!t) throw new Error('Could not find "attribute" prop for '.concat(W(e), "."));
      i.set(t, e);
    }), P.createElement(P.Fragment, null, n.map(function (e) {
      return P.createElement(S.Fragment, {
        key: e
      }, i.get(e) || P.createElement(r, {
        attribute: e
      }));
    }));
  }, {
    $$widgetType: "ais.dynamicWidgets"
  });
  function On(e) {
    return function (e) {
      if (Array.isArray(e)) return jn(e);
    }(e) || function (e) {
      if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
    }(e) || function (e, t) {
      var n;
      if (e) return "string" == typeof e ? jn(e, t) : "Map" === (n = "Object" === (n = Object.prototype.toString.call(e).slice(8, -1)) && e.constructor ? e.constructor.name : n) || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? jn(e, t) : void 0;
    }(e) || function () {
      throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }();
  }
  function jn(e, t) {
    (null == t || t > e.length) && (t = e.length);
    for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
    return r;
  }
  function Cn(r, e) {
    var i = 1 < arguments.length && void 0 !== e ? e : {};
    return Object.keys(i).filter(function (e) {
      return void 0 !== i[e] && void 0 !== i[e][r];
    }).map(function (e) {
      var t = r,
        n = i[e];
      switch (e) {
        case "range":
          return Object.keys(n[t]).map(function (e) {
            return n[t][e];
          });
        case "refinementList":
          return n[t];
        case "hierarchicalMenu":
        case "menu":
          return [n[t]];
        case "multiRange":
          return n[t].split(":");
        case "toggle":
          return [n[t]];
        default:
          return [];
      }
    }).reduce(function (e, t) {
      return e.concat(t);
    }, []);
  }
  var En = t({
      displayName: "AlgoliaQueryRules",
      $$type: "ais.queryRules",
      defaultProps: {
        transformItems: function (e) {
          return e;
        },
        transformRuleContexts: function (e) {
          return e;
        },
        trackedFilters: {}
      },
      getProvidedProps: function (e, t, n) {
        var n = d(n, {
          ais: e.contextValue,
          multiIndexContext: e.indexContextValue
        });
        return null === n ? {
          items: [],
          canRefine: !1
        } : (n = n.userData, {
          items: e = (0, e.transformItems)(void 0 === n ? [] : n),
          canRefine: 0 < e.length
        });
      },
      getSearchParameters: function (e, t, n) {
        var i, a, r;
        return 0 === Object.keys(t.trackedFilters).length ? e : (n = _e({
          ais: t.contextValue,
          multiIndexContext: t.indexContextValue
        }) && n.indices ? n.indices[h({
          ais: t.contextValue,
          multiIndexContext: t.indexContextValue
        })] : n, n = {
          searchState: n,
          trackedFilters: t.trackedFilters
        }, i = n.searchState, a = n.trackedFilters, n = Object.keys(a).reduce(function (e, t) {
          var n = Cn(t, i),
            r = (0, a[t])(n);
          return [].concat(On(e), On(n.filter(function (e) {
            return r.includes(e);
          }).map(function (e) {
            return "ais-".concat(t, "-").concat(e).replace(/[^a-z0-9-_]+/gi, "_");
          })));
        }, []), r = e.ruleContexts || [], r = [].concat(On(r), On(n)), n = t.transformRuleContexts(r).slice(0, 10), e.setQueryParameter("ruleContexts", n));
      }
    }),
    Fn = En(function () {
      return null;
    }, {
      $$widgetType: "ais.queryRuleContext"
    });
  function Nn(e) {
    return (Nn = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
      return typeof e;
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    })(e);
  }
  function Vn() {
    return (Vn = Object.assign ? Object.assign.bind() : function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n,
          r = arguments[t];
        for (n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
      }
      return e;
    }).apply(this, arguments);
  }
  function In(e, t) {
    for (var n = 0; n < t.length; n++) {
      var r = t[n];
      r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, Dn(r.key), r);
    }
  }
  function _n(e, t) {
    return (_n = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
      return e.__proto__ = t, e;
    })(e, t);
  }
  function Tn(n) {
    var r = function () {
      if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
      if (Reflect.construct.sham) return !1;
      if ("function" == typeof Proxy) return !0;
      try {
        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
      } catch (e) {
        return !1;
      }
    }();
    return function () {
      var e,
        t = An(n),
        t = (e = r ? (e = An(this).constructor, Reflect.construct(t, arguments, e)) : t.apply(this, arguments), this);
      if (e && ("object" === Nn(e) || "function" == typeof e)) return e;
      if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
      return kn(t);
    };
  }
  function kn(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
  }
  function An(e) {
    return (An = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
      return e.__proto__ || Object.getPrototypeOf(e);
    })(e);
  }
  function Mn(e, t, n) {
    (t = Dn(t)) in e ? Object.defineProperty(e, t, {
      value: n,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[t] = n;
  }
  function Dn(e) {
    e = function (e, t) {
      if ("object" !== Nn(e) || null === e) return e;
      var n = e[Symbol.toPrimitive];
      if (void 0 === n) return ("string" === t ? String : Number)(e);
      n = n.call(e, t || "default");
      if ("object" !== Nn(n)) return n;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }(e, "string");
    return "symbol" === Nn(e) ? e : String(e);
  }
  function Hn(e) {
    return {
      targetedIndex: e.indexId
    };
  }
  var Ln = function (e) {
    var t = i;
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
      constructor: {
        value: t,
        writable: !0,
        configurable: !0
      }
    }), Object.defineProperty(t, "prototype", {
      writable: !1
    }), e && _n(t, e);
    var n,
      r = Tn(i);
    function i(e) {
      if (this instanceof i) return Mn(kn(e = r.call(this, e)), "state", {
        indexContext: Hn(e.props)
      }), Mn(kn(e), "unregisterWidget", void 0), e.props.contextValue.onSearchParameters(e.getSearchParameters.bind(kn(e)), {
        ais: e.props.contextValue,
        multiIndexContext: e.state.indexContext
      }, e.props, void 0, i.displayName), e;
      throw new TypeError("Cannot call a class as a function");
    }
    return t = i, e = [{
      key: "getDerivedStateFromProps",
      value: function (e) {
        return {
          indexContext: Hn(e)
        };
      }
    }], (n = [{
      key: "componentDidMount",
      value: function () {
        this.unregisterWidget = this.props.contextValue.widgetsManager.registerWidget(this);
      }
    }, {
      key: "componentDidUpdate",
      value: function (e) {
        this.props.indexName !== e.indexName && this.props.contextValue.widgetsManager.update();
      }
    }, {
      key: "componentWillUnmount",
      value: function () {
        "function" == typeof this.unregisterWidget && this.unregisterWidget();
      }
    }, {
      key: "getSearchParameters",
      value: function (e, t) {
        return e.setIndex((this.props || t).indexName);
      }
    }, {
      key: "render",
      value: function () {
        return 0 === S.Children.count(this.props.children) ? null : P.createElement(se, {
          value: this.state.indexContext
        }, this.props.children);
      }
    }]) && In(t.prototype, n), e && In(t, e), Object.defineProperty(t, "prototype", {
      writable: !1
    }), i;
  }(S.Component);
  Mn(Ln, "propTypes", {
    indexName: b.string.isRequired,
    indexId: b.string.isRequired,
    children: b.node
  }), Mn(Ln, "displayName", "AlgoliaIndex"), Mn(Ln, "$$type", "ais.index"), Mn(Ln, "$$widgetType", "ais.index");
  var $n = ["resultsFacetValues"],
    Bn = ["resultsFacetValues"],
    Qn = ["resultsFacetValues"];
  function qn(e) {
    return (qn = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
      return typeof e;
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    })(e);
  }
  function Un(e, t) {
    if (null == e) return {};
    var n,
      r = function (e, t) {
        if (null == e) return {};
        var n,
          r,
          i = {},
          a = Object.keys(e);
        for (r = 0; r < a.length; r++) n = a[r], 0 <= t.indexOf(n) || (i[n] = e[n]);
        return i;
      }(e, t);
    if (Object.getOwnPropertySymbols) for (var i = Object.getOwnPropertySymbols(e), a = 0; a < i.length; a++) n = i[a], 0 <= t.indexOf(n) || Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
    return r;
  }
  function Wn(t, e) {
    var n,
      r = Object.keys(t);
    return Object.getOwnPropertySymbols && (n = Object.getOwnPropertySymbols(t), e && (n = n.filter(function (e) {
      return Object.getOwnPropertyDescriptor(t, e).enumerable;
    })), r.push.apply(r, n)), r;
  }
  function V(t) {
    for (var e = 1; e < arguments.length; e++) {
      var n = null != arguments[e] ? arguments[e] : {};
      e % 2 ? Wn(Object(n), !0).forEach(function (e) {
        zn(t, e, n[e]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : Wn(Object(n)).forEach(function (e) {
        Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
      });
    }
    return t;
  }
  function zn(e, t, n) {
    return (t = function (e) {
      e = function (e, t) {
        if ("object" !== qn(e) || null === e) return e;
        var n = e[Symbol.toPrimitive];
        if (void 0 === n) return ("string" === t ? String : Number)(e);
        n = n.call(e, t || "default");
        if ("object" !== qn(n)) return n;
        throw new TypeError("@@toPrimitive must return a primitive value.");
      }(e, "string");
      return "symbol" === qn(e) ? e : String(e);
    }(t)) in e ? Object.defineProperty(e, t, {
      value: n,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[t] = n, e;
  }
  function Yn(e) {
    "function" == typeof e.addAlgoliaAgent && (e.addAlgoliaAgent("react (".concat(S.version, ")")), e.addAlgoliaAgent("react-instantsearch (".concat(Pe, ")")));
  }
  var Jn = function (e) {
      return _e({
        ais: e.props.contextValue,
        multiIndexContext: e.props.indexContextValue
      });
    },
    Zn = function (e, t) {
      return e.props.indexContextValue.targetedIndex === t;
    },
    Kn = function (e) {
      return Boolean(e.props.indexId);
    },
    Gn = function (e, t) {
      return e.props.indexId === t;
    },
    Xn = function (e, t) {
      e = Kn(e), t = Kn(t);
      return e && !t ? -1 : !e && t ? 1 : 0;
    };
  function er(n) {
    return Object.keys(n).map(function (e) {
      return function (e) {
        for (var t = arguments.length, n = new Array(1 < t ? t - 1 : 0), r = 1; r < t; r++) n[r - 1] = arguments[r];
        var i = 0;
        return e.replace(/%s/g, function () {
          return encodeURIComponent(n[i++]);
        });
      }("%s=%s", e, (t = n[e], "[object Object]" === Object.prototype.toString.call(t) || "[object Array]" === Object.prototype.toString.call(t) ? JSON.stringify(n[e]) : n[e]));
      var t;
    }).join("&");
  }
  function tr(e) {
    var i,
      t,
      n,
      r,
      a,
      o,
      s,
      c,
      u,
      l = e.indexName,
      f = e.initialState,
      f = void 0 === f ? {} : f,
      m = e.searchClient,
      p = e.resultsState,
      h = e.stalledSearchDelay,
      d = Nt(m, l, V({}, xe)),
      y = (Yn(m), d.on("search", function () {
        g = g || setTimeout(function () {
          var e = w.getState(),
            e = (e.resultsFacetValues, Un(e, Qn));
          w.setState(V(V({}, e), {}, {
            isSearchStalled: !0
          }));
        }, h);
      }).on("result", C({
        indexId: l
      })).on("error", E), !1),
      g = null,
      v = d.state,
      b = (t = function () {
        var e = R(w.getState().widgets);
        w.setState(V(V({}, w.getState()), {}, {
          metadata: e,
          searching: !0
        })), j();
      }, r = !(n = []), {
        registerWidget: function (e) {
          return n.push(e), x(), function () {
            n.splice(n.indexOf(e), 1), x();
          };
        },
        update: x,
        getWidgets: function () {
          return n;
        }
      });
    function x() {
      r || (r = !0, q(function () {
        r = !1, t();
      }));
    }
    a = m, (e = p) && (a.transporter && !a._cacheHydrated || a._useCache && "function" == typeof a.addAlgoliaAgent) && (a.transporter && !a._cacheHydrated && (a._cacheHydrated = !0, o = a.search, a.search = function (e) {
      for (var t = arguments.length, n = new Array(1 < t ? t - 1 : 0), r = 1; r < t; r++) n[r - 1] = arguments[r];
      var i = e.map(function (e) {
        return V(V({}, e), {}, {
          params: er(e.params)
        });
      });
      return a.transporter.responsesCache.get({
        method: "search",
        args: [i].concat(n)
      }, function () {
        return o.apply(void 0, [e].concat(n));
      });
    }), Array.isArray(e.results) ? (u = a, s = e.results, u.transporter ? u.transporter.responsesCache.set({
      method: "search",
      args: [s.reduce(function (e, t) {
        return e.concat(t.rawResults.map(function (e) {
          return {
            indexName: e.index,
            params: e.params
          };
        }));
      }, [])]
    }, {
      results: s.reduce(function (e, t) {
        return e.concat(t.rawResults);
      }, [])
    }) : (c = "/1/indexes/*/queries_body_".concat(JSON.stringify({
      requests: s.reduce(function (e, t) {
        return e.concat(t.rawResults.map(function (e) {
          return {
            indexName: e.index,
            params: e.params
          };
        }));
      }, [])
    })), u.cache = V(V({}, u.cache), {}, zn({}, c, JSON.stringify({
      results: s.reduce(function (e, t) {
        return e.concat(t.rawResults);
      }, [])
    }))))) : (u = e, (c = a).transporter ? c.transporter.responsesCache.set({
      method: "search",
      args: [u.rawResults.map(function (e) {
        return {
          indexName: e.index,
          params: e.params
        };
      })]
    }, {
      results: u.rawResults
    }) : (s = "/1/indexes/*/queries_body_".concat(JSON.stringify({
      requests: u.rawResults.map(function (e) {
        return {
          indexName: e.index,
          params: e.params
        };
      })
    })), c.cache = V(V({}, c.cache), {}, zn({}, s, JSON.stringify({
      results: u.rawResults
    }))))));
    e = {
      widgets: f,
      metadata: (m = p) ? m.metadata.map(function (e) {
        return V(V({
          value: function () {
            return {};
          }
        }, e), {}, {
          items: e.items && e.items.map(function (e) {
            return V(V({
              value: function () {
                return {};
              }
            }, e), {}, {
              items: e.items && e.items.map(function (e) {
                return V({
                  value: function () {
                    return {};
                  }
                }, e);
              })
            });
          })
        });
      }) : [],
      results: function (e) {
        if (!e) return null;
        if (Array.isArray(e.results)) return e.results.reduce(function (e, t) {
          return V(V({}, e), {}, zn({}, t._internalIndexId, new Nt.SearchResults(new Nt.SearchParameters(t.state), t.rawResults)));
        }, {});
        return new Nt.SearchResults(new Nt.SearchParameters(e.state), e.rawResults);
      }(p),
      error: null,
      searching: !1,
      isSearchStalled: !0,
      searchingForFacetValues: !1
    }, S = e, P = [];
    var S,
      P,
      w = {
        getState: function () {
          return S;
        },
        setState: function (e) {
          S = e, P.forEach(function (e) {
            return e();
          });
        },
        subscribe: function (e) {
          return P.push(e), function () {
            P.splice(P.indexOf(e), 1);
          };
        }
      };
    function R(t) {
      return b.getWidgets().filter(function (e) {
        return Boolean(e.getMetadata);
      }).map(function (e) {
        return e.getMetadata(t);
      });
    }
    function O() {
      var t = b.getWidgets().filter(function (e) {
          return Boolean(e.getSearchParameters);
        }).filter(function (e) {
          return !Jn(e) && !Kn(e);
        }).reduce(function (e, t) {
          return t.getSearchParameters(e);
        }, v),
        e = b.getWidgets().filter(function (e) {
          return Boolean(e.getSearchParameters);
        }).filter(function (e) {
          var t = Jn(e) && Zn(e, l),
            e = Kn(e) && Gn(e, l);
          return t || e;
        }).sort(Xn).reduce(function (e, t) {
          return t.getSearchParameters(e);
        }, t),
        n = b.getWidgets().filter(function (e) {
          return Boolean(e.getSearchParameters);
        }).filter(function (e) {
          var t = Jn(e) && !Zn(e, l),
            e = Kn(e) && !Gn(e, l);
          return t || e;
        }).sort(Xn).reduce(function (e, t) {
          var n = Jn(t) ? t.props.indexContextValue.targetedIndex : t.props.indexId,
            r = e[n] || [];
          return V(V({}, e), {}, zn({}, n, r.concat(t)));
        }, {});
      return {
        mainParameters: e,
        derivedParameters: Object.keys(n).map(function (e) {
          return {
            parameters: n[e].reduce(function (e, t) {
              return t.getSearchParameters(e);
            }, t),
            indexId: e
          };
        })
      };
    }
    function j() {
      var e, t;
      y || (e = (t = O()).mainParameters, t = t.derivedParameters, i = t.length + 1, d.derivedHelpers.slice().forEach(function (e) {
        e.detach();
      }), t.forEach(function (e) {
        var t = e.indexId,
          n = e.parameters;
        d.derive(function () {
          return n;
        }).on("result", C({
          indexId: t
        })).on("error", E);
      }), d.setState(e), d.search());
    }
    function C(e) {
      var r = e.indexId;
      return function (e) {
        i--;
        var t = w.getState(),
          n = !d.derivedHelpers.length,
          t = t.results || {},
          t = !n && t.getFacetByName ? {} : t,
          n = (t = n ? e.results : V(V({}, t), {}, zn({}, r, e.results)), w.getState()),
          e = n.isSearchStalled,
          n = (d.hasPendingRequests() || (clearTimeout(g), g = null, e = !1), n.resultsFacetValues, Un(n, $n));
        w.setState(V(V({}, n), {}, {
          results: t,
          isSearchStalled: e,
          searching: 0 < i,
          error: null
        }));
      };
    }
    function E(e) {
      var e = e.error,
        t = w.getState(),
        n = t.isSearchStalled,
        t = (d.hasPendingRequests() || (clearTimeout(g), n = !1), t.resultsFacetValues, Un(t, Bn));
      w.setState(V(V({}, t), {}, {
        isSearchStalled: n,
        error: e,
        searching: !1
      }));
    }
    return {
      store: w,
      widgetsManager: b,
      getWidgetsIds: function () {
        return w.getState().metadata.reduce(function (e, t) {
          return void 0 !== t.id ? e.concat(t.id) : e;
        }, []);
      },
      getSearchParameters: O,
      onSearchForFacetValues: function (e) {
        var n = e.facetName,
          r = e.query,
          e = e.maxFacetHits,
          e = Math.max(1, Math.min(void 0 === e ? 10 : e, 100));
        w.setState(V(V({}, w.getState()), {}, {
          searchingForFacetValues: !0
        })), d.searchForFacetValues(n, r, e).then(function (e) {
          var t;
          w.setState(V(V({}, w.getState()), {}, {
            error: null,
            searchingForFacetValues: !1,
            resultsFacetValues: V(V({}, w.getState().resultsFacetValues), {}, (zn(t = {}, n, e.facetHits), zn(t, "query", r), t))
          }));
        }, function (e) {
          w.setState(V(V({}, w.getState()), {}, {
            searchingForFacetValues: !1,
            error: e
          }));
        }).catch(function (e) {
          setTimeout(function () {
            throw e;
          });
        });
      },
      onExternalStateUpdate: function (e) {
        var t = R(e);
        w.setState(V(V({}, w.getState()), {}, {
          widgets: e,
          metadata: t,
          searching: !0
        })), j();
      },
      transitionState: function (e) {
        var n = w.getState().widgets;
        return b.getWidgets().filter(function (e) {
          return Boolean(e.transitionState);
        }).reduce(function (e, t) {
          return t.transitionState(n, e);
        }, e);
      },
      updateClient: function (e) {
        Yn(e), d.setClient(e), j();
      },
      updateIndex: function (e) {
        v = v.setIndex(e);
      },
      clearCache: function () {
        d.clearCache(), j();
      },
      skipSearch: function () {
        y = !0;
      }
    };
  }
  function nr(e) {
    return (nr = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
      return typeof e;
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    })(e);
  }
  function rr(e, t) {
    var a,
      n = document.createElement("meta"),
      r = document.querySelector("head"),
      t = (n.name = "algolia:metadata", t = t, a = ["contextValue", "indexContextValue"], e = (e = e).map(function (e) {
        var t = e.props,
          e = e.constructor,
          n = e._connectorDesc || {},
          r = n.defaultProps,
          i = void 0 === r ? {} : r,
          r = n.displayName;
        return {
          displayName: void 0 === r ? e.displayName : r,
          $$type: e.$$type,
          $$widgetType: e.$$widgetType,
          params: Object.keys(t).filter(function (e) {
            return !a.includes(e) && i[e] !== t[e] && void 0 !== t[e];
          })
        };
      }), {
        ua: t.transporter && t.transporter.userAgent ? t.transporter.userAgent.value : t._ua,
        widgets: e
      });
    n.content = JSON.stringify(t), r.appendChild(n);
  }
  function ir(e) {
    return (ir = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
      return typeof e;
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    })(e);
  }
  function ar(t, e) {
    var n,
      r = Object.keys(t);
    return Object.getOwnPropertySymbols && (n = Object.getOwnPropertySymbols(t), e && (n = n.filter(function (e) {
      return Object.getOwnPropertyDescriptor(t, e).enumerable;
    })), r.push.apply(r, n)), r;
  }
  function or(t) {
    for (var e = 1; e < arguments.length; e++) {
      var n = null != arguments[e] ? arguments[e] : {};
      e % 2 ? ar(Object(n), !0).forEach(function (e) {
        mr(t, e, n[e]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : ar(Object(n)).forEach(function (e) {
        Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
      });
    }
    return t;
  }
  function sr(e, t) {
    for (var n = 0; n < t.length; n++) {
      var r = t[n];
      r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, pr(r.key), r);
    }
  }
  function cr(e, t) {
    return (cr = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
      return e.__proto__ = t, e;
    })(e, t);
  }
  function ur(n) {
    var r = function () {
      if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
      if (Reflect.construct.sham) return !1;
      if ("function" == typeof Proxy) return !0;
      try {
        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
      } catch (e) {
        return !1;
      }
    }();
    return function () {
      var e,
        t = fr(n),
        t = (e = r ? (e = fr(this).constructor, Reflect.construct(t, arguments, e)) : t.apply(this, arguments), this);
      if (e && ("object" === ir(e) || "function" == typeof e)) return e;
      if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
      return lr(t);
    };
  }
  function lr(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
  }
  function fr(e) {
    return (fr = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
      return e.__proto__ || Object.getPrototypeOf(e);
    })(e);
  }
  function mr(e, t, n) {
    (t = pr(t)) in e ? Object.defineProperty(e, t, {
      value: n,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[t] = n;
  }
  function pr(e) {
    e = function (e, t) {
      if ("object" !== ir(e) || null === e) return e;
      var n = e[Symbol.toPrimitive];
      if (void 0 === n) return ("string" === t ? String : Number)(e);
      n = n.call(e, t || "default");
      if ("object" !== ir(n)) return n;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }(e, "string");
    return "symbol" === ir(e) ? e : String(e);
  }
  function hr(e) {
    return Boolean(e.searchState);
  }
  var dr = function (e) {
    var t = i;
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
      constructor: {
        value: t,
        writable: !0,
        configurable: !0
      }
    }), Object.defineProperty(t, "prototype", {
      writable: !1
    }), e && cr(t, e);
    var n,
      r = ur(i);
    function i(e) {
      if (!(this instanceof i)) throw new TypeError("Cannot call a class as a function");
      mr(lr(e = r.call(this, e)), "cleanupTimerRef", null), mr(lr(e), "isUnmounting", !1);
      var t = tr({
          indexName: e.props.indexName,
          searchClient: e.props.searchClient,
          initialState: e.props.searchState || {},
          resultsState: e.props.resultsState,
          stalledSearchDelay: e.props.stalledSearchDelay
        }),
        n = {
          store: t.store,
          widgetsManager: t.widgetsManager,
          mainTargetedIndex: e.props.indexName,
          onInternalStateUpdate: e.onWidgetsInternalStateUpdate.bind(lr(e)),
          createHrefForState: e.createHrefForState.bind(lr(e)),
          onSearchForFacetValues: e.onSearchForFacetValues.bind(lr(e)),
          onSearchStateChange: e.onSearchStateChange.bind(lr(e)),
          onSearchParameters: e.onSearchParameters.bind(lr(e))
        };
      return e.state = {
        isControlled: hr(e.props),
        instantSearchManager: t,
        contextValue: n
      }, e;
    }
    return t = i, e = [{
      key: "getDerivedStateFromProps",
      value: function (e, t) {
        var n = hr(e),
          r = t.instantSearchManager.store.getState().widgets,
          i = e.searchState;
        return n && !L(r, i) && t.instantSearchManager.onExternalStateUpdate(e.searchState), {
          isControlled: n,
          contextValue: or(or({}, t.contextValue), {}, {
            mainTargetedIndex: e.indexName
          })
        };
      }
    }], (n = [{
      key: "componentDidUpdate",
      value: function (e) {
        var t = hr(e);
        if (t && !this.state.isControlled) throw new Error("You can't switch <InstantSearch> from being controlled to uncontrolled");
        if (!t && this.state.isControlled) throw new Error("You can't switch <InstantSearch> from being uncontrolled to controlled");
        this.props.refresh !== e.refresh && this.props.refresh && this.state.instantSearchManager.clearCache(), e.indexName !== this.props.indexName && this.state.instantSearchManager.updateIndex(this.props.indexName), e.searchClient !== this.props.searchClient && this.state.instantSearchManager.updateClient(this.props.searchClient);
      }
    }, {
      key: "componentDidMount",
      value: function () {
        this.cleanupTimerRef && (clearTimeout(this.cleanupTimerRef), this.cleanupTimerRef = null), "object" === ("undefined" == typeof window ? "undefined" : nr(window)) && "object" === nr(window.navigator) && "string" == typeof window.navigator.userAgent && window.navigator.userAgent.includes("Algolia Crawler") && "object" === nr(window.document) && rr(this.state.instantSearchManager.widgetsManager.getWidgets(), this.props.searchClient);
      }
    }, {
      key: "componentWillUnmount",
      value: function () {
        var e = this;
        this.cleanupTimerRef = setTimeout(function () {
          e.isUnmounting = !0, e.state.instantSearchManager.skipSearch();
        });
      }
    }, {
      key: "createHrefForState",
      value: function (e) {
        return e = this.state.instantSearchManager.transitionState(e), this.state.isControlled && this.props.createURL ? this.props.createURL(e, this.getKnownKeys()) : "#";
      }
    }, {
      key: "onWidgetsInternalStateUpdate",
      value: function (e) {
        e = this.state.instantSearchManager.transitionState(e), this.onSearchStateChange(e), this.state.isControlled || this.state.instantSearchManager.onExternalStateUpdate(e);
      }
    }, {
      key: "onSearchStateChange",
      value: function (e) {
        this.props.onSearchStateChange && !this.isUnmounting && this.props.onSearchStateChange(e);
      }
    }, {
      key: "onSearchParameters",
      value: function (e, t, n, r, i) {
        var a;
        this.props.onSearchParameters && (a = this.props.searchState || {}, this.props.onSearchParameters(e, t, n, a)), this.props.widgetsCollector && (a = this.props.searchState || {}, this.props.widgetsCollector({
          getSearchParameters: e,
          getMetadata: r,
          context: t,
          props: n,
          searchState: a,
          displayName: i
        }));
      }
    }, {
      key: "onSearchForFacetValues",
      value: function (e) {
        this.state.instantSearchManager.onSearchForFacetValues(e);
      }
    }, {
      key: "getKnownKeys",
      value: function () {
        return this.state.instantSearchManager.getWidgetsIds();
      }
    }, {
      key: "render",
      value: function () {
        return 0 === S.Children.count(this.props.children) ? null : P.createElement(ie, {
          value: this.state.contextValue
        }, this.props.children);
      }
    }]) && sr(t.prototype, n), e && sr(t, e), Object.defineProperty(t, "prototype", {
      writable: !1
    }), i;
  }(S.Component);
  function yr(e) {
    return (yr = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
      return typeof e;
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    })(e);
  }
  function gr(e, t, n) {
    return (t = function (e) {
      e = function (e, t) {
        if ("object" !== yr(e) || null === e) return e;
        var n = e[Symbol.toPrimitive];
        if (void 0 === n) return ("string" === t ? String : Number)(e);
        n = n.call(e, t || "default");
        if ("object" !== yr(n)) return n;
        throw new TypeError("@@toPrimitive must return a primitive value.");
      }(e, "string");
      return "symbol" === yr(e) ? e : String(e);
    }(t)) in e ? Object.defineProperty(e, t, {
      value: n,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[t] = n, e;
  }
  function vr(e) {
    return function (e) {
      if (Array.isArray(e)) return br(e);
    }(e) || function (e) {
      if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
    }(e) || function (e, t) {
      var n;
      if (e) return "string" == typeof e ? br(e, t) : "Map" === (n = "Object" === (n = Object.prototype.toString.call(e).slice(8, -1)) && e.constructor ? e.constructor.name : n) || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? br(e, t) : void 0;
    }(e) || function () {
      throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }();
  }
  function br(e, t) {
    (null == t || t > e.length) && (t = e.length);
    for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
    return r;
  }
  mr(dr, "defaultProps", {
    stalledSearchDelay: 200,
    refresh: !1
  }), mr(dr, "propTypes", {
    indexName: b.string.isRequired,
    searchClient: b.shape({
      search: b.func.isRequired,
      searchForFacetValues: b.func,
      addAlgoliaAgent: b.func,
      clearCache: b.func
    }).isRequired,
    createURL: b.func,
    refresh: b.bool,
    searchState: b.object,
    onSearchStateChange: b.func,
    onSearchParameters: b.func,
    widgetsCollector: b.func,
    resultsState: b.oneOfType([b.object, b.array]),
    children: b.node,
    stalledSearchDelay: b.number
  });
  function xr() {
    return "query";
  }
  function Sr(e, t, n) {
    xr();
    e = u(e, t, n, "query", "");
    return e || "";
  }
  var Pr = t({
    displayName: "AlgoliaAutoComplete",
    $$type: "ais.autoComplete",
    getProvidedProps: function (e, t, n) {
      return {
        hits: (r = n).results ? r.results.hits && Array.isArray(r.results.hits) ? J(Z(r.results.hits, r.results.queryID), r.results.hitsPerPage, r.results.page) : Object.keys(r.results).reduce(function (e, t) {
          return [].concat(vr(e), [{
            index: t,
            hits: J(Z(r.results[t].hits, r.results[t].queryID), r.results[t].hitsPerPage, r.results[t].page)
          }]);
        }, []) : [],
        currentRefinement: Sr(e, t, {
          ais: e.contextValue,
          multiIndexContext: e.indexContextValue
        })
      };
      var r;
    },
    refine: function (e, t, n) {
      return e = {
        ais: e.contextValue,
        multiIndexContext: e.indexContextValue
      }, xr(), y(t, gr({}, "query", n), e, !0);
    },
    cleanUp: function (e, t) {
      return e = {
        ais: e.contextValue,
        multiIndexContext: e.indexContextValue
      }, r(t, e, xr());
    },
    getSearchParameters: function (e, t, n) {
      return e.setQuery(Sr(t, n, {
        ais: t.contextValue,
        multiIndexContext: t.indexContextValue
      }));
    }
  });
  function wr(e) {
    return (wr = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
      return typeof e;
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    })(e);
  }
  function Rr(e, t, n) {
    return (t = function (e) {
      e = function (e, t) {
        if ("object" !== wr(e) || null === e) return e;
        var n = e[Symbol.toPrimitive];
        if (void 0 === n) return ("string" === t ? String : Number)(e);
        n = n.call(e, t || "default");
        if ("object" !== wr(n)) return n;
        throw new TypeError("@@toPrimitive must return a primitive value.");
      }(e, "string");
      return "symbol" === wr(e) ? e : String(e);
    }(t)) in e ? Object.defineProperty(e, t, {
      value: n,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[t] = n, e;
  }
  function Or(e) {
    return e.attributes[0];
  }
  var jr = t({
    displayName: "AlgoliaBreadcrumb",
    $$type: "ais.breadcrumb",
    propTypes: {
      attributes: function (e, t, n) {
        if (!Array.isArray(e[t]) || e[t].some(function (e) {
          return "string" != typeof e;
        }) || e[t].length < 1) return new Error("Invalid prop ".concat(t, " supplied to ").concat(n, ". Expected an Array of Strings"));
      },
      transformItems: b.func
    },
    getProvidedProps: function (e, t, n) {
      var r = Or(e),
        n = d(n, {
          ais: e.contextValue,
          multiIndexContext: e.indexContextValue
        });
      return Boolean(n) && Boolean(n.getFacetByName(r)) ? (r = (n = n.getFacetValues(r)).data ? function n(e) {
        return e.reduce(function (e, t) {
          return e = t.isRefined && (e.push({
            label: t.name,
            value: t.escapedValue
          }), t.data) ? e.concat(n(t.data)) : e;
        }, []);
      }(n.data) : [], {
        canRefine: 0 < (n = e.transformItems ? e.transformItems(r) : r).length,
        items: n
      }) : {
        items: [],
        canRefine: !1
      };
    },
    refine: function (e, t, n) {
      return r = {
        ais: e.contextValue,
        multiIndexContext: e.indexContextValue
      }, y(t, Rr({}, Or(e), n || ""), r, !0, "hierarchicalMenu");
      var r;
    }
  });
  function Cr(e) {
    return (Cr = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
      return typeof e;
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    })(e);
  }
  function Er(t, e) {
    var n,
      r = Object.keys(t);
    return Object.getOwnPropertySymbols && (n = Object.getOwnPropertySymbols(t), e && (n = n.filter(function (e) {
      return Object.getOwnPropertyDescriptor(t, e).enumerable;
    })), r.push.apply(r, n)), r;
  }
  function Fr(r) {
    for (var e = 1; e < arguments.length; e++) {
      var i = null != arguments[e] ? arguments[e] : {};
      e % 2 ? Er(Object(i), !0).forEach(function (e) {
        var t, n;
        t = r, n = i[e = e], (e = function (e) {
          e = function (e, t) {
            if ("object" !== Cr(e) || null === e) return e;
            var n = e[Symbol.toPrimitive];
            if (void 0 === n) return ("string" === t ? String : Number)(e);
            n = n.call(e, t || "default");
            if ("object" !== Cr(n)) return n;
            throw new TypeError("@@toPrimitive must return a primitive value.");
          }(e, "string");
          return "symbol" === Cr(e) ? e : String(e);
        }(e)) in t ? Object.defineProperty(t, e, {
          value: n,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }) : t[e] = n;
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(r, Object.getOwnPropertyDescriptors(i)) : Er(Object(i)).forEach(function (e) {
        Object.defineProperty(r, e, Object.getOwnPropertyDescriptor(i, e));
      });
    }
    return r;
  }
  var Nr = t({
    displayName: "AlgoliaCurrentRefinements",
    $$type: "ais.currentRefinements",
    propTypes: {
      transformItems: b.func
    },
    getProvidedProps: function (n, e, t, r) {
      r = r.reduce(function (e, t) {
        return void 0 === t.items || !n.clearsQuery && "query" === t.id || n.clearsQuery && "query" === t.id && "" === t.items[0].currentRefinement ? e : e.concat(t.items.map(function (e) {
          return Fr(Fr({}, e), {}, {
            id: t.id,
            index: t.index
          });
        }));
      }, []), r = n.transformItems ? n.transformItems(r) : r;
      return {
        items: r,
        canRefine: 0 < r.length
      };
    },
    refine: function (e, t, n) {
      return (n instanceof Array ? n.map(function (e) {
        return e.value;
      }) : [n]).reduce(function (e, t) {
        return t(e);
      }, t);
    }
  });
  function Vr(e) {
    return (Vr = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
      return typeof e;
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    })(e);
  }
  var Ir = ["defaultRefinement"];
  function _r(e, t, n) {
    return (t = function (e) {
      e = function (e, t) {
        if ("object" !== Vr(e) || null === e) return e;
        var n = e[Symbol.toPrimitive];
        if (void 0 === n) return ("string" === t ? String : Number)(e);
        n = n.call(e, t || "default");
        if ("object" !== Vr(n)) return n;
        throw new TypeError("@@toPrimitive must return a primitive value.");
      }(e, "string");
      return "symbol" === Vr(e) ? e : String(e);
    }(t)) in e ? Object.defineProperty(e, t, {
      value: n,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[t] = n, e;
  }
  function Tr(e, t) {
    if (null == e) return {};
    var n,
      r = function (e, t) {
        if (null == e) return {};
        var n,
          r,
          i = {},
          a = Object.keys(e);
        for (r = 0; r < a.length; r++) n = a[r], 0 <= t.indexOf(n) || (i[n] = e[n]);
        return i;
      }(e, t);
    if (Object.getOwnPropertySymbols) for (var i = Object.getOwnPropertySymbols(e), a = 0; a < i.length; a++) n = i[a], 0 <= t.indexOf(n) || Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
    return r;
  }
  function kr() {
    return "boundingBox";
  }
  function Ar(e) {
    return [e.northEast.lat, e.northEast.lng, e.southWest.lat, e.southWest.lng].join();
  }
  function Mr(e) {
    return e = e.match(Lr), {
      lat: parseFloat(e[1]),
      lng: parseFloat(e[2])
    };
  }
  function Dr(e, t, n) {
    if (G(e = u(e, t, n, kr(), {}))) return {
      northEast: {
        lat: parseFloat(e.northEast.lat),
        lng: parseFloat(e.northEast.lng)
      },
      southWest: {
        lat: parseFloat(e.southWest.lat),
        lng: parseFloat(e.southWest.lng)
      }
    };
  }
  function Hr(e, t, n) {
    return y(e, _r({}, kr(), t), n, !0);
  }
  var Lr = /^(-?\d+(?:\.\d+)?),\s*(-?\d+(?:\.\d+)?)$/,
    $r = t({
      displayName: "AlgoliaGeoSearch",
      $$type: "ais.geoSearch",
      getProvidedProps: function (e, t, n) {
        var r = {
            ais: e.contextValue,
            multiIndexContext: e.indexContextValue
          },
          n = d(n, r),
          i = Dr(e, t, r),
          a = n && n._state.insideBoundingBox && function (e) {
            e = e.split(",");
            return {
              northEast: {
                lat: parseFloat(e[0]),
                lng: parseFloat(e[1])
              },
              southWest: {
                lat: parseFloat(e[2]),
                lng: parseFloat(e[3])
              }
            };
          }(n._state.insideBoundingBox) || void 0,
          e = (t = t, r = r, (e = e).defaultRefinement, e = Tr(e, Ir), (o = u(e, t, r, "aroundLatLng")) || (o = u(e, t, r, "configure.aroundLatLng")) && Mr(o)),
          t = n && n._state.aroundLatLng && Mr(n._state.aroundLatLng) || void 0,
          r = i || a,
          o = e || t;
        return {
          hits: n ? n.hits.filter(function (e) {
            return Boolean(e._geoloc);
          }) : [],
          isRefinedWithMap: Boolean(r),
          currentRefinement: r,
          position: o
        };
      },
      refine: function (e, t, n) {
        return Hr(t, n, {
          ais: e.contextValue,
          multiIndexContext: e.indexContextValue
        });
      },
      getSearchParameters: function (e, t, n) {
        n = Dr(t, n, {
          ais: t.contextValue,
          multiIndexContext: t.indexContextValue
        });
        return n ? e.setQueryParameter("insideBoundingBox", Ar(n)) : e;
      },
      cleanUp: function (e, t) {
        return r(t, {
          ais: e.contextValue,
          multiIndexContext: e.indexContextValue
        }, kr());
      },
      getMetadata: function (e, t) {
        var n = [],
          r = kr(),
          i = {
            ais: e.contextValue,
            multiIndexContext: e.indexContextValue
          },
          a = h(i),
          o = {},
          e = Dr(e, t, i);
        return e && n.push({
          label: "".concat(r, ": ").concat(Ar(e)),
          value: function (e) {
            return Hr(e, o, i);
          },
          currentRefinement: e
        }), {
          id: r,
          index: a,
          items: n
        };
      },
      shouldComponentUpdate: function () {
        return !0;
      }
    });
  function Br(e) {
    return (Br = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
      return typeof e;
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    })(e);
  }
  function Qr(t, e) {
    var n,
      r = Object.keys(t);
    return Object.getOwnPropertySymbols && (n = Object.getOwnPropertySymbols(t), e && (n = n.filter(function (e) {
      return Object.getOwnPropertyDescriptor(t, e).enumerable;
    })), r.push.apply(r, n)), r;
  }
  function qr(t) {
    for (var e = 1; e < arguments.length; e++) {
      var n = null != arguments[e] ? arguments[e] : {};
      e % 2 ? Qr(Object(n), !0).forEach(function (e) {
        Ur(t, e, n[e]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : Qr(Object(n)).forEach(function (e) {
        Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
      });
    }
    return t;
  }
  function Ur(e, t, n) {
    return (t = function (e) {
      e = function (e, t) {
        if ("object" !== Br(e) || null === e) return e;
        var n = e[Symbol.toPrimitive];
        if (void 0 === n) return ("string" === t ? String : Number)(e);
        n = n.call(e, t || "default");
        if ("object" !== Br(n)) return n;
        throw new TypeError("@@toPrimitive must return a primitive value.");
      }(e, "string");
      return "symbol" === Br(e) ? e : String(e);
    }(t)) in e ? Object.defineProperty(e, t, {
      value: n,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[t] = n, e;
  }
  function Wr(e) {
    return e.attributes[0];
  }
  var zr = "hierarchicalMenu";
  function Yr(e, t, n) {
    t = u(e, t, n, "".concat(zr, ".").concat(Wr(e)), null);
    return "" === t ? null : t;
  }
  function Jr(e, c, u, l) {
    return e.map(function (e) {
      return {
        label: e.name,
        value: (t = e.escapedValue, r = (n = c).id, i = c.attributes, a = c.separator, o = c.rootPath, s = c.showParentLevel, null === (n = Yr(c, u, l)) ? t : new Nt.SearchParameters({
          hierarchicalFacets: [{
            name: r,
            attributes: i,
            separator: a,
            rootPath: o,
            showParentLevel: s
          }]
        }).toggleHierarchicalFacetRefinement(r, n).toggleHierarchicalFacetRefinement(r, t).getHierarchicalRefinement(r)[0]),
        count: e.count,
        isRefined: e.isRefined,
        items: e.data && Jr(e.data, c, u, l)
      };
      var t, n, r, i, a, o, s;
    });
  }
  function Zr() {
    var e = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : [],
      t = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : 10;
    return e.slice(0, t).map(function () {
      var e = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : {};
      return Array.isArray(e.items) ? qr(qr({}, e), {}, {
        items: Zr(e.items, t)
      }) : e;
    });
  }
  function Kr(e, t, n, r) {
    return y(t, Ur({}, Wr(e), n || ""), r, !0, zr);
  }
  function Gr(e) {
    var t = e.attribute,
      n = e.hit,
      r = e.highlightProperty,
      i = void 0 === (i = e.preTag) ? xe.highlightPreTag : i,
      e = e.postTag,
      t = {
        attribute: t,
        highlightProperty: r,
        hit: n,
        preTag: i,
        postTag: void 0 === e ? xe.highlightPostTag : e
      },
      a = void 0 === (r = t.preTag) ? "<em>" : r,
      o = void 0 === (r = t.postTag) ? "</em>" : r,
      r = t.highlightProperty,
      n = t.attribute;
    if (t = t.hit) return t = ee(t[r], n) || {}, Array.isArray(t) ? t.map(function (e) {
      return Se({
        preTag: a,
        postTag: o,
        highlightedValue: e.value
      });
    }) : Se({
      preTag: a,
      postTag: o,
      highlightedValue: t.value
    });
    throw new Error("`hit`, the matching record, must be provided");
  }
  var Xr = ["name:asc"],
    ei = t({
      displayName: "AlgoliaHierarchicalMenu",
      $$type: "ais.hierarchicalMenu",
      propTypes: {
        attributes: function (e, t, n) {
          if (!Array.isArray(e[t]) || e[t].some(function (e) {
            return "string" != typeof e;
          }) || e[t].length < 1) return new Error("Invalid prop ".concat(t, " supplied to ").concat(n, ". Expected an Array of Strings"));
        },
        separator: b.string,
        rootPath: b.string,
        showParentLevel: b.bool,
        defaultRefinement: b.string,
        showMore: b.bool,
        limit: b.number,
        showMoreLimit: b.number,
        transformItems: b.func,
        facetOrdering: b.bool
      },
      defaultProps: {
        showMore: !1,
        limit: 10,
        showMoreLimit: 20,
        separator: " > ",
        rootPath: null,
        showParentLevel: !0,
        facetOrdering: !0
      },
      getProvidedProps: function (e, t, n) {
        var r = e.showMore,
          i = e.limit,
          a = e.showMoreLimit,
          o = e.facetOrdering,
          s = Wr(e),
          n = d(n, {
            ais: e.contextValue,
            multiIndexContext: e.indexContextValue
          });
        return Boolean(n) && Boolean(n.getFacetByName(s)) ? (r = r ? a : i, i = (a = n.getFacetValues(s, {
          sortBy: Xr,
          facetOrdering: o
        })).data ? Jr(a.data, e, t, {
          ais: e.contextValue,
          multiIndexContext: e.indexContextValue
        }) : [], n = e.transformItems ? e.transformItems(i) : i, {
          items: Zr(n, r),
          currentRefinement: Yr(e, t, {
            ais: e.contextValue,
            multiIndexContext: e.indexContextValue
          }),
          canRefine: 0 < n.length
        }) : {
          items: [],
          currentRefinement: Yr(e, t, {
            ais: e.contextValue,
            multiIndexContext: e.indexContextValue
          }),
          canRefine: !1
        };
      },
      refine: function (e, t, n) {
        return Kr(e, t, n, {
          ais: e.contextValue,
          multiIndexContext: e.indexContextValue
        });
      },
      cleanUp: function (e, t) {
        return e = {
          ais: (n = e).contextValue,
          multiIndexContext: e.indexContextValue
        }, r(t, e, "".concat(zr, ".").concat(Wr(n)));
        var n;
      },
      getSearchParameters: function (e, t, n) {
        var r = t.attributes,
          i = t.separator,
          a = t.rootPath,
          o = t.showParentLevel,
          s = t.showMore,
          c = t.limit,
          u = t.showMoreLimit,
          l = t.contextValue,
          f = Wr(t),
          s = s ? u : c,
          u = (e = e.addHierarchicalFacet({
            name: f,
            attributes: r,
            separator: i,
            rootPath: a,
            showParentLevel: o
          }).setQueryParameters({
            maxValuesPerFacet: Math.max(e.maxValuesPerFacet || 0, s)
          }), Yr(t, n, {
            ais: l,
            multiIndexContext: t.indexContextValue
          }));
        return e = null !== u ? e.toggleHierarchicalFacetRefinement(f, u) : e;
      },
      getMetadata: function (t, e) {
        var n = t.attributes[0],
          r = Wr(t),
          e = Yr(t, e, {
            ais: t.contextValue,
            multiIndexContext: t.indexContextValue
          }),
          n = e ? [{
            label: "".concat(n, ": ").concat(te(e)),
            attribute: n,
            value: function (e) {
              return Kr(t, e, "", {
                ais: t.contextValue,
                multiIndexContext: t.indexContextValue
              });
            },
            currentRefinement: e
          }] : [];
        return {
          id: r,
          index: h({
            ais: t.contextValue,
            multiIndexContext: t.indexContextValue
          }),
          items: n
        };
      }
    }),
    ti = t({
      displayName: "AlgoliaHighlighter",
      $$type: "ais.highlighter",
      propTypes: {},
      getProvidedProps: function () {
        return {
          highlight: Gr
        };
      }
    }),
    ni = t({
      displayName: "AlgoliaHits",
      $$type: "ais.hits",
      getProvidedProps: function (e, t, n) {
        n = d(n, {
          ais: e.contextValue,
          multiIndexContext: e.indexContextValue
        });
        return n ? {
          hits: Z(J(n.hits, n.hitsPerPage, n.page), n.queryID)
        } : {
          hits: []
        };
      },
      getSearchParameters: function (e) {
        return e;
      }
    });
  function ri(e) {
    return (ri = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
      return typeof e;
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    })(e);
  }
  function ii(t, e) {
    var n,
      r = Object.keys(t);
    return Object.getOwnPropertySymbols && (n = Object.getOwnPropertySymbols(t), e && (n = n.filter(function (e) {
      return Object.getOwnPropertyDescriptor(t, e).enumerable;
    })), r.push.apply(r, n)), r;
  }
  function ai(t) {
    for (var e = 1; e < arguments.length; e++) {
      var n = null != arguments[e] ? arguments[e] : {};
      e % 2 ? ii(Object(n), !0).forEach(function (e) {
        oi(t, e, n[e]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : ii(Object(n)).forEach(function (e) {
        Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
      });
    }
    return t;
  }
  function oi(e, t, n) {
    return (t = function (e) {
      e = function (e, t) {
        if ("object" !== ri(e) || null === e) return e;
        var n = e[Symbol.toPrimitive];
        if (void 0 === n) return ("string" === t ? String : Number)(e);
        n = n.call(e, t || "default");
        if ("object" !== ri(n)) return n;
        throw new TypeError("@@toPrimitive must return a primitive value.");
      }(e, "string");
      return "symbol" === ri(e) ? e : String(e);
    }(t)) in e ? Object.defineProperty(e, t, {
      value: n,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[t] = n, e;
  }
  function si() {
    return "hitsPerPage";
  }
  function ci(e, t, n) {
    e = u(e, t, n, "hitsPerPage", null);
    return "string" == typeof e ? parseInt(e, 10) : e;
  }
  var ui = t({
    displayName: "AlgoliaHitsPerPage",
    $$type: "ais.hitsPerPage",
    propTypes: {
      defaultRefinement: b.number.isRequired,
      items: b.arrayOf(b.shape({
        label: b.string,
        value: b.number.isRequired
      })).isRequired,
      transformItems: b.func
    },
    getProvidedProps: function (e, t) {
      var n = ci(e, t, {
          ais: e.contextValue,
          multiIndexContext: e.indexContextValue
        }),
        t = e.items.map(function (e) {
          return e.value === n ? ai(ai({}, e), {}, {
            isRefined: !0
          }) : ai(ai({}, e), {}, {
            isRefined: !1
          });
        });
      return {
        items: e.transformItems ? e.transformItems(t) : t,
        currentRefinement: n
      };
    },
    refine: function (e, t, n) {
      return y(t, oi({}, "hitsPerPage", n), {
        ais: e.contextValue,
        multiIndexContext: e.indexContextValue
      }, !0);
    },
    cleanUp: function (e, t) {
      return r(t, {
        ais: e.contextValue,
        multiIndexContext: e.indexContextValue
      }, si());
    },
    getSearchParameters: function (e, t, n) {
      return e.setHitsPerPage(ci(t, n, {
        ais: t.contextValue,
        multiIndexContext: t.indexContextValue
      }));
    },
    getMetadata: function () {
      return {
        id: si()
      };
    }
  });
  function li(e) {
    return (li = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
      return typeof e;
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    })(e);
  }
  var fi = ["page"];
  function mi(e, t, n) {
    return (t = function (e) {
      e = function (e, t) {
        if ("object" !== li(e) || null === e) return e;
        var n = e[Symbol.toPrimitive];
        if (void 0 === n) return ("string" === t ? String : Number)(e);
        n = n.call(e, t || "default");
        if ("object" !== li(n)) return n;
        throw new TypeError("@@toPrimitive must return a primitive value.");
      }(e, "string");
      return "symbol" === li(e) ? e : String(e);
    }(t)) in e ? Object.defineProperty(e, t, {
      value: n,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[t] = n, e;
  }
  function pi(e) {
    return function (e) {
      if (Array.isArray(e)) return hi(e);
    }(e) || function (e) {
      if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
    }(e) || function (e, t) {
      var n;
      if (e) return "string" == typeof e ? hi(e, t) : "Map" === (n = "Object" === (n = Object.prototype.toString.call(e).slice(8, -1)) && e.constructor ? e.constructor.name : n) || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? hi(e, t) : void 0;
    }(e) || function () {
      throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }();
  }
  function hi(e, t) {
    (null == t || t > e.length) && (t = e.length);
    for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
    return r;
  }
  function di(e, t) {
    if (null == e) return {};
    var n,
      r = function (e, t) {
        if (null == e) return {};
        var n,
          r,
          i = {},
          a = Object.keys(e);
        for (r = 0; r < a.length; r++) n = a[r], 0 <= t.indexOf(n) || (i[n] = e[n]);
        return i;
      }(e, t);
    if (Object.getOwnPropertySymbols) for (var i = Object.getOwnPropertySymbols(e), a = 0; a < i.length; a++) n = i[a], 0 <= t.indexOf(n) || Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
    return r;
  }
  function yi(e) {
    e = e || {};
    e.page;
    return di(e, fi);
  }
  var gi = t({
    displayName: "AlgoliaInfiniteHits",
    $$type: "ais.infiniteHits",
    getProvidedProps: function (e, t, n) {
      var r,
        i,
        a,
        o,
        s,
        c,
        u,
        l,
        f,
        m,
        p = this,
        n = d(n, {
          ais: e.contextValue,
          multiIndexContext: e.indexContextValue
        });
      return n ? (r = n.page, c = n.hits, f = n.hitsPerPage, i = n.nbPages, a = n._state, this._cache = e.cache || this._cache || (s = o = void 0, {
        read: function (e) {
          e = e.state;
          return L(s, yi(e)) ? o : null;
        },
        write: function (e) {
          var t = e.state,
            e = e.hits;
          s = yi(t), o = e;
        }
      }), e = this._cache.read({
        state: a
      }) || {}, c = Z(J(c, f, r), n.queryID), e[r] = c, this._cache.write({
        state: a,
        hits: e
      }), u = Math.min.apply(Math, pi(Object.keys(e).map(Number))), l = Math.max.apply(Math, pi(Object.keys(e).map(Number))), f = 0 < u, n = l < i - 1, {
        hits: (m = e, Object.keys(m).map(Number).sort(function (e, t) {
          return e - t;
        }).reduce(function (e, t) {
          return e.concat(m[t]);
        }, [])),
        hasPrevious: f,
        hasMore: n,
        refinePrevious: function (e) {
          return p.refine(e, u - 1);
        },
        refineNext: function (e) {
          return p.refine(e, l + 1);
        }
      }) : {
        hits: [],
        hasPrevious: !1,
        hasMore: !1,
        refine: function () {},
        refinePrevious: function () {},
        refineNext: function () {}
      };
    },
    getSearchParameters: function (e, t, n) {
      return e.setQueryParameters({
        page: (t = {
          ais: (e = t).contextValue,
          multiIndexContext: t.indexContextValue
        }, ("string" == typeof (e = u(e, n, t, "page", 1)) ? parseInt(e, 10) : e) - 1)
      });
    },
    refine: function (e, t, n, r) {
      return y(t, mi({}, "page", r + 1), {
        ais: e.contextValue,
        multiIndexContext: e.indexContextValue
      }, !1);
    }
  });
  function vi(e) {
    return (vi = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
      return typeof e;
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    })(e);
  }
  function bi(e, t, n) {
    return (t = function (e) {
      e = function (e, t) {
        if ("object" !== vi(e) || null === e) return e;
        var n = e[Symbol.toPrimitive];
        if (void 0 === n) return ("string" === t ? String : Number)(e);
        n = n.call(e, t || "default");
        if ("object" !== vi(n)) return n;
        throw new TypeError("@@toPrimitive must return a primitive value.");
      }(e, "string");
      return "symbol" === vi(e) ? e : String(e);
    }(t)) in e ? Object.defineProperty(e, t, {
      value: n,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[t] = n, e;
  }
  var xi = "menu";
  function Si(e) {
    return e.attribute;
  }
  function Pi(e, t, n) {
    t = u(e, t, n, "".concat(xi, ".").concat(Si(e)), null);
    return "" === t ? null : t;
  }
  function wi(e, t, n, r) {
    return e === Pi(t, n, r) ? "" : e;
  }
  function Ri(e) {
    var t = e.showMore,
      n = e.limit,
      e = e.showMoreLimit;
    return t ? e : n;
  }
  function Oi(e, t, n, r) {
    return y(t, bi({}, Si(e), n || ""), r, !0, xi);
  }
  var ji = ["count:desc", "name:asc"],
    Ci = t({
      displayName: "AlgoliaMenu",
      $$type: "ais.menu",
      propTypes: {
        attribute: b.string.isRequired,
        showMore: b.bool,
        limit: b.number,
        showMoreLimit: b.number,
        defaultRefinement: b.string,
        transformItems: b.func,
        searchable: b.bool,
        facetOrdering: b.bool
      },
      defaultProps: {
        showMore: !1,
        limit: 10,
        showMoreLimit: 20,
        facetOrdering: !0
      },
      getProvidedProps: function (t, n, e, r, i) {
        var a = t.attribute,
          o = t.searchable,
          s = t.indexContextValue,
          c = t.facetOrdering,
          e = d(e, {
            ais: t.contextValue,
            multiIndexContext: t.indexContextValue
          }),
          u = Boolean(e) && Boolean(e.getFacetByName(a)),
          l = Boolean(i && i[a] && "" !== i.query);
        if (o && s) throw new Error("react-instantsearch: searching in *List is not available when used inside a multi index context");
        return u ? (s = l ? i[a].map(function (e) {
          return {
            label: e.value,
            value: wi(e.escapedValue, t, n, {
              ais: t.contextValue,
              multiIndexContext: t.indexContextValue
            }),
            _highlightResult: {
              label: {
                value: e.highlighted
              }
            },
            count: e.count,
            isRefined: e.isRefined
          };
        }) : e.getFacetValues(a, {
          sortBy: o ? void 0 : ji,
          facetOrdering: c
        }).map(function (e) {
          return {
            label: e.name,
            value: wi(e.escapedValue, t, n, {
              ais: t.contextValue,
              multiIndexContext: t.indexContextValue
            }),
            count: e.count,
            isRefined: e.isRefined
          };
        }), {
          items: (i = t.transformItems ? t.transformItems(s) : s).slice(0, Ri(t)),
          currentRefinement: Pi(t, n, {
            ais: t.contextValue,
            multiIndexContext: t.indexContextValue
          }),
          isFromSearch: l,
          searchable: o,
          canRefine: 0 < i.length
        }) : {
          items: [],
          currentRefinement: Pi(t, n, {
            ais: t.contextValue,
            multiIndexContext: t.indexContextValue
          }),
          isFromSearch: l,
          searchable: o,
          canRefine: u
        };
      },
      refine: function (e, t, n) {
        return Oi(e, t, n, {
          ais: e.contextValue,
          multiIndexContext: e.indexContextValue
        });
      },
      searchForFacetValues: function (e, t, n) {
        return {
          facetName: e.attribute,
          query: n,
          maxFacetHits: Ri(e)
        };
      },
      cleanUp: function (e, t) {
        return e = {
          ais: (n = e).contextValue,
          multiIndexContext: e.indexContextValue
        }, r(t, e, "".concat(xi, ".").concat(Si(n)));
        var n;
      },
      getSearchParameters: function (e, t, n) {
        var r = t.attribute,
          n = (e = (e = e.setQueryParameters({
            maxValuesPerFacet: Math.max(e.maxValuesPerFacet || 0, Ri(t))
          })).addDisjunctiveFacet(r), Pi(t, n, {
            ais: t.contextValue,
            multiIndexContext: t.indexContextValue
          }));
        return e = null !== n ? e.addDisjunctiveFacetRefinement(r, n) : e;
      },
      getMetadata: function (t, e) {
        var n = Si(t),
          e = Pi(t, e, {
            ais: t.contextValue,
            multiIndexContext: t.indexContextValue
          });
        return {
          id: n,
          index: h({
            ais: t.contextValue,
            multiIndexContext: t.indexContextValue
          }),
          items: null === e ? [] : [{
            label: "".concat(t.attribute, ": ").concat(te(e)),
            attribute: t.attribute,
            value: function (e) {
              return Oi(t, e, "", {
                ais: t.contextValue,
                multiIndexContext: t.indexContextValue
              });
            },
            currentRefinement: e
          }]
        };
      }
    });
  function Ei(e) {
    return (Ei = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
      return typeof e;
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    })(e);
  }
  function Fi(e, t, n) {
    return (t = function (e) {
      e = function (e, t) {
        if ("object" !== Ei(e) || null === e) return e;
        var n = e[Symbol.toPrimitive];
        if (void 0 === n) return ("string" === t ? String : Number)(e);
        n = n.call(e, t || "default");
        if ("object" !== Ei(n)) return n;
        throw new TypeError("@@toPrimitive must return a primitive value.");
      }(e, "string");
      return "symbol" === Ei(e) ? e : String(e);
    }(t)) in e ? Object.defineProperty(e, t, {
      value: n,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[t] = n, e;
  }
  function Ni(e, t) {
    return function (e) {
      if (Array.isArray(e)) return e;
    }(e) || function (e, t) {
      var n = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
      if (null != n) {
        var r,
          i,
          a,
          o,
          s = [],
          c = !0,
          u = !1;
        try {
          if (a = (n = n.call(e)).next, 0 === t) {
            if (Object(n) !== n) return;
            c = !1;
          } else for (; !(c = (r = a.call(n)).done) && (s.push(r.value), s.length !== t); c = !0);
        } catch (e) {
          u = !0, i = e;
        } finally {
          try {
            if (!c && null != n.return && (o = n.return(), Object(o) !== o)) return;
          } finally {
            if (u) throw i;
          }
        }
        return s;
      }
    }(e, t) || function (e, t) {
      var n;
      if (e) return "string" == typeof e ? Vi(e, t) : "Map" === (n = "Object" === (n = Object.prototype.toString.call(e).slice(8, -1)) && e.constructor ? e.constructor.name : n) || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? Vi(e, t) : void 0;
    }(e, t) || function () {
      throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }();
  }
  function Vi(e, t) {
    (null == t || t > e.length) && (t = e.length);
    for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
    return r;
  }
  function Ii(e) {
    var t;
    return void 0 === e.start && void 0 === e.end ? "" : (t = void 0 !== e.start ? e.start : "", e = void 0 !== e.end ? e.end : "", "".concat(t, ":").concat(e));
  }
  var _i = "multiRange";
  function Ti(e) {
    return e.attribute;
  }
  function ki(e, t, n) {
    return u(e, t, n, "".concat(_i, ".").concat(Ti(e)), "");
  }
  function Ai(e, t, n, r) {
    return y(t, Fi({}, Ti(e), n), r, !0, _i);
  }
  var Mi = t({
    displayName: "AlgoliaNumericMenu",
    $$type: "ais.numericMenu",
    propTypes: {
      id: b.string,
      attribute: b.string.isRequired,
      items: b.arrayOf(b.shape({
        label: b.node,
        start: b.number,
        end: b.number
      })).isRequired,
      transformItems: b.func
    },
    getProvidedProps: function (o, e, t) {
      var n = o.attribute,
        s = ki(o, e, {
          ais: o.contextValue,
          multiIndexContext: o.indexContextValue
        }),
        c = d(t, {
          ais: o.contextValue,
          multiIndexContext: o.indexContextValue
        }),
        e = o.items.map(function (e) {
          var t,
            n,
            r,
            i,
            a = Ii(e);
          return {
            label: e.label,
            value: a,
            isRefined: a === s,
            noRefinement: !(!c || (e = Ti(o), a = a, t = (t = c).getFacetByName(e) ? t.getFacetStats(e) : null, e = a.split(":"), i = 0 === Number(e[0]) || "" === a ? Number.NEGATIVE_INFINITY : Number(e[0]), a = 0 === Number(e[1]) || "" === a ? Number.POSITIVE_INFINITY : Number(e[1]), Boolean(t) && (e = i, r = a, (n = t).min >= e && n.min <= r || n.max >= e && n.max <= r || (e = a, (n = i) >= (r = t).min && n <= r.max) || e >= r.min && e <= r.max)))
          };
        }),
        t = c && c.getFacetByName(n) ? c.getFacetStats(n) : null,
        n = K(e, function (e) {
          return !0 === e.isRefined;
        }),
        n = (e.some(function (e) {
          return "" === e.value;
        }) || e.push({
          value: "",
          isRefined: void 0 === n,
          noRefinement: !t,
          label: "All"
        }), o.transformItems ? o.transformItems(e) : e);
      return {
        items: n,
        currentRefinement: s,
        canRefine: 0 < n.length && n.some(function (e) {
          return !1 === e.noRefinement;
        })
      };
    },
    refine: function (e, t, n) {
      return Ai(e, t, n, {
        ais: e.contextValue,
        multiIndexContext: e.indexContextValue
      });
    },
    cleanUp: function (e, t) {
      return e = {
        ais: (n = e).contextValue,
        multiIndexContext: e.indexContextValue
      }, r(t, e, "".concat(_i, ".").concat(Ti(n)));
      var n;
    },
    getSearchParameters: function (e, t, n) {
      var r = t.attribute,
        t = 0 === (n = ki(t, n, {
          ais: t.contextValue,
          multiIndexContext: t.indexContextValue
        })).length ? {
          start: null,
          end: null
        } : (t = (n = Ni(n.split(":"), 2))[0], n = n[1], {
          start: 0 < t.length ? parseFloat(t) : null,
          end: 0 < n.length ? parseFloat(n) : null
        }),
        n = t.start,
        t = t.end;
      return e = e.addDisjunctiveFacet(r), "number" == typeof n && (e = e.addNumericRefinement(r, ">=", n)), e = "number" == typeof t ? e.addNumericRefinement(r, "<=", t) : e;
    },
    getMetadata: function (t, e) {
      var n,
        r = Ti(t),
        i = ki(t, e, {
          ais: t.contextValue,
          multiIndexContext: t.indexContextValue
        }),
        e = [],
        a = h({
          ais: t.contextValue,
          multiIndexContext: t.indexContextValue
        });
      return "" !== i && (n = K(t.items, function (e) {
        return Ii(e) === i;
      }).label, e.push({
        label: "".concat(t.attribute, ": ").concat(n),
        attribute: t.attribute,
        currentRefinement: n,
        value: function (e) {
          return Ai(t, e, "", {
            ais: t.contextValue,
            multiIndexContext: t.indexContextValue
          });
        }
      })), {
        id: r,
        index: a,
        items: e
      };
    }
  });
  function Di(e) {
    return (Di = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
      return typeof e;
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    })(e);
  }
  function Hi(e, t, n) {
    return (t = function (e) {
      e = function (e, t) {
        if ("object" !== Di(e) || null === e) return e;
        var n = e[Symbol.toPrimitive];
        if (void 0 === n) return ("string" === t ? String : Number)(e);
        n = n.call(e, t || "default");
        if ("object" !== Di(n)) return n;
        throw new TypeError("@@toPrimitive must return a primitive value.");
      }(e, "string");
      return "symbol" === Di(e) ? e : String(e);
    }(t)) in e ? Object.defineProperty(e, t, {
      value: n,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[t] = n, e;
  }
  function Li() {
    return "page";
  }
  function $i(e, t, n) {
    e = u(e, t, n, "page", 1);
    return "string" == typeof e ? parseInt(e, 10) : e;
  }
  var Bi = t({
      displayName: "AlgoliaPagination",
      $$type: "ais.pagination",
      getProvidedProps: function (e, t, n) {
        var n = d(n, {
          ais: e.contextValue,
          multiIndexContext: e.indexContextValue
        });
        return n ? {
          nbPages: n = n.nbPages,
          currentRefinement: $i(e, t, {
            ais: e.contextValue,
            multiIndexContext: e.indexContextValue
          }),
          canRefine: 1 < n
        } : null;
      },
      refine: function (e, t, n) {
        return e = {
          ais: e.contextValue,
          multiIndexContext: e.indexContextValue
        }, y(t, Hi({}, "page", n), e, !1);
      },
      cleanUp: function (e, t) {
        return r(t, {
          ais: e.contextValue,
          multiIndexContext: e.indexContextValue
        }, Li());
      },
      getSearchParameters: function (e, t, n) {
        return e.setPage($i(t, n, {
          ais: t.contextValue,
          multiIndexContext: t.indexContextValue
        }) - 1);
      },
      getMetadata: function () {
        return {
          id: Li()
        };
      }
    }),
    Qi = t({
      displayName: "AlgoliaPoweredBy",
      $$type: "ais.poweredBy",
      getProvidedProps: function () {
        var e = "undefined" == typeof window || void 0 === window.location ? "" : window.location.hostname;
        return {
          url: "https://www.algolia.com/?utm_source=react-instantsearch&utm_medium=website&" + "utm_content=".concat(e, "&") + "utm_campaign=poweredby"
        };
      }
    });
  function qi(e) {
    return (qi = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
      return typeof e;
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    })(e);
  }
  function Ui(e, t, n) {
    return (t = function (e) {
      e = function (e, t) {
        if ("object" !== qi(e) || null === e) return e;
        var n = e[Symbol.toPrimitive];
        if (void 0 === n) return ("string" === t ? String : Number)(e);
        n = n.call(e, t || "default");
        if ("object" !== qi(n)) return n;
        throw new TypeError("@@toPrimitive must return a primitive value.");
      }(e, "string");
      return "symbol" === qi(e) ? e : String(e);
    }(t)) in e ? Object.defineProperty(e, t, {
      value: n,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[t] = n, e;
  }
  function Wi(e) {
    return e.attribute;
  }
  var zi = "range";
  function Yi(e, t, n, r) {
    var t = u(e, t, r, "".concat(zi, ".").concat(Wi(e)), {}),
      r = t.min,
      t = t.max,
      i = Boolean(e.precision),
      r = {
        min: r = "string" == typeof r ? i ? parseFloat(r) : parseInt(r, 10) : r,
        max: t = "string" == typeof t ? i ? parseFloat(t) : parseInt(t, 10) : t
      },
      i = void 0 !== e.min,
      t = void 0 !== e.max,
      e = void 0 !== r.min,
      a = void 0 !== r.max;
    if (i && e && r.min < n.min) throw Error("You can't provide min value lower than range.");
    if (t && a && r.max > n.max) throw Error("You can't provide max value greater than range.");
    return i && !e && (r.min = n.min), t && !a && (r.max = n.max), r;
  }
  function Ji(e, t) {
    return {
      min: (void 0 !== e.min ? e : t).min,
      max: (void 0 !== e.max ? e : t).max
    };
  }
  function Zi(e, t, n, r) {
    e = e || n !== r ? e && t ? n : r : void 0;
    return e;
  }
  function Ki(e, t, n, r, i) {
    var a = n.min,
      n = n.max,
      o = r.min,
      r = r.max,
      s = void 0 === a || "" === a,
      c = void 0 === n || "" === n,
      a = s ? void 0 : parseFloat(a),
      n = c ? void 0 : parseFloat(n),
      u = s || isFinite(a),
      l = c || isFinite(n);
    if (!u || !l) throw Error("You can't provide non finite values to the range connector.");
    if (a < o) throw Error("You can't provide min value lower than range.");
    if (r < n) throw Error("You can't provide max value greater than range.");
    return y(t, Ui({}, Wi(e), {
      min: Zi(void 0 !== e.min, s, o, a),
      max: Zi(void 0 !== e.max, c, r, n)
    }), i, !0, zi);
  }
  var Gi = t({
    displayName: "AlgoliaRange",
    $$type: "ais.range",
    propTypes: {
      id: b.string,
      attribute: b.string.isRequired,
      defaultRefinement: b.shape({
        min: b.number,
        max: b.number
      }),
      min: b.number,
      max: b.number,
      precision: b.number,
      header: b.node,
      footer: b.node
    },
    defaultProps: {
      precision: 0
    },
    getProvidedProps: function (e, t, n) {
      var r = e.attribute,
        i = e.precision,
        a = e.min,
        o = e.max,
        n = d(n, {
          ais: e.contextValue,
          multiIndexContext: e.indexContextValue
        }),
        s = n && n.getFacetByName(r),
        c = s && n.getFacetStats(r) || {},
        s = (s ? n.getFacetValues(r) : []).map(function (e) {
          return {
            value: e.name,
            count: e.count
          };
        }),
        c = (n = {
          min: a,
          max: o
        }, r = c, a = i, a = Math.pow(10, a), o = "number" == typeof n.min && isFinite(n.min) ? n.min : "number" == typeof r.min && isFinite(r.min) ? r.min : void 0, n = "number" == typeof n.max && isFinite(n.max) ? n.max : "number" == typeof r.max && isFinite(r.max) ? r.max : void 0, {
          min: void 0 !== o ? Math.floor(o * a) / a : o,
          max: void 0 !== n ? Math.ceil(n * a) / a : n
        }),
        r = c.min,
        o = c.max,
        a = (this._currentRange = {
          min: r,
          max: o
        }, Yi(e, t, this._currentRange, {
          ais: e.contextValue,
          multiIndexContext: e.indexContextValue
        }));
      return {
        min: r,
        max: o,
        canRefine: 0 < s.length,
        currentRefinement: Ji(a, this._currentRange),
        count: s,
        precision: i
      };
    },
    refine: function (e, t, n) {
      return Ki(e, t, n, this._currentRange, {
        ais: e.contextValue,
        multiIndexContext: e.indexContextValue
      });
    },
    cleanUp: function (e, t) {
      return e = {
        ais: (n = e).contextValue,
        multiIndexContext: e.indexContextValue
      }, r(t, e, "".concat(zi, ".").concat(Wi(n)));
      var n;
    },
    getSearchParameters: function (e, t, n) {
      var r = t.attribute,
        n = Yi(t, n, this._currentRange, {
          ais: t.contextValue,
          multiIndexContext: t.indexContextValue
        }),
        t = n.min,
        n = n.max;
      return e = e.addDisjunctiveFacet(r), void 0 !== t && (e = e.addNumericRefinement(r, ">=", t)), e = void 0 !== n ? e.addNumericRefinement(r, "<=", n) : e;
    },
    getMetadata: function (t, e) {
      var n = this,
        r = this._currentRange,
        i = r.min,
        r = r.max,
        e = Yi(t, e, this._currentRange, {
          ais: t.contextValue,
          multiIndexContext: t.indexContextValue
        }),
        a = e.min,
        e = e.max,
        o = [],
        s = void 0 !== a,
        c = void 0 !== e;
      return (s && a !== i || c && e !== r) && (s = [s ? "".concat(a, " <= ") : "", t.attribute, c ? " <= ".concat(e) : ""], o.push({
        label: s.join(""),
        attribute: t.attribute,
        value: function (e) {
          return Ki(t, e, {}, n._currentRange, {
            ais: t.contextValue,
            multiIndexContext: t.indexContextValue
          });
        },
        currentRefinement: Ji({
          min: a,
          max: e
        }, {
          min: i,
          max: r
        })
      })), {
        id: Wi(t),
        index: h({
          ais: t.contextValue,
          multiIndexContext: t.indexContextValue
        }),
        items: o
      };
    }
  });
  function Xi(e) {
    return (Xi = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
      return typeof e;
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    })(e);
  }
  function ea(e, t, n) {
    return (t = function (e) {
      e = function (e, t) {
        if ("object" !== Xi(e) || null === e) return e;
        var n = e[Symbol.toPrimitive];
        if (void 0 === n) return ("string" === t ? String : Number)(e);
        n = n.call(e, t || "default");
        if ("object" !== Xi(n)) return n;
        throw new TypeError("@@toPrimitive must return a primitive value.");
      }(e, "string");
      return "symbol" === Xi(e) ? e : String(e);
    }(t)) in e ? Object.defineProperty(e, t, {
      value: n,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[t] = n, e;
  }
  var ta = "refinementList";
  function na(e) {
    return e.attribute;
  }
  function ra(e, t, n) {
    t = u(e, t, n, "".concat(ta, ".").concat(na(e)), []);
    return "string" != typeof t ? t : t ? [t] : [];
  }
  function ia(t, e, n, r) {
    e = ra(e, n, r);
    return -1 === e.indexOf(t) ? e.concat([t]) : e.filter(function (e) {
      return e !== t;
    });
  }
  function aa(e) {
    var t = e.showMore,
      n = e.limit,
      e = e.showMoreLimit;
    return t ? e : n;
  }
  function oa(e, t, n, r) {
    return y(t, ea({}, na(e), 0 < n.length ? n : ""), r, !0, ta);
  }
  var sa = ["isRefined", "count:desc", "name:asc"],
    ca = t({
      displayName: "AlgoliaRefinementList",
      $$type: "ais.refinementList",
      propTypes: {
        id: b.string,
        attribute: b.string.isRequired,
        operator: b.oneOf(["and", "or"]),
        showMore: b.bool,
        limit: b.number,
        showMoreLimit: b.number,
        defaultRefinement: b.arrayOf(b.oneOfType([b.string, b.number])),
        searchable: b.bool,
        transformItems: b.func,
        facetOrdering: b.bool
      },
      defaultProps: {
        operator: "or",
        showMore: !1,
        limit: 10,
        showMoreLimit: 20,
        facetOrdering: !0
      },
      getProvidedProps: function (t, n, e, r, i) {
        var a = t.attribute,
          o = t.searchable,
          s = t.indexContextValue,
          c = t.facetOrdering,
          e = d(e, {
            ais: t.contextValue,
            multiIndexContext: t.indexContextValue
          }),
          u = Boolean(e) && Boolean(e.getFacetByName(a)),
          l = Boolean(i && i[a] && "" !== i.query);
        if (o && s) throw new Error("react-instantsearch: searching in *List is not available when used inside a multi index context");
        return u ? (s = l ? i[a].map(function (e) {
          return {
            label: e.value,
            value: ia(e.escapedValue, t, n, {
              ais: t.contextValue,
              multiIndexContext: t.indexContextValue
            }),
            _highlightResult: {
              label: {
                value: e.highlighted
              }
            },
            count: e.count,
            isRefined: e.isRefined
          };
        }) : e.getFacetValues(a, {
          sortBy: sa,
          facetOrdering: c
        }).map(function (e) {
          return {
            label: e.name,
            value: ia(e.escapedValue, t, n, {
              ais: t.contextValue,
              multiIndexContext: t.indexContextValue
            }),
            count: e.count,
            isRefined: e.isRefined
          };
        }), {
          items: (i = t.transformItems ? t.transformItems(s) : s).slice(0, aa(t)),
          currentRefinement: ra(t, n, {
            ais: t.contextValue,
            multiIndexContext: t.indexContextValue
          }),
          isFromSearch: l,
          searchable: o,
          canRefine: 0 < i.length
        }) : {
          items: [],
          currentRefinement: ra(t, n, {
            ais: t.contextValue,
            multiIndexContext: t.indexContextValue
          }),
          canRefine: u,
          isFromSearch: l,
          searchable: o
        };
      },
      refine: function (e, t, n) {
        return oa(e, t, n, {
          ais: e.contextValue,
          multiIndexContext: e.indexContextValue
        });
      },
      searchForFacetValues: function (e, t, n) {
        return {
          facetName: e.attribute,
          query: n,
          maxFacetHits: aa(e)
        };
      },
      cleanUp: function (e, t) {
        return e = {
          ais: (n = e).contextValue,
          multiIndexContext: e.indexContextValue
        }, r(t, e, "".concat(ta, ".").concat(na(n)));
        var n;
      },
      getSearchParameters: function (e, t, n) {
        var r = t.attribute,
          i = "and" === t.operator ? "addFacet" : "addDisjunctiveFacet",
          a = "".concat(i, "Refinement");
        return e = (e = e.setQueryParameters({
          maxValuesPerFacet: Math.max(e.maxValuesPerFacet || 0, aa(t))
        }))[i](r), ra(t, n, {
          ais: t.contextValue,
          multiIndexContext: t.indexContextValue
        }).reduce(function (e, t) {
          return e[a](r, t);
        }, e);
      },
      getMetadata: function (n, r) {
        var e = na(n),
          i = {
            ais: n.contextValue,
            multiIndexContext: n.indexContextValue
          };
        return {
          id: e,
          index: h(i),
          items: 0 < ra(n, r, i).length ? [{
            attribute: n.attribute,
            label: "".concat(n.attribute, ": "),
            currentRefinement: ra(n, r, i),
            value: function (e) {
              return oa(n, e, [], i);
            },
            items: ra(n, r, i).map(function (t) {
              return {
                label: te("".concat(t)),
                value: function (e) {
                  e = ra(n, e, i).filter(function (e) {
                    return e !== t;
                  });
                  return oa(n, r, e, i);
                }
              };
            })
          }] : []
        };
      }
    }),
    ua = t({
      displayName: "AlgoliaScrollTo",
      $$type: "ais.scrollTo",
      propTypes: {
        scrollOn: b.string
      },
      defaultProps: {
        scrollOn: "page"
      },
      getProvidedProps: function (e, t) {
        var n = e.scrollOn,
          r = u(e, t, {
            ais: e.contextValue,
            multiIndexContext: e.indexContextValue
          }, n, null),
          e = (this._prevSearchState || (this._prevSearchState = {}), X(t = _e({
            ais: e.contextValue,
            multiIndexContext: e.indexContextValue
          }) ? t.indices ? t.indices[h({
            ais: e.contextValue,
            multiIndexContext: e.indexContextValue
          })] : {} : t, ["configure", n])),
          t = U(this._prevSearchState, e);
        return this._prevSearchState = e, {
          value: r,
          hasNotChanged: t
        };
      }
    });
  function la(e) {
    return (la = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
      return typeof e;
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    })(e);
  }
  function fa(e, t, n) {
    return (t = function (e) {
      e = function (e, t) {
        if ("object" !== la(e) || null === e) return e;
        var n = e[Symbol.toPrimitive];
        if (void 0 === n) return ("string" === t ? String : Number)(e);
        n = n.call(e, t || "default");
        if ("object" !== la(n)) return n;
        throw new TypeError("@@toPrimitive must return a primitive value.");
      }(e, "string");
      return "symbol" === la(e) ? e : String(e);
    }(t)) in e ? Object.defineProperty(e, t, {
      value: n,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[t] = n, e;
  }
  function ma() {
    return "query";
  }
  function pa(e, t, n) {
    e = u(e, t, n, "query", "");
    return e || "";
  }
  function ha(e, t, n, r) {
    return y(t, fa({}, "query", n), r, !0);
  }
  var da = t({
    displayName: "AlgoliaSearchBox",
    $$type: "ais.searchBox",
    propTypes: {
      defaultRefinement: b.string
    },
    getProvidedProps: function (e, t, n) {
      return {
        currentRefinement: pa(e, t, {
          ais: e.contextValue,
          multiIndexContext: e.indexContextValue
        }),
        isSearchStalled: n.isSearchStalled
      };
    },
    refine: function (e, t, n) {
      return ha(0, t, n, {
        ais: e.contextValue,
        multiIndexContext: e.indexContextValue
      });
    },
    cleanUp: function (e, t) {
      return e = {
        ais: e.contextValue,
        multiIndexContext: e.indexContextValue
      }, r(t, e, ma());
    },
    getSearchParameters: function (e, t, n) {
      return e.setQuery(pa(t, n, {
        ais: t.contextValue,
        multiIndexContext: t.indexContextValue
      }));
    },
    getMetadata: function (t, e) {
      e = pa(t, e, {
        ais: t.contextValue,
        multiIndexContext: t.indexContextValue
      });
      return {
        id: "query",
        index: h({
          ais: t.contextValue,
          multiIndexContext: t.indexContextValue
        }),
        items: null === e ? [] : [{
          label: "".concat("query", ": ").concat(e),
          value: function (e) {
            return ha(0, e, "", {
              ais: t.contextValue,
              multiIndexContext: t.indexContextValue
            });
          },
          currentRefinement: e
        }]
      };
    }
  });
  function ya(e) {
    return (ya = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
      return typeof e;
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    })(e);
  }
  function ga(e, t, n) {
    return (t = function (e) {
      e = function (e, t) {
        if ("object" !== ya(e) || null === e) return e;
        var n = e[Symbol.toPrimitive];
        if (void 0 === n) return ("string" === t ? String : Number)(e);
        n = n.call(e, t || "default");
        if ("object" !== ya(n)) return n;
        throw new TypeError("@@toPrimitive must return a primitive value.");
      }(e, "string");
      return "symbol" === ya(e) ? e : String(e);
    }(t)) in e ? Object.defineProperty(e, t, {
      value: n,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[t] = n, e;
  }
  function va() {
    return "relevancyStrictness";
  }
  var ba = t({
    displayName: "AlgoliaRelevantSort",
    $$type: "ais.relevantSort",
    getProvidedProps: function (e, t, n) {
      n = d(n, {
        ais: e.contextValue,
        multiIndexContext: e.indexContextValue
      });
      return n ? {
        isVirtualReplica: void 0 !== n.appliedRelevancyStrictness,
        isRelevantSorted: void 0 !== n.appliedRelevancyStrictness && 0 < n.appliedRelevancyStrictness
      } : {
        isVirtualReplica: !1,
        isRelevantSorted: !1
      };
    },
    getSearchParameters: function (e, t, n) {
      return e.setQueryParameter("relevancyStrictness", (e = {
        ais: t.contextValue,
        multiIndexContext: t.indexContextValue
      }, u(t, n, e, "relevancyStrictness")));
    },
    refine: function (e, t, n) {
      return y(t, ga({}, va(), n), {
        ais: e.contextValue,
        multiIndexContext: e.indexContextValue
      }, !0);
    }
  });
  function xa(e) {
    return (xa = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
      return typeof e;
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    })(e);
  }
  function Sa(t, e) {
    var n,
      r = Object.keys(t);
    return Object.getOwnPropertySymbols && (n = Object.getOwnPropertySymbols(t), e && (n = n.filter(function (e) {
      return Object.getOwnPropertyDescriptor(t, e).enumerable;
    })), r.push.apply(r, n)), r;
  }
  function Pa(t) {
    for (var e = 1; e < arguments.length; e++) {
      var n = null != arguments[e] ? arguments[e] : {};
      e % 2 ? Sa(Object(n), !0).forEach(function (e) {
        wa(t, e, n[e]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : Sa(Object(n)).forEach(function (e) {
        Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
      });
    }
    return t;
  }
  function wa(e, t, n) {
    return (t = function (e) {
      e = function (e, t) {
        if ("object" !== xa(e) || null === e) return e;
        var n = e[Symbol.toPrimitive];
        if (void 0 === n) return ("string" === t ? String : Number)(e);
        n = n.call(e, t || "default");
        if ("object" !== xa(n)) return n;
        throw new TypeError("@@toPrimitive must return a primitive value.");
      }(e, "string");
      return "symbol" === xa(e) ? e : String(e);
    }(t)) in e ? Object.defineProperty(e, t, {
      value: n,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[t] = n, e;
  }
  function Ra() {
    return "sortBy";
  }
  function Oa(e, t, n) {
    e = u(e, t, n, "sortBy", null);
    return e || null;
  }
  var ja = t({
      displayName: "AlgoliaSortBy",
      $$type: "ais.sortBy",
      propTypes: {
        defaultRefinement: b.string,
        items: b.arrayOf(b.shape({
          label: b.string,
          value: b.string.isRequired
        })).isRequired,
        transformItems: b.func
      },
      getProvidedProps: function (e, t) {
        var n = Oa(e, t, {
            ais: e.contextValue,
            multiIndexContext: e.indexContextValue
          }),
          t = e.items.map(function (e) {
            return e.value === n ? Pa(Pa({}, e), {}, {
              isRefined: !0
            }) : Pa(Pa({}, e), {}, {
              isRefined: !1
            });
          });
        return {
          items: e.transformItems ? e.transformItems(t) : t,
          currentRefinement: n
        };
      },
      refine: function (e, t, n) {
        return y(t, wa({}, "sortBy", n), {
          ais: e.contextValue,
          multiIndexContext: e.indexContextValue
        }, !0);
      },
      cleanUp: function (e, t) {
        return r(t, {
          ais: e.contextValue,
          multiIndexContext: e.indexContextValue
        }, Ra());
      },
      getSearchParameters: function (e, t, n) {
        n = Oa(t, n, {
          ais: t.contextValue,
          multiIndexContext: t.indexContextValue
        });
        return e.setIndex(n);
      },
      getMetadata: function () {
        return {
          id: Ra()
        };
      }
    }),
    Ca = t({
      displayName: "AlgoliaStateResults",
      $$type: "ais.stateResults",
      getProvidedProps: function (e, t, n) {
        return {
          searchState: t,
          searchResults: d(n, {
            ais: e.contextValue,
            multiIndexContext: e.indexContextValue
          }),
          allSearchResults: n.results,
          searching: n.searching,
          isSearchStalled: n.isSearchStalled,
          error: n.error,
          searchingForFacetValues: n.searchingForFacetValues,
          props: e
        };
      }
    }),
    Ea = t({
      displayName: "AlgoliaStats",
      $$type: "ais.stats",
      getProvidedProps: function (e, t, n) {
        n = d(n, {
          ais: e.contextValue,
          multiIndexContext: e.indexContextValue
        });
        return n ? {
          areHitsSorted: void 0 !== n.appliedRelevancyStrictness && 0 < n.appliedRelevancyStrictness && n.nbHits !== n.nbSortedHits,
          nbHits: n.nbHits,
          nbSortedHits: n.nbSortedHits,
          processingTimeMS: n.processingTimeMS
        } : null;
      }
    });
  function Fa(e) {
    return (Fa = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
      return typeof e;
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    })(e);
  }
  function Na(e, t, n) {
    return (t = function (e) {
      e = function (e, t) {
        if ("object" !== Fa(e) || null === e) return e;
        var n = e[Symbol.toPrimitive];
        if (void 0 === n) return ("string" === t ? String : Number)(e);
        n = n.call(e, t || "default");
        if ("object" !== Fa(n)) return n;
        throw new TypeError("@@toPrimitive must return a primitive value.");
      }(e, "string");
      return "symbol" === Fa(e) ? e : String(e);
    }(t)) in e ? Object.defineProperty(e, t, {
      value: n,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[t] = n, e;
  }
  function Va(e) {
    return e.attribute;
  }
  var Ia = "toggle",
    _a = ["0", "false", "null", "undefined"];
  function Ta(e, t, n) {
    t = u(e, t, n, "".concat(Ia, ".").concat(Va(e)), !1);
    return -1 === _a.indexOf(t) && Boolean(t);
  }
  function ka(e, t, n, r) {
    return y(t, Na({}, Va(e), n || !1), r, !0, Ia);
  }
  var Aa = t({
    displayName: "AlgoliaToggle",
    $$type: "ais.toggle",
    propTypes: {
      label: b.string.isRequired,
      attribute: b.string.isRequired,
      value: b.any.isRequired,
      filter: b.func,
      defaultRefinement: b.bool
    },
    getProvidedProps: function (e, t, n) {
      var r = e.attribute,
        i = e.value,
        n = d(n, {
          ais: e.contextValue,
          multiIndexContext: e.indexContextValue
        }),
        t = Ta(e, t, {
          ais: e.contextValue,
          multiIndexContext: e.indexContextValue
        }),
        e = n && n.getFacetByName(r) ? n.getFacetValues(r) : null,
        n = e && e.length ? K(e, function (e) {
          return e.name === i.toString();
        }) : null,
        r = n && n.count,
        n = e && e.length ? e.reduce(function (e, t) {
          return e + t.count;
        }, 0) : null;
      return {
        currentRefinement: t,
        canRefine: t ? null !== n && 0 < n : null !== r && 0 < r,
        count: {
          checked: n,
          unchecked: r
        }
      };
    },
    refine: function (e, t, n) {
      return ka(e, t, n, {
        ais: e.contextValue,
        multiIndexContext: e.indexContextValue
      });
    },
    cleanUp: function (e, t) {
      return e = {
        ais: (n = e).contextValue,
        multiIndexContext: e.indexContextValue
      }, r(t, e, "".concat(Ia, ".").concat(Va(n)));
      var n;
    },
    getSearchParameters: function (e, t, n) {
      var r = t.attribute,
        i = t.value,
        a = t.filter,
        n = Ta(t, n, {
          ais: t.contextValue,
          multiIndexContext: t.indexContextValue
        }),
        t = e.addDisjunctiveFacet(r);
      return t = n && (t = t.addDisjunctiveFacetRefinement(r, i), a) ? a(t) : t;
    },
    getMetadata: function (t, e) {
      var n = Va(t),
        e = Ta(t, e, {
          ais: t.contextValue,
          multiIndexContext: t.indexContextValue
        }),
        r = [],
        i = h({
          ais: t.contextValue,
          multiIndexContext: t.indexContextValue
        });
      return e && r.push({
        label: t.label,
        currentRefinement: e,
        attribute: t.attribute,
        value: function (e) {
          return ka(t, e, !1, {
            ais: t.contextValue,
            multiIndexContext: t.indexContextValue
          });
        }
      }), {
        id: n,
        index: i,
        items: r
      };
    }
  });
  function Ma(e) {
    return (Ma = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
      return typeof e;
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    })(e);
  }
  function Da(t, e) {
    var n,
      r = Object.keys(t);
    return Object.getOwnPropertySymbols && (n = Object.getOwnPropertySymbols(t), e && (n = n.filter(function (e) {
      return Object.getOwnPropertyDescriptor(t, e).enumerable;
    })), r.push.apply(r, n)), r;
  }
  function Ha(r) {
    for (var e = 1; e < arguments.length; e++) {
      var i = null != arguments[e] ? arguments[e] : {};
      e % 2 ? Da(Object(i), !0).forEach(function (e) {
        var t, n;
        t = r, n = i[e = e], (e = function (e) {
          e = function (e, t) {
            if ("object" !== Ma(e) || null === e) return e;
            var n = e[Symbol.toPrimitive];
            if (void 0 === n) return ("string" === t ? String : Number)(e);
            n = n.call(e, t || "default");
            if ("object" !== Ma(n)) return n;
            throw new TypeError("@@toPrimitive must return a primitive value.");
          }(e, "string");
          return "symbol" === Ma(e) ? e : String(e);
        }(e)) in t ? Object.defineProperty(t, e, {
          value: n,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }) : t[e] = n;
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(r, Object.getOwnPropertyDescriptors(i)) : Da(Object(i)).forEach(function (e) {
        Object.defineProperty(r, e, Object.getOwnPropertyDescriptor(i, e));
      });
    }
    return r;
  }
  function La(r, i, a) {
    return function (e, t) {
      if ("function" != typeof r) throw new TypeError("Expected insightsClient to be a Function");
      var n = function (e) {
        var t = e.method,
          n = e.results,
          r = e.currentHit,
          i = n.index,
          a = r.__queryID,
          o = [r.objectID];
        if (!a) throw new Error("Could not infer `queryID`. Ensure `clickAnalytics: true` was added with the Configure widget.\nSee: https://alg.li/VpPpLt");
        switch (t) {
          case "clickedObjectIDsAfterSearch":
            return {
              index: i,
              queryID: a,
              objectIDs: o,
              positions: [r.__position]
            };
          case "convertedObjectIDsAfterSearch":
            return {
              index: i,
              queryID: a,
              objectIDs: o
            };
          default:
            throw new Error('Unsupported method "'.concat(t, '" passed to the insights function. The supported methods are: "clickedObjectIDsAfterSearch", "convertedObjectIDsAfterSearch".'));
        }
      }({
        method: e,
        results: i,
        currentHit: a
      });
      r(e, Ha(Ha({}, n), t));
    };
  }
  function $a(e) {
    return ($a = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
      return typeof e;
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    })(e);
  }
  function Ba(t, e) {
    var n,
      r = Object.keys(t);
    return Object.getOwnPropertySymbols && (n = Object.getOwnPropertySymbols(t), e && (n = n.filter(function (e) {
      return Object.getOwnPropertyDescriptor(t, e).enumerable;
    })), r.push.apply(r, n)), r;
  }
  function Qa(t) {
    for (var e = 1; e < arguments.length; e++) {
      var n = null != arguments[e] ? arguments[e] : {};
      e % 2 ? Ba(Object(n), !0).forEach(function (e) {
        qa(t, e, n[e]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : Ba(Object(n)).forEach(function (e) {
        Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
      });
    }
    return t;
  }
  function qa(e, t, n) {
    (t = function (e) {
      e = function (e, t) {
        if ("object" !== $a(e) || null === e) return e;
        var n = e[Symbol.toPrimitive];
        if (void 0 === n) return ("string" === t ? String : Number)(e);
        n = n.call(e, t || "default");
        if ("object" !== $a(n)) return n;
        throw new TypeError("@@toPrimitive must return a primitive value.");
      }(e, "string");
      return "symbol" === $a(e) ? e : String(e);
    }(t)) in e ? Object.defineProperty(e, t, {
      value: n,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[t] = n;
  }
  function Ua() {
    return "query";
  }
  function Wa() {
    return "additionalVoiceParameters";
  }
  function za(e, t, n) {
    e = u(e, t, n, "query", "");
    return e || "";
  }
  function Ya(e, t, n, r) {
    var i,
      a = e.language ? {
        queryLanguages: [e.language.split("-")[0]]
      } : {},
      e = "function" == typeof e.additionalQueryParameters ? Qa({
        ignorePlurals: !0,
        removeStopWords: !0,
        optionalWords: n
      }, e.additionalQueryParameters({
        query: n
      })) : {};
    qa(i = {}, "query", n), qa(i, "additionalVoiceParameters", Qa(Qa({}, a), e));
    return y(t, i, r, !0);
  }
  var b = t({
      displayName: "AlgoliaVoiceSearch",
      $$type: "ais.voiceSearch",
      propTypes: {
        defaultRefinement: b.string
      },
      getProvidedProps: function (e, t, n) {
        return {
          currentRefinement: za(e, t, {
            ais: e.contextValue,
            multiIndexContext: e.indexContextValue
          }),
          isSearchStalled: n.isSearchStalled
        };
      },
      refine: function (e, t, n) {
        return Ya(e, t, n, {
          ais: e.contextValue,
          multiIndexContext: e.indexContextValue
        });
      },
      cleanUp: function (e, t) {
        return n = t, e = {
          ais: e.contextValue,
          multiIndexContext: e.indexContextValue
        }, n = r(t, e, Ua()), r(n, e, Wa());
        var n;
      },
      getSearchParameters: function (e, t, n) {
        var r,
          i = za(t, n, {
            ais: t.contextValue,
            multiIndexContext: t.indexContextValue
          }),
          n = (t = {
            ais: (r = t).contextValue,
            multiIndexContext: t.indexContextValue
          }, (r = u(r, n, t, "additionalVoiceParameters", "")) || {});
        return e.setQuery(i).setQueryParameters(n);
      },
      getMetadata: function (t, e) {
        e = za(t, e, {
          ais: t.contextValue,
          multiIndexContext: t.indexContextValue
        });
        return {
          id: "query",
          index: h({
            ais: t.contextValue,
            multiIndexContext: t.indexContextValue
          }),
          items: null === e ? [] : [{
            label: "".concat("query", ": ").concat(e),
            value: function (e) {
              return Ya(t, e, "", {
                ais: t.contextValue,
                multiIndexContext: t.indexContextValue
              });
            },
            currentRefinement: e
          }]
        };
      }
    }),
    Ja = a;
  function Za() {}
  function Ka() {}
  Ka.resetWarningCache = Za;
  function I(i) {
    var a = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : "ais";
    return function () {
      for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++) t[n] = arguments[n];
      var r = t.filter(function (e) {
        return e || "" === e;
      }).map(function (e) {
        var t = "".concat(a, "-").concat(i);
        return e ? "".concat(t, "-").concat(e) : t;
      });
      return T(r);
    };
  }
  var _ = Lt(function (e) {
      function t(e, t, n, r, i, a) {
        if ("SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED" !== a) throw (a = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types")).name = "Invariant Violation", a;
      }
      function n() {
        return t;
      }
      e.exports = (e = {
        array: t.isRequired = t,
        bigint: t,
        bool: t,
        func: t,
        number: t,
        object: t,
        string: t,
        symbol: t,
        any: t,
        arrayOf: n,
        element: t,
        elementType: t,
        instanceOf: n,
        node: t,
        objectOf: n,
        oneOf: n,
        oneOfType: n,
        shape: n,
        exact: n,
        checkPropTypes: Ka,
        resetWarningCache: Za
      }).PropTypes = e;
    }),
    T = Lt(function (e) {
      function o() {
        for (var e = [], t = 0; t < arguments.length; t++) {
          var n = arguments[t];
          if (n) {
            var r,
              i = typeof n;
            if ("string" == i || "number" == i) e.push(n);else if (Array.isArray(n)) n.length && (r = o.apply(null, n)) && e.push(r);else if ("object" == i) if (n.toString === Object.prototype.toString) for (var a in n) s.call(n, a) && n[a] && e.push(a);else e.push(n.toString());
          }
        }
        return e.join(" ");
      }
      var s;
      s = {}.hasOwnProperty, e.exports ? e.exports = o.default = o : window.classNames = o;
    });
  function Ga(e) {
    var t = e.start,
      n = void 0 === t ? 0 : t,
      t = e.end,
      e = e.step,
      e = void 0 === e ? 1 : e,
      r = 0 === e ? 1 : e,
      e = Math.round((t - n) / r);
    return dn(Array(e)).map(function (e, t) {
      return (n + t) * r;
    });
  }
  function Xa(e, t) {
    if (Array.isArray(e)) for (var n = 0; n < e.length; n++) if (t(e[n])) return e[n];
  }
  function k(e) {
    var t = e.canRefine,
      n = e.children;
    return P.createElement(oo, null, function (e) {
      return P.createElement(co, {
        setCanRefine: e,
        canRefine: t
      }, n);
    });
  }
  function eo(e) {
    var t = e.items,
      n = e.canRefine,
      r = e.refine,
      i = e.translate,
      e = e.className;
    return P.createElement("div", {
      className: T(go("", !n && "-noRefinement"), e)
    }, P.createElement("ul", {
      className: go("list", !n && "list--noRefinement")
    }, t.map(function (e) {
      return P.createElement("li", {
        key: e.label,
        className: go("item")
      }, P.createElement("span", {
        className: go("label")
      }, e.label), e.items ? e.items.map(function (e) {
        return P.createElement("span", {
          key: e.label,
          className: go("category")
        }, P.createElement("span", {
          className: go("categoryLabel")
        }, e.label), P.createElement("button", {
          className: go("delete"),
          onClick: function () {
            return r(e.value);
          }
        }, i("clearFilter", e)));
      }) : P.createElement("span", {
        className: go("category")
      }, P.createElement("button", {
        className: go("delete"),
        onClick: function () {
          return r(e.value);
        }
      }, i("clearFilter", e))));
    })));
  }
  function to(e) {
    var t = e.cx,
      n = e.value,
      r = e.highlightedTagName,
      i = e.isHighlighted,
      e = e.nonHighlightedTagName;
    return P.createElement(i ? r : e, {
      className: t(i ? "highlighted" : "nonHighlighted")
    }, n);
  }
  function no(e) {
    var r = e.cx,
      t = e.hit,
      n = e.attribute,
      i = e.highlight,
      a = e.highlightProperty,
      o = e.tagName,
      s = e.nonHighlightedTagName,
      c = e.separator,
      e = e.className,
      u = i({
        hit: t,
        attribute: n,
        highlightProperty: a
      });
    return P.createElement("span", {
      className: T(r(""), e)
    }, u.map(function (e, t) {
      var n;
      return Array.isArray(e) ? (n = t === u.length - 1, P.createElement("span", {
        key: t
      }, e.map(function (e, t) {
        return P.createElement(to, {
          cx: r,
          key: t,
          value: e.value,
          highlightedTagName: o,
          nonHighlightedTagName: s,
          isHighlighted: e.isHighlighted
        });
      }), !n && P.createElement("span", {
        className: r("separator")
      }, c))) : P.createElement(to, {
        cx: r,
        key: t,
        value: e.value,
        highlightedTagName: o,
        nonHighlightedTagName: s,
        isHighlighted: e.isHighlighted
      });
    }));
  }
  function ro(e) {
    return P.createElement("div", {
      style: {
        borderBottom: "1px solid #bbb",
        paddingBottom: "5px",
        marginBottom: "5px",
        wordBreak: "break-all"
      }
    }, JSON.stringify(e).slice(0, 100), "...");
  }
  var io = I("Panel"),
    ao = S.createContext(function () {}),
    oo = ao.Consumer,
    so = ao.Provider,
    ao = function () {
      E(a, S.Component);
      var i = N(a);
      function a() {
        var t;
        O(this, a);
        for (var e = arguments.length, n = new Array(e), r = 0; r < e; r++) n[r] = arguments[r];
        return C(F(t = i.call.apply(i, [this].concat(n))), "state", {
          canRefine: !0
        }), C(F(t), "setCanRefine", function (e) {
          t.setState({
            canRefine: e
          });
        }), t;
      }
      return j(a, [{
        key: "render",
        value: function () {
          var e = this.props,
            t = e.children,
            n = e.className,
            r = e.header,
            e = e.footer,
            i = this.state.canRefine;
          return P.createElement("div", {
            className: T(io("", !i && "-noRefinement"), n)
          }, r && P.createElement("div", {
            className: io("header")
          }, r), P.createElement("div", {
            className: io("body")
          }, P.createElement(so, {
            value: this.setCanRefine
          }, t)), e && P.createElement("div", {
            className: io("footer")
          }, e));
        }
      }]), a;
    }(),
    co = (C(ao, "defaultProps", {
      className: "",
      header: null,
      footer: null
    }), function () {
      E(t, S.Component);
      var e = N(t);
      function t() {
        return O(this, t), e.apply(this, arguments);
      }
      return j(t, [{
        key: "componentDidMount",
        value: function () {
          this.props.setCanRefine(this.props.canRefine);
        }
      }, {
        key: "componentDidUpdate",
        value: function (e) {
          e.canRefine !== this.props.canRefine && this.props.setCanRefine(this.props.canRefine);
        }
      }, {
        key: "render",
        value: function () {
          return this.props.children;
        }
      }]), t;
    }()),
    uo = function () {
      E(a, S.Component);
      var i = N(a);
      function a() {
        var r;
        O(this, a);
        for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++) t[n] = arguments[n];
        return C(F(r = i.call.apply(i, [this].concat(t))), "onClick", function (e) {
          var t, n;
          n = 1 === (t = e).button, Boolean(n || t.altKey || t.ctrlKey || t.metaKey || t.shiftKey) || (r.props.onClick(), e.preventDefault());
        }), r;
      }
      return j(a, [{
        key: "render",
        value: function () {
          return P.createElement("a", ln({}, this.props, {
            onClick: this.onClick
          }));
        }
      }]), a;
    }(),
    lo = I("Breadcrumb"),
    fo = function () {
      E(t, S.Component);
      var e = N(t);
      function t() {
        return O(this, t), e.apply(this, arguments);
      }
      return j(t, [{
        key: "render",
        value: function () {
          var e = this.props,
            t = e.canRefine,
            r = e.createURL,
            i = e.items,
            a = e.refine,
            n = e.rootURL,
            o = e.separator,
            s = e.translate,
            e = e.className,
            s = t ? P.createElement("li", {
              className: lo("item")
            }, P.createElement(uo, {
              className: lo("link"),
              onClick: function () {
                return n ? null : a();
              },
              href: n || r()
            }, s("rootLabel"))) : null,
            c = i.map(function (e, t) {
              var n = t === i.length - 1;
              return P.createElement("li", {
                className: lo("item", n && "item--selected"),
                key: t
              }, P.createElement("span", {
                className: lo("separator")
              }, o), n ? e.label : P.createElement(uo, {
                className: lo("link"),
                onClick: function () {
                  return a(e.value);
                },
                href: r(e.value)
              }, e.label));
            });
          return P.createElement("div", {
            className: T(lo("", !t && "-noRefinement"), e)
          }, P.createElement("ul", {
            className: lo("list")
          }, s, c));
        }
      }]), t;
    }(),
    mo = (C(fo, "defaultProps", {
      rootURL: null,
      separator: " > ",
      className: ""
    }), n({
      rootLabel: "Home"
    })(fo)),
    fo = jr(function (e) {
      return P.createElement(k, e, P.createElement(mo, e));
    }, {
      $$widgetType: "ais.breadcrumb"
    }),
    po = I("ClearRefinements"),
    ho = function () {
      E(t, S.Component);
      var e = N(t);
      function t() {
        return O(this, t), e.apply(this, arguments);
      }
      return j(t, [{
        key: "render",
        value: function () {
          var e = this.props,
            t = e.items,
            n = e.canRefine,
            r = e.refine,
            i = e.translate,
            e = e.className;
          return P.createElement("div", {
            className: T(po(""), e)
          }, P.createElement("button", {
            className: po("button", !n && "button--disabled"),
            onClick: function () {
              return r(t);
            },
            disabled: !n
          }, i("reset")));
        }
      }]), t;
    }(),
    yo = (C(ho, "defaultProps", {
      className: ""
    }), n({
      reset: "Clear all filters"
    })(ho)),
    ho = Nr(function (e) {
      return P.createElement(k, e, P.createElement(yo, e));
    }, {
      $$widgetType: "ais.clearRefinements"
    }),
    go = I("CurrentRefinements"),
    vo = _.arrayOf(_.shape({
      label: _.string.isRequired,
      value: _.func.isRequired,
      items: function () {
        return vo.apply(void 0, arguments);
      }
    })),
    bo = (eo.defaultProps = {
      className: ""
    }, n({
      clearFilter: "✕"
    })(eo)),
    xo = Nr(function (e) {
      return P.createElement(k, e, P.createElement(bo, e));
    }, {
      $$widgetType: "ais.currentRefinements"
    }),
    So = I("SearchBox"),
    Po = P.createElement("svg", {
      width: "18",
      height: "18",
      viewBox: "0 0 38 38",
      xmlns: "http://www.w3.org/2000/svg",
      stroke: "#444",
      className: So("loadingIcon"),
      "aria-hidden": "true"
    }, P.createElement("g", {
      fill: "none",
      fillRule: "evenodd"
    }, P.createElement("g", {
      transform: "translate(1 1)",
      strokeWidth: "2"
    }, P.createElement("circle", {
      strokeOpacity: ".5",
      cx: "18",
      cy: "18",
      r: "18"
    }), P.createElement("path", {
      d: "M36 18c0-9.94-8.06-18-18-18"
    }, P.createElement("animateTransform", {
      attributeName: "transform",
      type: "rotate",
      from: "0 18 18",
      to: "360 18 18",
      dur: "1s",
      repeatCount: "indefinite"
    }))))),
    wo = P.createElement("svg", {
      className: So("resetIcon"),
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 20 20",
      width: "10",
      height: "10",
      "aria-hidden": "true"
    }, P.createElement("path", {
      d: "M8.114 10L.944 2.83 0 1.885 1.886 0l.943.943L10 8.113l7.17-7.17.944-.943L20 1.886l-.943.943-7.17 7.17 7.17 7.17.943.944L18.114 20l-.943-.943-7.17-7.17-7.17 7.17-.944.943L0 18.114l.943-.943L8.113 10z"
    })),
    Ro = P.createElement("svg", {
      className: So("submitIcon"),
      xmlns: "http://www.w3.org/2000/svg",
      width: "10",
      height: "10",
      viewBox: "0 0 40 40",
      "aria-hidden": "true"
    }, P.createElement("path", {
      d: "M26.804 29.01c-2.832 2.34-6.465 3.746-10.426 3.746C7.333 32.756 0 25.424 0 16.378 0 7.333 7.333 0 16.378 0c9.046 0 16.378 7.333 16.378 16.378 0 3.96-1.406 7.594-3.746 10.426l10.534 10.534c.607.607.61 1.59-.004 2.202-.61.61-1.597.61-2.202.004L26.804 29.01zm-10.426.627c7.323 0 13.26-5.936 13.26-13.26 0-7.32-5.937-13.257-13.26-13.257C9.056 3.12 3.12 9.056 3.12 16.378c0 7.323 5.936 13.26 13.258 13.26z"
    })),
    Oo = function () {
      E(n, S.Component);
      var t = N(n);
      function n(e) {
        var a;
        return O(this, n), C(F(a = t.call(this)), "getQuery", function () {
          return a.props.searchAsYouType ? a.props.currentRefinement : a.state.query;
        }), C(F(a), "onInputMount", function (e) {
          a.input = e, a.props.inputRef && ("function" == typeof a.props.inputRef ? a.props.inputRef(e) : a.props.inputRef.current = e);
        }), C(F(a), "onKeyDown", function (e) {
          var t, n, r;
          a.props.focusShortcuts && (t = a.props.focusShortcuts.map(function (e) {
            return "string" == typeof e ? e.toUpperCase().charCodeAt(0) : e;
          }), n = (r = e.target || e.srcElement).tagName, r.isContentEditable || "INPUT" === n || "SELECT" === n || "TEXTAREA" === n || (r = e.which || e.keyCode, -1 !== t.indexOf(r) && (a.input.focus(), e.stopPropagation(), e.preventDefault())));
        }), C(F(a), "onSubmit", function (e) {
          e.preventDefault(), e.stopPropagation(), a.input.blur();
          var e = a.props,
            t = e.refine;
          return e.searchAsYouType || t(a.getQuery()), !1;
        }), C(F(a), "onChange", function (e) {
          var t = a.props,
            n = t.searchAsYouType,
            r = t.refine,
            t = t.onChange,
            i = e.target.value;
          n ? r(i) : a.setState({
            query: i
          }), t && t(e);
        }), C(F(a), "onReset", function (e) {
          var t = a.props,
            n = t.searchAsYouType,
            r = t.refine,
            t = t.onReset;
          r(""), a.input.focus(), n || a.setState({
            query: ""
          }), t && t(e);
        }), a.state = {
          query: e.searchAsYouType ? null : e.currentRefinement
        }, a;
      }
      return j(n, [{
        key: "componentDidMount",
        value: function () {
          document.addEventListener("keydown", this.onKeyDown);
        }
      }, {
        key: "componentWillUnmount",
        value: function () {
          document.removeEventListener("keydown", this.onKeyDown);
        }
      }, {
        key: "componentDidUpdate",
        value: function (e) {
          this.props.searchAsYouType || e.currentRefinement === this.props.currentRefinement || this.setState({
            query: this.props.currentRefinement
          });
        }
      }, {
        key: "render",
        value: function () {
          var n = this,
            e = this.props,
            t = e.className,
            r = e.inputId,
            i = e.translate,
            a = e.autoFocus,
            o = e.loadingIndicator,
            s = e.submit,
            e = e.reset,
            c = this.getQuery(),
            u = Object.keys(this.props).reduce(function (e, t) {
              return -1 === ["onsubmit", "onreset", "onchange"].indexOf(t.toLowerCase()) && 0 === t.indexOf("on") ? R(R({}, e), {}, C({}, t, n.props[t])) : e;
            }, {}),
            l = this.props.showLoadingIndicator && this.props.isSearchStalled;
          return P.createElement("div", {
            className: T(So(""), t)
          }, P.createElement("form", {
            ref: this.props.formRef,
            noValidate: !0,
            onSubmit: this.props.onSubmit || this.onSubmit,
            onReset: this.onReset,
            className: So("form", l && "form--stalledSearch"),
            action: "",
            role: "search"
          }, P.createElement("input", ln({
            ref: this.onInputMount,
            id: r,
            type: "search",
            placeholder: i("placeholder"),
            autoFocus: a,
            autoComplete: "off",
            autoCorrect: "off",
            autoCapitalize: "off",
            spellCheck: "false",
            required: !0,
            maxLength: "512",
            value: c,
            onChange: this.onChange
          }, u, {
            className: So("input")
          })), P.createElement("button", {
            type: "submit",
            title: i("submitTitle"),
            className: So("submit")
          }, s), P.createElement("button", {
            type: "reset",
            title: i("resetTitle"),
            className: So("reset"),
            hidden: !c || l
          }, e), this.props.showLoadingIndicator && P.createElement("span", {
            hidden: !l,
            className: So("loadingIndicator")
          }, o)));
        }
      }]), n;
    }(),
    jo = (C(Oo, "defaultProps", {
      currentRefinement: "",
      className: "",
      focusShortcuts: ["s", "/"],
      autoFocus: !1,
      searchAsYouType: !0,
      showLoadingIndicator: !1,
      isSearchStalled: !1,
      loadingIndicator: Po,
      reset: wo,
      submit: Ro
    }), n({
      resetTitle: "Clear the search query.",
      submitTitle: "Submit your search query.",
      placeholder: "Search here…"
    })(Oo)),
    Co = _.arrayOf(_.shape({
      value: _.any,
      label: _.node.isRequired,
      items: function () {
        return Co.apply(void 0, arguments);
      }
    })),
    Eo = function () {
      E(t, S.Component);
      var e = N(t);
      function t() {
        var r;
        return O(this, t), C(F(r = e.call(this)), "onShowMoreClick", function () {
          r.setState(function (e) {
            return {
              extended: !e.extended
            };
          });
        }), C(F(r), "getLimit", function () {
          var e = r.props,
            t = e.limit,
            e = e.showMoreLimit;
          return r.state.extended ? e : t;
        }), C(F(r), "resetQuery", function () {
          r.setState({
            query: ""
          });
        }), C(F(r), "renderItem", function (t, e) {
          var n = t.items && Boolean(t.items.length);
          return P.createElement("li", {
            key: t.key || t.label,
            className: r.props.cx("item", t.isRefined && "item--selected", t.noRefinement && "item--noRefinement", n && "item--parent")
          }, r.props.renderItem(t, e), n && P.createElement("ul", {
            className: r.props.cx("list", "list--child")
          }, t.items.slice(0, r.getLimit()).map(function (e) {
            return r.renderItem(e, t);
          })));
        }), r.state = {
          extended: !1,
          query: ""
        }, r;
      }
      return j(t, [{
        key: "renderShowMore",
        value: function () {
          var e = this.props,
            t = e.showMore,
            n = e.translate,
            e = e.cx,
            r = this.state.extended,
            i = this.props.limit >= this.props.items.length;
          return t ? P.createElement("button", {
            disabled: i,
            className: e("showMore", i && "showMore--disabled"),
            onClick: this.onShowMoreClick
          }, n("showMore", r)) : null;
        }
      }, {
        key: "renderSearchBox",
        value: function () {
          var t = this,
            e = this.props,
            n = e.cx,
            r = e.searchForItems,
            i = e.isFromSearch,
            a = e.translate,
            o = e.items,
            s = e.selectItem,
            e = 0 === o.length && "" !== this.state.query ? P.createElement("div", {
              className: n("noResults")
            }, a("noResults")) : null;
          return P.createElement("div", {
            className: n("searchBox")
          }, P.createElement(jo, {
            currentRefinement: this.state.query,
            refine: function (e) {
              t.setState({
                query: e
              }), r(e);
            },
            focusShortcuts: [],
            translate: a,
            onSubmit: function (e) {
              e.preventDefault(), e.stopPropagation(), i && 0 < o.length && s(o[0], t.resetQuery);
            }
          }), e);
        }
      }, {
        key: "render",
        value: function () {
          var t = this,
            e = this.props,
            n = e.cx,
            r = e.items,
            i = e.className,
            a = e.searchable,
            e = e.canRefine,
            a = a ? this.renderSearchBox() : null,
            i = T(n("", !e && "-noRefinement"), i);
          return 0 === r.length ? P.createElement("div", {
            className: i
          }, a) : P.createElement("div", {
            className: i
          }, a, P.createElement("ul", {
            className: n("list", !e && "list--noRefinement")
          }, r.slice(0, this.getLimit()).map(function (e) {
            return t.renderItem(e, t.resetQuery);
          })), this.renderShowMore());
        }
      }]), t;
    }(),
    Fo = (C(Eo, "defaultProps", {
      className: "",
      isFromSearch: !1
    }), I("HierarchicalMenu")),
    No = _.arrayOf(_.shape({
      label: _.string.isRequired,
      value: _.string,
      count: _.number.isRequired,
      items: function () {
        return No.apply(void 0, arguments);
      }
    })),
    Po = function () {
      E(a, S.Component);
      var r = N(a);
      function a() {
        var i;
        O(this, a);
        for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++) t[n] = arguments[n];
        return C(F(i = r.call.apply(r, [this].concat(t))), "renderItem", function (e) {
          var t = i.props,
            n = t.createURL,
            r = t.refine;
          return P.createElement(uo, {
            className: Fo("link", e.isRefined && "link--selected"),
            onClick: function () {
              return r(e.value);
            },
            href: n(e.value)
          }, P.createElement("span", {
            className: Fo("label")
          }, e.label), " ", P.createElement("span", {
            className: Fo("count")
          }, e.count));
        }), i;
      }
      return j(a, [{
        key: "render",
        value: function () {
          var e = this.props,
            t = e.translate,
            n = e.items,
            r = e.showMore,
            i = e.limit,
            a = e.showMoreLimit,
            o = e.canRefine,
            e = e.className;
          return P.createElement(Eo, {
            renderItem: this.renderItem,
            cx: Fo,
            translate: t,
            items: n,
            showMore: r,
            limit: i,
            showMoreLimit: a,
            canRefine: o,
            className: e
          });
        }
      }]), a;
    }(),
    Vo = (C(Po, "defaultProps", {
      className: ""
    }), n({
      showMore: function (e) {
        return e ? "Show less" : "Show more";
      }
    })(Po)),
    wo = ei(function (e) {
      return P.createElement(k, e, P.createElement(Vo, e));
    }, {
      $$widgetType: "ais.hierarchicalMenu"
    }),
    Io = (no.defaultProps = {
      tagName: "em",
      nonHighlightedTagName: "span",
      className: "",
      separator: ", "
    }, I("Highlight")),
    _o = ti(function (e) {
      return P.createElement(no, ln({}, e, {
        highlightProperty: "_highlightResult",
        cx: Io
      }));
    }, {
      $$widgetType: "ais.highlight"
    }),
    To = I("Hits"),
    Ro = (_.shape({
      objectID: _.oneOfType([_.string, _.number]).isRequired
    }), ni(function (e) {
      var t = e.hits,
        n = e.className,
        n = void 0 === n ? "" : n,
        e = e.hitComponent,
        r = void 0 === e ? ro : e;
      return P.createElement("div", {
        className: T(To(""), n)
      }, P.createElement("ul", {
        className: To("list")
      }, t.map(function (e) {
        return P.createElement("li", {
          className: To("item"),
          key: e.objectID
        }, P.createElement(r, {
          hit: e
        }));
      })));
    }, {
      $$widgetType: "ais.hits"
    })),
    ko = function () {
      E(a, S.Component);
      var i = N(a);
      function a() {
        var t;
        O(this, a);
        for (var e = arguments.length, n = new Array(e), r = 0; r < e; r++) n[r] = arguments[r];
        return C(F(t = i.call.apply(i, [this].concat(n))), "onChange", function (e) {
          t.props.onSelect(e.target.value);
        }), t;
      }
      return j(a, [{
        key: "render",
        value: function () {
          var e = this.props,
            t = e.cx,
            n = e.id,
            r = e.items,
            e = e.selectedItem;
          return P.createElement("select", {
            id: n,
            className: t("select"),
            value: e,
            onChange: this.onChange
          }, r.map(function (e) {
            return P.createElement("option", {
              className: t("option"),
              key: void 0 === e.key ? e.value : e.key,
              disabled: e.disabled,
              value: e.value
            }, void 0 === e.label ? e.value : e.label);
          }));
        }
      }]), a;
    }(),
    Ao = I("HitsPerPage"),
    Oo = function () {
      E(t, S.Component);
      var e = N(t);
      function t() {
        return O(this, t), e.apply(this, arguments);
      }
      return j(t, [{
        key: "render",
        value: function () {
          var e = this.props,
            t = e.id,
            n = e.items,
            r = e.currentRefinement,
            i = e.refine,
            e = e.className;
          return P.createElement("div", {
            className: T(Ao(""), e)
          }, P.createElement(ko, {
            id: t,
            onSelect: i,
            selectedItem: r,
            items: n,
            cx: Ao
          }));
        }
      }]), t;
    }(),
    Po = (C(Oo, "defaultProps", {
      className: ""
    }), ui(Oo, {
      $$widgetType: "ais.hitsPerPage"
    })),
    Mo = I("InfiniteHits"),
    _ = function () {
      E(t, S.Component);
      var e = N(t);
      function t() {
        return O(this, t), e.apply(this, arguments);
      }
      return j(t, [{
        key: "render",
        value: function () {
          var e = this.props,
            t = e.hitComponent,
            n = e.hits,
            r = e.showPrevious,
            i = e.hasPrevious,
            a = e.hasMore,
            o = e.refinePrevious,
            s = e.refineNext,
            c = e.translate,
            e = e.className;
          return P.createElement("div", {
            className: T(Mo(""), e)
          }, r && P.createElement("button", {
            className: Mo("loadPrevious", !i && "loadPrevious--disabled"),
            onClick: function () {
              return o();
            },
            disabled: !i
          }, c("loadPrevious")), P.createElement("ul", {
            className: Mo("list")
          }, n.map(function (e) {
            return P.createElement("li", {
              key: e.objectID,
              className: Mo("item")
            }, P.createElement(t, {
              hit: e
            }));
          })), P.createElement("button", {
            className: Mo("loadMore", !a && "loadMore--disabled"),
            onClick: function () {
              return s();
            },
            disabled: !a
          }, c("loadMore")));
        }
      }]), t;
    }();
  _.defaultProps = {
    className: "",
    showPrevious: !1,
    hitComponent: function (e) {
      return P.createElement("div", {
        style: {
          borderBottom: "1px solid #bbb",
          paddingBottom: "5px",
          marginBottom: "5px",
          wordBreak: "break-all"
        }
      }, JSON.stringify(e).slice(0, 100), "...");
    }
  };
  var Oo = gi(n({
      loadPrevious: "Load previous",
      loadMore: "Load more"
    })(_), {
      $$widgetType: "ais.infiniteHits"
    }),
    Do = I("Menu"),
    _ = function () {
      E(a, S.Component);
      var r = N(a);
      function a() {
        var i;
        O(this, a);
        for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++) t[n] = arguments[n];
        return C(F(i = r.call.apply(r, [this].concat(t))), "renderItem", function (e, t) {
          var n = i.props.createURL,
            r = i.props.isFromSearch ? P.createElement(_o, {
              attribute: "label",
              hit: e
            }) : e.label;
          return P.createElement(uo, {
            className: Do("link"),
            onClick: function () {
              return i.selectItem(e, t);
            },
            href: n(e.value)
          }, P.createElement("span", {
            className: Do("label")
          }, r), " ", P.createElement("span", {
            className: Do("count")
          }, e.count));
        }), C(F(i), "selectItem", function (e, t) {
          t(), i.props.refine(e.value);
        }), i;
      }
      return j(a, [{
        key: "render",
        value: function () {
          var e = this.props,
            t = e.translate,
            n = e.items,
            r = e.showMore,
            i = e.limit,
            a = e.showMoreLimit,
            o = e.isFromSearch,
            s = e.searchForItems,
            c = e.searchable,
            u = e.canRefine,
            e = e.className;
          return P.createElement(Eo, {
            renderItem: this.renderItem,
            selectItem: this.selectItem,
            cx: Do,
            translate: t,
            items: n,
            showMore: r,
            limit: i,
            showMoreLimit: a,
            isFromSearch: o,
            searchForItems: s,
            searchable: c,
            canRefine: u,
            className: e
          });
        }
      }]), a;
    }(),
    Ho = (C(_, "defaultProps", {
      className: ""
    }), n({
      showMore: function (e) {
        return e ? "Show less" : "Show more";
      },
      noResults: "No results",
      submit: null,
      reset: null,
      resetTitle: "Clear the search query.",
      submitTitle: "Submit your search query.",
      placeholder: "Search here…"
    })(_)),
    _ = Ci(function (e) {
      return P.createElement(k, e, P.createElement(Ho, e));
    }, {
      $$widgetType: "ais.menu"
    }),
    Lo = I("MenuSelect"),
    $o = function () {
      E(a, S.Component);
      var i = N(a);
      function a() {
        var t;
        O(this, a);
        for (var e = arguments.length, n = new Array(e), r = 0; r < e; r++) n[r] = arguments[r];
        return C(F(t = i.call.apply(i, [this].concat(n))), "handleSelectChange", function (e) {
          e = e.target.value;
          t.props.refine("ais__see__all__option" === e ? "" : e);
        }), t;
      }
      return j(a, [{
        key: "selectedValue",
        get: function () {
          return (Xa(this.props.items, function (e) {
            return !0 === e.isRefined;
          }) || {
            value: "ais__see__all__option"
          }).value;
        }
      }, {
        key: "render",
        value: function () {
          var e = this.props,
            t = e.id,
            n = e.items,
            r = e.canRefine,
            i = e.translate,
            e = e.className;
          return P.createElement("div", {
            className: T(Lo("", !r && "-noRefinement"), e)
          }, P.createElement("select", {
            id: t,
            value: this.selectedValue,
            onChange: this.handleSelectChange,
            className: Lo("select")
          }, P.createElement("option", {
            value: "ais__see__all__option",
            className: Lo("option")
          }, i("seeAllOption")), n.map(function (e) {
            return P.createElement("option", {
              key: e.value,
              value: e.value,
              className: Lo("option")
            }, e.label, " (", e.count, ")");
          })));
        }
      }]), a;
    }(),
    Bo = (C($o, "defaultProps", {
      className: ""
    }), n({
      seeAllOption: "See all"
    })($o)),
    $o = Ci(function (e) {
      return P.createElement(k, e, P.createElement(Bo, e));
    }, {
      $$widgetType: "ais.menuSelect"
    }),
    Qo = I("NumericMenu"),
    qo = function () {
      E(a, S.Component);
      var i = N(a);
      function a() {
        var r;
        O(this, a);
        for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++) t[n] = arguments[n];
        return C(F(r = i.call.apply(i, [this].concat(t))), "renderItem", function (e) {
          var t = r.props,
            n = t.refine,
            t = t.translate;
          return P.createElement("label", {
            className: Qo("label")
          }, P.createElement("input", {
            className: Qo("radio"),
            type: "radio",
            checked: e.isRefined,
            disabled: e.noRefinement,
            onChange: function () {
              return n(e.value);
            }
          }), P.createElement("span", {
            className: Qo("labelText")
          }, "" === e.value ? t("all") : e.label));
        }), r;
      }
      return j(a, [{
        key: "render",
        value: function () {
          var e = this.props,
            t = e.items,
            n = e.canRefine,
            e = e.className;
          return P.createElement(Eo, {
            renderItem: this.renderItem,
            showMore: !1,
            canRefine: n,
            cx: Qo,
            items: t.map(function (e) {
              return R(R({}, e), {}, {
                key: e.value
              });
            }),
            className: e
          });
        }
      }]), a;
    }(),
    Uo = (C(qo, "defaultProps", {
      className: ""
    }), n({
      all: "All"
    })(qo)),
    qo = Mi(function (e) {
      return P.createElement(k, e, P.createElement(Uo, e));
    }, {
      $$widgetType: "ais.numericMenu"
    }),
    Wo = function () {
      E(t, S.Component);
      var e = N(t);
      function t() {
        return O(this, t), e.apply(this, arguments);
      }
      return j(t, [{
        key: "render",
        value: function () {
          var e = this.props,
            t = e.cx,
            n = e.createURL,
            r = e.items,
            i = e.onSelect,
            e = e.canRefine;
          return P.createElement("ul", {
            className: t("list", !e && "list--noRefinement")
          }, r.map(function (e) {
            return P.createElement("li", {
              key: void 0 === e.key ? e.value : e.key,
              className: t("item", e.selected && !e.disabled && "item--selected", e.disabled && "item--disabled", e.modifier)
            }, e.disabled ? P.createElement("span", {
              className: t("link")
            }, void 0 === e.label ? e.value : e.label) : P.createElement(uo, {
              className: t("link", e.selected && "link--selected"),
              "aria-label": e.ariaLabel,
              href: n(e.value),
              onClick: function () {
                return i(e.value);
              }
            }, void 0 === e.label ? e.value : e.label));
          }));
        }
      }]), t;
    }(),
    zo = ["listComponent", "nbPages", "totalPages", "currentRefinement", "padding", "showFirst", "showPrevious", "showNext", "showLast", "refine", "createURL", "canRefine", "translate", "className"],
    Yo = I("Pagination");
  function Jo(e, t, n) {
    var r,
      i,
      a = Math.min(2 * n + 1, t);
    return a === t ? Ga({
      start: 1,
      end: t + 1
    }) : (t = t, i = a, i = (r = e) <= (n = n) ? r : t - n <= r ? i - (t - r) : n + 1, Ga({
      start: 1 + (e - i),
      end: e + (a - i) + 1
    }));
  }
  function Zo(e) {
    return e = e.isRelevantSorted, P.createElement("span", null, e ? "See all results" : "See relevant results");
  }
  function Ko(e) {
    var t = e.currentRefinement,
      n = e.label,
      r = e.canRefine,
      i = e.refine,
      e = e.className;
    return P.createElement("div", {
      className: T(js("", !r && "-noRefinement"), e)
    }, P.createElement("label", {
      className: js("label")
    }, P.createElement("input", {
      className: js("checkbox"),
      type: "checkbox",
      checked: t,
      onChange: function (e) {
        return i(e.target.checked);
      }
    }), P.createElement("span", {
      className: js("labelText")
    }, n)));
  }
  var Go = function () {
      E(t, S.Component);
      var e = N(t);
      function t() {
        return O(this, t), e.apply(this, arguments);
      }
      return j(t, [{
        key: "getItem",
        value: function (e, t, n) {
          var r = this.props,
            i = r.nbPages,
            a = r.totalPages,
            r = r.translate;
          return {
            key: "".concat(e, ".").concat(n),
            modifier: e,
            disabled: n < 1 || n >= Math.min(a, i),
            label: r(t, n),
            value: n,
            ariaLabel: r("aria".concat(0 === (e = t).length ? "" : "".concat(e[0].toUpperCase()).concat(e.slice(1))), n)
          };
        }
      }, {
        key: "render",
        value: function () {
          var e = this.props,
            t = e.listComponent,
            n = e.nbPages,
            r = e.totalPages,
            i = e.currentRefinement,
            a = e.padding,
            o = e.showFirst,
            s = e.showPrevious,
            c = e.showNext,
            u = e.showLast,
            l = e.refine,
            f = e.createURL,
            m = e.canRefine,
            p = e.translate,
            h = e.className,
            e = pn(e, zo),
            n = Math.min(n, r),
            r = n,
            d = [];
          return o && d.push({
            key: "first",
            modifier: "item--firstPage",
            disabled: 1 === i,
            label: p("first"),
            value: 1,
            ariaLabel: p("ariaFirst")
          }), s && d.push({
            key: "previous",
            modifier: "item--previousPage",
            disabled: 1 === i,
            label: p("previous"),
            value: i - 1,
            ariaLabel: p("ariaPrevious")
          }), d = d.concat(Jo(i, n, a).map(function (e) {
            return {
              key: e,
              modifier: "item--page",
              label: p("page", e),
              value: e,
              selected: e === i,
              ariaLabel: p("ariaPage", e)
            };
          })), c && d.push({
            key: "next",
            modifier: "item--nextPage",
            disabled: i === r || r <= 1,
            label: p("next"),
            value: i + 1,
            ariaLabel: p("ariaNext")
          }), u && d.push({
            key: "last",
            modifier: "item--lastPage",
            disabled: i === r || r <= 1,
            label: p("last"),
            value: r,
            ariaLabel: p("ariaLast")
          }), P.createElement("div", {
            className: T(Yo("", !m && "-noRefinement"), h)
          }, P.createElement(t, ln({}, e, {
            cx: Yo,
            items: d,
            onSelect: l,
            createURL: f,
            canRefine: m
          })));
        }
      }]), t;
    }(),
    Xo = (C(Go, "defaultProps", {
      listComponent: Wo,
      showFirst: !0,
      showPrevious: !0,
      showNext: !0,
      showLast: !1,
      padding: 3,
      totalPages: 1 / 0,
      className: ""
    }), n({
      previous: "‹",
      next: "›",
      first: "«",
      last: "»",
      page: function (e) {
        return e.toString();
      },
      ariaPrevious: "Previous page",
      ariaNext: "Next page",
      ariaFirst: "First page",
      ariaLast: "Last page",
      ariaPage: function (e) {
        return "Page ".concat(e.toString());
      }
    })(Go)),
    Wo = Bi(function (e) {
      return P.createElement(k, e, P.createElement(Xo, e));
    }, {
      $$widgetType: "ais.pagination"
    }),
    es = I("PoweredBy"),
    ts = P.createElement("path", {
      fill: "#003DFF",
      d: "M249.5 64.2V1.4c0-.9-.7-1.5-1.6-1.4L236.2 2a1.4 1.4 0 0 0-1.2 1.3V67c0 3 0 21.6 22.4 22.3a1.4 1.4 0 0 0 1.5-1.4v-9.5c0-.7-.6-1.3-1.2-1.4-8.2-.9-8.2-11-8.2-12.7ZM443.5 24.4h-11.8c-.8 0-1.4.6-1.4 1.4v62c0 .8.6 1.4 1.4 1.4h11.8c.8 0 1.4-.6 1.4-1.4v-62c0-.8-.6-1.4-1.4-1.4ZM431.7 16.6h11.8c.8 0 1.4-.6 1.4-1.3v-14c0-.8-.7-1.4-1.6-1.3L431.5 2a1.4 1.4 0 0 0-1.2 1.3v12c0 .8.6 1.4 1.4 1.4Zm-20.5 47.6V1.4c0-.9-.7-1.5-1.5-1.4L397.9 2a1.4 1.4 0 0 0-1.2 1.3V67c0 3 0 21.6 22.4 22.3a1.4 1.4 0 0 0 1.5-1.4v-9.5c0-.7-.5-1.3-1.2-1.4-8.2-.9-8.2-11-8.2-12.7Zm-30.7-31c-2.6-2.8-5.8-5-9.6-6.5a31.7 31.7 0 0 0-12-2.3c-4.5 0-8.5.7-12.2 2.3A27.9 27.9 0 0 0 331 43.5a39.6 39.6 0 0 0 0 26.3c1.5 4 3.6 7.5 6.2 10.3 2.6 2.9 5.8 5 9.5 6.7a38 38 0 0 0 12.2 2.4c2.8 0 8.6-.9 12.3-2.4a27 27 0 0 0 9.5-6.7 35.1 35.1 0 0 0 8.3-23c0-4.9-.8-9.6-2.4-13.6-1.5-4-3.5-7.4-6.1-10.2ZM370 71.5a13.1 13.1 0 0 1-11.2 5.6 13 13 0 0 1-11.2-5.6c-2.7-3.6-4-7.9-4-14.2 0-6.3 1.3-11.5 4-15.1a13 13 0 0 1 11.1-5.5 13 13 0 0 1 11.3 5.5c2.6 3.6 4 8.8 4 15 0 6.4-1.3 10.6-4 14.3Zm-161.6-47H197a32 32 0 0 0-27 15 33.8 33.8 0 0 0 8.9 45.9 18.8 18.8 0 0 0 11.2 3.1H191.2l.6-.2h.2a21 21 0 0 0 16.5-14.6V87c0 .8.6 1.4 1.4 1.4h11.7c.8 0 1.4-.6 1.4-1.4V25.8c0-.8-.6-1.4-1.4-1.4h-13Zm0 48.3a17.8 17.8 0 0 1-10.4 3.5h-.2a12.5 12.5 0 0 1-.7 0A18.4 18.4 0 0 1 180.4 51c2.7-6.8 9-11.6 16.6-11.6h11.5v33.3Zm289-48.3H486a32 32 0 0 0-27 15 33.8 33.8 0 0 0 8.8 45.9 18.8 18.8 0 0 0 11.3 3.1h1.1l.6-.2h.2a21 21 0 0 0 16.5-14.6V87c0 .8.6 1.4 1.4 1.4h11.7c.8 0 1.4-.6 1.4-1.4V25.8c0-.8-.6-1.4-1.4-1.4h-13.1Zm0 48.3a17.8 17.8 0 0 1-10.5 3.5h-.9A18.4 18.4 0 0 1 469.4 51c2.6-6.8 9-11.6 16.6-11.6h11.5v33.3ZM306.3 24.4h-11.5a32 32 0 0 0-27 15 33.7 33.7 0 0 0-5.1 14.6 34.6 34.6 0 0 0 0 7.6c1 8.9 5.4 16.7 11.8 22a19.5 19.5 0 0 0 2.2 1.7 18.8 18.8 0 0 0 21.6-.6c3.8-2.7 6.7-6.7 8-11.1V87.9c0 5-1.3 8.9-4 11.5-2.7 2.6-7.3 3.9-13.6 3.9-2.6 0-6.7-.2-10.9-.6a1.4 1.4 0 0 0-1.4 1l-3 10a1.4 1.4 0 0 0 1.1 1.8c5 .7 10 1 12.8 1 11.4 0 19.8-2.4 25.3-7.4 5-4.6 7.8-11.4 8.2-20.7V25.8c0-.8-.6-1.4-1.3-1.4h-13.2Zm0 15s.2 32.4 0 33.4a17.5 17.5 0 0 1-10 3.4h-.2a13.6 13.6 0 0 1-1.7 0A18.7 18.7 0 0 1 278.3 51c2.6-6.8 9-11.6 16.5-11.6h11.5ZM58.2 0A58.3 58.3 0 1 0 86 109.5c.9-.5 1-1.6.3-2.2l-5.5-4.9a3.8 3.8 0 0 0-4-.6A47 47 0 0 1 11 57.5 47.3 47.3 0 0 1 58.2 11h47.3v84L78.7 71.2a2 2 0 0 0-3 .3 22 22 0 1 1 4.4-15.2 4 4 0 0 0 1.3 2.6l7 6.2c.8.7 2 .3 2.3-.8a33 33 0 0 0-30.4-39 33 33 0 0 0-35 32 33.3 33.3 0 0 0 32.2 33.9 32.8 32.8 0 0 0 20-6.3l35.1 31c1.5 1.4 3.9.3 3.9-1.7V2.2a2.2 2.2 0 0 0-2.2-2.2h-56Z"
    }),
    ns = P.createElement(function () {
      return P.createElement("svg", {
        viewBox: "0 0 512 117",
        width: "118",
        height: "27",
        className: es("logo")
      }, ts);
    }, null),
    Go = Qi(n({
      searchBy: "Search by"
    })(function () {
      E(t, S.Component);
      var e = N(t);
      function t() {
        return O(this, t), e.apply(this, arguments);
      }
      return j(t, [{
        key: "render",
        value: function () {
          var e = this.props,
            t = e.url,
            n = e.translate,
            e = e.className;
          return P.createElement("div", {
            className: T(es(""), e)
          }, P.createElement("span", {
            className: es("text")
          }, n("searchBy")), " ", P.createElement("a", {
            href: t,
            target: "_blank",
            className: es("link"),
            "aria-label": "Algolia",
            rel: "noopener noreferrer"
          }, ns));
        }
      }]), t;
    }()), {
      $$widgetType: "ais.poweredBy"
    }),
    rs = I("RangeInput"),
    is = function () {
      E(r, S.Component);
      var n = N(r);
      function r(e) {
        var t;
        return O(this, r), C(F(t = n.call(this, e)), "onSubmit", function (e) {
          e.preventDefault(), t.props.refine({
            min: t.state.from,
            max: t.state.to
          });
        }), t.state = t.normalizeStateForRendering(e), t;
      }
      return j(r, [{
        key: "componentDidUpdate",
        value: function (e) {
          !this.props.canRefine || e.currentRefinement.min === this.props.currentRefinement.min && e.currentRefinement.max === this.props.currentRefinement.max || this.setState(this.normalizeStateForRendering(this.props));
        }
      }, {
        key: "normalizeStateForRendering",
        value: function (e) {
          var t = e.canRefine,
            n = e.min,
            r = e.max,
            e = e.currentRefinement,
            i = e.min,
            e = e.max;
          return {
            from: t && void 0 !== i && i !== n ? i : "",
            to: t && void 0 !== e && e !== r ? e : ""
          };
        }
      }, {
        key: "normalizeRangeForRendering",
        value: function (e) {
          var t = e.canRefine,
            n = e.min,
            e = e.max,
            r = void 0 !== n,
            i = void 0 !== e;
          return {
            min: t && r && i ? n : "",
            max: t && r && i ? e : ""
          };
        }
      }, {
        key: "render",
        value: function () {
          var t = this,
            e = this.state,
            n = e.from,
            e = e.to,
            r = this.props,
            i = r.precision,
            a = r.translate,
            o = r.canRefine,
            r = r.className,
            s = this.normalizeRangeForRendering(this.props),
            c = s.min,
            s = s.max,
            i = 1 / Math.pow(10, i);
          return P.createElement("div", {
            className: T(rs("", !o && "-noRefinement"), r)
          }, P.createElement("form", {
            className: rs("form"),
            onSubmit: this.onSubmit
          }, P.createElement("input", {
            className: rs("input", "input--min"),
            type: "number",
            min: c,
            max: s,
            value: n,
            step: i,
            placeholder: c,
            disabled: !o,
            onChange: function (e) {
              return t.setState({
                from: e.currentTarget.value
              });
            }
          }), P.createElement("span", {
            className: rs("separator")
          }, a("separator")), P.createElement("input", {
            className: rs("input", "input--max"),
            type: "number",
            min: c,
            max: s,
            value: e,
            step: i,
            placeholder: s,
            disabled: !o,
            onChange: function (e) {
              return t.setState({
                to: e.currentTarget.value
              });
            }
          }), P.createElement("button", {
            className: rs("submit"),
            type: "submit"
          }, a("submit"))));
        }
      }]), r;
    }(),
    as = (C(is, "defaultProps", {
      currentRefinement: {},
      className: ""
    }), n({
      submit: "ok",
      separator: "to"
    })(is)),
    is = Gi(function (e) {
      return P.createElement(k, e, P.createElement(as, e));
    }, {
      $$widgetType: "ais.rangeInput"
    }),
    os = P.createElement("div", null, "We do not provide any Slider, see the documentation to learn how to connect one easily:", P.createElement("a", {
      target: "_blank",
      rel: "noopener noreferrer",
      href: "https://www.algolia.com/doc/api-reference/widgets/range-slider/react/"
    }, "https://www.algolia.com/doc/api-reference/widgets/range-slider/react/")),
    ss = I("RatingMenu"),
    cs = P.createElement("path", {
      d: "M12 .288l2.833 8.718h9.167l-7.417 5.389 2.833 8.718-7.416-5.388-7.417 5.388 2.833-8.718-7.416-5.389h9.167z"
    }),
    us = P.createElement("path", {
      d: "M12 6.76l1.379 4.246h4.465l-3.612 2.625 1.379 4.246-3.611-2.625-3.612 2.625 1.379-4.246-3.612-2.625h4.465l1.38-4.246zm0-6.472l-2.833 8.718h-9.167l7.416 5.389-2.833 8.718 7.417-5.388 7.416 5.388-2.833-8.718 7.417-5.389h-9.167l-2.833-8.718z"
    }),
    ls = function () {
      E(t, S.Component);
      var e = N(t);
      function t() {
        return O(this, t), e.apply(this, arguments);
      }
      return j(t, [{
        key: "onClick",
        value: function (e, t, n) {
          n.preventDefault(), n.stopPropagation(), e === this.props.currentRefinement.min && t === this.props.currentRefinement.max ? this.props.refine({
            min: this.props.min,
            max: this.props.max
          }) : this.props.refine({
            min: e,
            max: t
          });
        }
      }, {
        key: "buildItem",
        value: function (e) {
          for (var t = e.max, n = e.lowerBound, r = e.count, i = e.translate, a = e.createURL, e = e.isLastSelectableItem, o = !r, s = this.props.currentRefinement.min < n, s = e && s || !o && n === this.props.currentRefinement.min && t === this.props.currentRefinement.max, c = [], u = 0, l = 0; l < t; l++) l < n && u++, c.push([P.createElement("svg", {
            key: l,
            className: ss("starIcon", n <= l ? "starIcon--empty" : "starIcon--full"),
            "aria-hidden": "true",
            width: "24",
            height: "24"
          }, P.createElement("use", {
            xlinkHref: "#".concat(ss(n <= l ? "starEmptySymbol" : "starSymbol"))
          })), " "]);
          e = o || e && s ? {} : {
            href: a({
              min: n,
              max: t
            }),
            onClick: this.onClick.bind(this, n, t)
          };
          return P.createElement("li", {
            key: n,
            className: ss("item", s && "item--selected", o && "item--disabled")
          }, P.createElement("a", ln({
            className: ss("link"),
            "aria-label": "".concat(u).concat(i("ratingLabel"))
          }, e), c, P.createElement("span", {
            className: ss("label"),
            "aria-hidden": "true"
          }, i("ratingLabel")), " ", P.createElement("span", {
            className: ss("count")
          }, r)));
        }
      }, {
        key: "render",
        value: function () {
          var r = this,
            e = this.props,
            t = e.min,
            n = e.max,
            i = e.translate,
            a = e.count,
            o = e.createURL,
            s = e.canRefine,
            e = e.className,
            c = void 0 !== t && 0 <= t ? t : 1,
            u = void 0 !== n && 0 <= n ? n : 0,
            t = u - c + 1,
            l = a.map(function (e) {
              return R(R({}, e), {}, {
                value: parseFloat(e.value)
              });
            }).filter(function (e) {
              return e.value >= c && e.value <= u;
            }),
            n = Ga({
              start: 0,
              end: Math.max(t, 0)
            }).map(function (t) {
              return Xa(l, function (e) {
                return e.value === u - t;
              }) || {
                value: u - t,
                count: 0,
                total: 0
              };
            }).reduce(function (e, t, n) {
              return e.concat(R(R({}, t), {}, {
                total: 0 === n ? t.count : e[n - 1].total + t.count
              }));
            }, []).map(function (e, t, n) {
              return r.buildItem({
                lowerBound: e.value,
                count: e.total,
                isLastSelectableItem: n.length - 1 === t,
                max: u,
                translate: i,
                createURL: o
              });
            });
          return P.createElement("div", {
            className: T(ss("", !s && "-noRefinement"), e)
          }, P.createElement("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            style: {
              display: "none"
            }
          }, P.createElement("symbol", {
            id: ss("starSymbol"),
            viewBox: "0 0 24 24"
          }, cs), P.createElement("symbol", {
            id: ss("starEmptySymbol"),
            viewBox: "0 0 24 24"
          }, us)), P.createElement("ul", {
            className: ss("list", !s && "list--noRefinement")
          }, n));
        }
      }]), t;
    }(),
    fs = (C(ls, "defaultProps", {
      className: ""
    }), n({
      ratingLabel: " & Up"
    })(ls)),
    ls = Gi(function (e) {
      return P.createElement(k, e, P.createElement(fs, e));
    }, {
      $$widgetType: "ais.ratingMenu"
    }),
    ms = I("RefinementList"),
    ps = function () {
      E(a, S.Component);
      var i = N(a);
      function a() {
        var r;
        O(this, a);
        for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++) t[n] = arguments[n];
        return C(F(r = i.call.apply(i, [this].concat(t))), "state", {
          query: ""
        }), C(F(r), "selectItem", function (e, t) {
          t(), r.props.refine(e.value);
        }), C(F(r), "renderItem", function (e, t) {
          var n = r.props.isFromSearch ? P.createElement(_o, {
            attribute: "label",
            hit: e
          }) : e.label;
          return P.createElement("label", {
            className: ms("label")
          }, P.createElement("input", {
            className: ms("checkbox"),
            type: "checkbox",
            checked: e.isRefined,
            onChange: function () {
              return r.selectItem(e, t);
            }
          }), P.createElement("span", {
            className: ms("labelText")
          }, n), " ", P.createElement("span", {
            className: ms("count")
          }, e.count.toLocaleString()));
        }), r;
      }
      return j(a, [{
        key: "render",
        value: function () {
          var e = this.props,
            t = e.translate,
            n = e.items,
            r = e.showMore,
            i = e.limit,
            a = e.showMoreLimit,
            o = e.isFromSearch,
            s = e.searchForItems,
            c = e.searchable,
            u = e.canRefine,
            e = e.className;
          return P.createElement(Eo, {
            renderItem: this.renderItem,
            selectItem: this.selectItem,
            cx: ms,
            translate: t,
            items: n,
            showMore: r,
            limit: i,
            showMoreLimit: a,
            isFromSearch: o,
            searchForItems: s,
            searchable: c,
            canRefine: u,
            className: e,
            query: this.state.query
          });
        }
      }]), a;
    }(),
    hs = (C(ps, "defaultProps", {
      className: ""
    }), n({
      showMore: function (e) {
        return e ? "Show less" : "Show more";
      },
      noResults: "No results",
      submit: null,
      reset: null,
      resetTitle: "Clear the search query.",
      submitTitle: "Submit your search query.",
      placeholder: "Search here…"
    })(ps)),
    ps = ca(function (e) {
      return P.createElement(k, e, P.createElement(hs, e));
    }, {
      $$widgetType: "ais.refinementList"
    }),
    ds = I("ScrollTo"),
    ys = ua(function () {
      E(t, S.Component);
      var e = N(t);
      function t() {
        return O(this, t), e.apply(this, arguments);
      }
      return j(t, [{
        key: "componentDidUpdate",
        value: function (e) {
          var t = this.props,
            n = t.value,
            t = t.hasNotChanged;
          n !== e.value && t && this.el.scrollIntoView();
        }
      }, {
        key: "render",
        value: function () {
          var t = this;
          return P.createElement("div", {
            ref: function (e) {
              return t.el = e;
            },
            className: ds("")
          }, this.props.children);
        }
      }]), t;
    }(), {
      $$widgetType: "ais.scrollTo"
    }),
    gs = da(jo, {
      $$widgetType: "ais.searchBox"
    }),
    vs = I("Snippet"),
    bs = ti(function (e) {
      return P.createElement(no, ln({}, e, {
        highlightProperty: "_snippetResult",
        cx: vs
      }));
    }, {
      $$widgetType: "ais.snippet"
    }),
    xs = I("RelevantSort"),
    Ss = ba(function (e) {
      var t = e.className,
        t = void 0 === t ? "" : t,
        n = e.isVirtualReplica,
        r = e.isRelevantSorted,
        i = e.buttonTextComponent,
        i = void 0 === i ? Zo : i,
        a = e.textComponent,
        o = e.refine;
      return n ? P.createElement("div", {
        className: T(xs(""), t)
      }, P.createElement("div", {
        className: xs("text")
      }, a && P.createElement(a, {
        isRelevantSorted: r
      })), P.createElement("button", {
        className: xs("button"),
        onClick: function () {
          return o(r ? 0 : void 0);
        }
      }, P.createElement(i, {
        isRelevantSorted: r
      }))) : null;
    }, {
      $$widgetType: "ais.relevantSort"
    }),
    Ps = I("SortBy"),
    ws = function () {
      E(t, S.Component);
      var e = N(t);
      function t() {
        return O(this, t), e.apply(this, arguments);
      }
      return j(t, [{
        key: "render",
        value: function () {
          var e = this.props,
            t = e.id,
            n = e.items,
            r = e.currentRefinement,
            i = e.refine,
            e = e.className;
          return P.createElement("div", {
            className: T(Ps(""), e)
          }, P.createElement(ko, {
            id: t,
            cx: Ps,
            items: n,
            selectedItem: r,
            onSelect: i
          }));
        }
      }]), t;
    }(),
    ws = (C(ws, "defaultProps", {
      className: ""
    }), ja(ws, {
      $$widgetType: "ais.sortBy"
    })),
    Rs = I("Stats"),
    Os = Ea(n({
      stats: function (e, t, n, r) {
        return (r && e !== n ? "".concat(n.toLocaleString(), " relevant results sorted out of ").concat(e.toLocaleString(), " found in ") : "".concat(e.toLocaleString(), " results found in ")).concat(t.toLocaleString(), "ms");
      }
    })(function (e) {
      var t = e.className,
        t = void 0 === t ? "" : t,
        n = e.areHitsSorted,
        r = e.nbHits,
        i = e.nbSortedHits,
        a = e.processingTimeMS,
        e = e.translate;
      return P.createElement("div", {
        className: T(Rs(""), t)
      }, P.createElement("span", {
        className: Rs("text")
      }, e("stats", r, a, i, n)));
    }), {
      $$widgetType: "ais.stats"
    }),
    js = I("ToggleRefinement"),
    Cs = (Ko.defaultProps = {
      className: ""
    }, Aa(Ko, {
      $$widgetType: "ais.toggleRefinement"
    }));
  function Es(e) {
    function t(e) {
      return {
        status: e,
        transcript: "",
        isSpeechFinal: !1,
        errorCode: void 0
      };
    }
    function n() {
      return Boolean(u);
    }
    function r() {
      return "askingPermission" === l.status || "waiting" === l.status || "recognizing" === l.status;
    }
    var i,
      a = e.searchAsYouSpeak,
      o = e.language,
      s = e.onQueryChange,
      c = e.onStateChange,
      u = window.webkitSpeechRecognition || window.SpeechRecognition,
      l = t("initial"),
      f = function () {
        var e = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : {};
        l = R(R({}, l), e), c();
      },
      m = function () {
        f(t(0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : "initial"));
      },
      p = function () {
        f({
          status: "waiting"
        });
      },
      h = function (e) {
        f({
          status: "error",
          errorCode: e.error
        });
      },
      d = function (e) {
        f({
          status: "recognizing",
          transcript: e.results[0] && e.results[0][0] && e.results[0][0].transcript || "",
          isSpeechFinal: e.results[0] && e.results[0].isFinal
        }), a && l.transcript && s(l.transcript);
      },
      y = function () {
        l.errorCode || !l.transcript || a || s(l.transcript), "error" !== l.status && f({
          status: "finished"
        });
      },
      g = function () {
        i && (i.stop(), i.removeEventListener("start", p), i.removeEventListener("error", h), i.removeEventListener("result", d), i.removeEventListener("end", y), i = void 0);
      };
    return {
      getState: function () {
        return l;
      },
      isBrowserSupported: n,
      isListening: r,
      toggleListening: function () {
        n() && (r() ? (g(), m("finished")) : (i = new u()) && (m("askingPermission"), i.interimResults = !0, o && (i.lang = o), i.addEventListener("start", p), i.addEventListener("error", h), i.addEventListener("result", d), i.addEventListener("end", y), i.start()));
      },
      dispose: g
    };
  }
  function Fs(e) {
    return e = e.children, P.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: "16",
      height: "16",
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: "currentColor",
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, e);
  }
  var Ns = I("VoiceSearch"),
    Vs = P.createElement(Fs, null, P.createElement("line", {
      x1: "1",
      y1: "1",
      x2: "23",
      y2: "23"
    }), P.createElement("path", {
      d: "M9 9v3a3 3 0 0 0 5.12 2.12M15 9.34V4a3 3 0 0 0-5.94-.6"
    }), P.createElement("path", {
      d: "M17 16.95A7 7 0 0 1 5 12v-2m14 0v2a7 7 0 0 1-.11 1.23"
    }), P.createElement("line", {
      x1: "12",
      y1: "19",
      x2: "12",
      y2: "23"
    }), P.createElement("line", {
      x1: "8",
      y1: "23",
      x2: "16",
      y2: "23"
    })),
    Is = P.createElement("path", {
      d: "M19 10v2a7 7 0 0 1-14 0v-2"
    }),
    _s = P.createElement("line", {
      x1: "12",
      y1: "19",
      x2: "12",
      y2: "23"
    }),
    Ts = P.createElement("line", {
      x1: "8",
      y1: "23",
      x2: "16",
      y2: "23"
    }),
    ks = function () {
      E(a, S.Component);
      var i = N(a);
      function a() {
        var t;
        O(this, a);
        for (var e = arguments.length, n = new Array(e), r = 0; r < e; r++) n[r] = arguments[r];
        return C(F(t = i.call.apply(i, [this].concat(n))), "voiceSearchHelper", void 0), C(F(t), "onClick", function (e) {
          t.voiceSearchHelper && (e.currentTarget.blur(), (0, t.voiceSearchHelper.toggleListening)());
        }), t;
      }
      return j(a, [{
        key: "componentDidMount",
        value: function () {
          var e = this,
            t = this.props,
            n = t.searchAsYouSpeak,
            r = t.language,
            i = t.refine;
          this.voiceSearchHelper = Es({
            searchAsYouSpeak: void 0 !== n && n,
            language: r,
            onQueryChange: function (e) {
              return i(e);
            },
            onStateChange: function () {
              e.setState(e.voiceSearchHelper.getState());
            }
          }), this.setState(this.voiceSearchHelper.getState());
        }
      }, {
        key: "render",
        value: function () {
          var e, t, n, r, i, a, o, s, c;
          return this.voiceSearchHelper ? (c = (n = this.state).status, e = n.transcript, t = n.isSpeechFinal, n = n.errorCode, r = (i = this.voiceSearchHelper).isListening, i = i.isBrowserSupported, a = (s = this.props).translate, o = s.buttonTextComponent, s = s.statusComponent, c = {
            status: c,
            errorCode: n,
            isListening: r(),
            transcript: e,
            isSpeechFinal: t,
            isBrowserSupported: i()
          }, P.createElement("div", {
            className: Ns("")
          }, P.createElement("button", {
            className: Ns("button"),
            type: "button",
            title: i() ? a("buttonTitle") : a("disabledButtonTitle"),
            onClick: this.onClick,
            disabled: !i()
          }, P.createElement(o, c)), P.createElement("div", {
            className: Ns("status")
          }, P.createElement(s, c)))) : null;
        }
      }, {
        key: "componentWillUnmount",
        value: function () {
          this.voiceSearchHelper && this.voiceSearchHelper.dispose();
        }
      }]), a;
    }();
  C(ks, "defaultProps", {
    searchAsYouSpeak: !1,
    buttonTextComponent: function (e) {
      var t = e.status,
        n = e.errorCode,
        e = e.isListening;
      return "error" === t && "not-allowed" === n ? Vs : P.createElement(Fs, null, P.createElement("path", {
        d: "M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3z",
        fill: e ? "currentColor" : ""
      }), Is, _s, Ts);
    },
    statusComponent: function (e) {
      e = e.transcript;
      return P.createElement("p", null, e);
    }
  });
  function As(e) {
    var t = e.items,
      n = e.className,
      e = e.children;
    return P.createElement("div", {
      className: T(Ms(""), n)
    }, e({
      items: t
    }));
  }
  var b = b(n({
      buttonTitle: "Search by voice",
      disabledButtonTitle: "Search by voice (not supported on this browser)"
    })(ks), {
      $$widgetType: "ais.voiceSearch"
    }),
    Ms = I("QueryRuleCustomData"),
    ks = En(function (e) {
      return P.createElement(k, e, P.createElement(As, e));
    }, {
      $$widgetType: "ais.queryRuleCustomData"
    });
  function Ds(i, a) {
    var o = null;
    return function () {
      for (var e = arguments.length, n = new Array(e), t = 0; t < e; t++) n[t] = arguments[t];
      var r = this;
      return new Promise(function (e, t) {
        o && clearTimeout(o), o = setTimeout(function () {
          o = null, Promise.resolve(i.apply(r, n)).then(e).catch(t);
        }, a);
      });
    };
  }
  var Hs = ["searchClient", "queryLanguages", "attributesForPrediction", "nbHits", "renderDebounceTime", "searchDebounceTime"];
  function Ls(e) {
    var t = e.searchClient,
      n = e.queryLanguages,
      r = e.attributesForPrediction,
      i = e.nbHits,
      a = e.renderDebounceTime,
      o = void 0 === a ? 100 : a,
      a = e.searchDebounceTime,
      s = void 0 === a ? 100 : a,
      c = pn(e, Hs);
    if (e = (a = hn(P.version.split(".").map(Number), 2))[0], a = a[1], !(17 <= e || 16 === e && 8 <= a)) throw new Error("`Answers` component and `useAnswers` hook require all React packages to be 16.8.0 or higher.");
    var u,
      l,
      f = S.useContext(ne),
      e = hn(S.useState(f.store.getState().widgets.query), 2),
      m = e[0],
      p = e[1],
      a = hn(S.useState(f.mainTargetedIndex), 2),
      h = a[0],
      d = a[1],
      e = hn(S.useState(!1), 2),
      a = e[0],
      y = e[1],
      e = hn(S.useState([]), 2),
      g = e[0],
      v = e[1],
      b = S.useMemo(function () {
        return r = n = -1, i = void 0, function (e) {
          var t = ++n;
          return Promise.resolve(e).then(function (e) {
            return i && t < r ? i : (r = t, i = e);
          });
        };
        var n, r, i;
      }, []),
      x = S.useMemo(function () {
        return t.initIndex(h);
      }, [t, h]);
    if (x.findAnswers) return u = S.useMemo(function () {
      return Ds(x.findAnswers, s);
    }, [x]), S.useEffect(function () {
      return d(f.mainTargetedIndex), f.store.subscribe(function () {
        var e = f.store.getState().widgets;
        p(e.query);
      });
    }, [f]), l = S.useMemo(function () {
      return Ds(function (e) {
        y(!1), v(e.hits);
      }, o);
    }, [y, v]), S.useEffect(function () {
      m ? (y(!0), b(u(m, n, R(R({}, c), {}, {
        nbHits: i,
        attributesForPrediction: r
      }))).then(function (e) {
        e && l(e);
      })) : (y(!1), v([]));
    }, [m]), {
      hits: g,
      isLoading: a
    };
    throw new Error("`Answers` component and `useAnswers` hook require `algoliasearch` to be 4.8.0 or higher.");
  }
  var $s = ["searchClient", "queryLanguages", "attributesForPrediction", "nbHits", "renderDebounceTime", "searchDebounceTime", "answersComponent"],
    Bs = I("Answers");
  function Qs(e) {
    var t = e.isLoading,
      e = e.hits;
    return P.createElement("div", {
      className: Bs("", 0 === e.length && "-empty")
    }, P.createElement("div", {
      className: Bs("header")
    }), t ? P.createElement("div", {
      className: Bs("loader")
    }) : P.createElement("ul", {
      className: Bs("list")
    }, e.map(function (e, t) {
      return P.createElement("li", {
        key: t,
        className: Bs("item")
      }, JSON.stringify(e));
    })));
  }
  var qs = ["children", "className"],
    Us = I("DynamicWidgets");
  function Ws(e) {
    var t = e.children,
      n = e.className,
      e = pn(e, qs);
    return P.createElement("div", {
      className: T(Us(""), n)
    }, P.createElement(Rn, e, t));
  }
  var zs = ["page"];
  function Ys(e) {
    e = e || {};
    e.page;
    return pn(e, zs);
  }
  var Js = "ais.infiniteHits";
  function Zs() {
    return "undefined" != typeof window && void 0 !== window.sessionStorage;
  }
  var Ks = Ws;
  e.Breadcrumb = fo, e.ClearRefinements = ho, e.Configure = Qe, e.CurrentRefinements = xo, e.DynamicWidgets = Ws, e.EXPERIMENTAL_Answers = function (e) {
    var t = e.searchClient,
      n = e.queryLanguages,
      r = e.attributesForPrediction,
      i = e.nbHits,
      a = e.renderDebounceTime,
      o = e.searchDebounceTime,
      s = void 0 === (s = e.answersComponent) ? Qs : s,
      n = (t = Ls(R({
        searchClient: t,
        queryLanguages: n,
        attributesForPrediction: r,
        nbHits: void 0 === i ? 1 : i,
        renderDebounceTime: a,
        searchDebounceTime: o
      }, pn(e, $s)))).hits,
      r = t.isLoading;
    return P.createElement(s, {
      hits: n,
      isLoading: r
    });
  }, e.EXPERIMENTAL_connectConfigureRelatedItems = qe, e.EXPERIMENTAL_connectDynamicWidgets = Ja, e.EXPERIMENTAL_useAnswers = Ls, e.ExperimentalConfigureRelatedItems = f, e.ExperimentalDynamicWidgets = Ks, e.HIGHLIGHT_TAGS = xe, e.HierarchicalMenu = wo, e.Highlight = _o, e.Hits = Ro, e.HitsPerPage = Po, e.Index = function (t) {
    var n = t.indexName;
    return P.createElement(re, null, function (e) {
      return P.createElement(Ln, Vn({
        contextValue: e,
        indexId: n
      }, t));
    });
  }, e.InfiniteHits = Oo, e.InstantSearch = dr, e.Menu = _, e.MenuSelect = $o, e.NumericMenu = qo, e.Pagination = Wo, e.Panel = ao, e.PoweredBy = Go, e.QueryRuleContext = Fn, e.QueryRuleCustomData = ks, e.RangeInput = is, e.RangeSlider = function () {
    return os;
  }, e.RatingMenu = ls, e.RefinementList = ps, e.RelevantSort = Ss, e.ScrollTo = ys, e.SearchBox = gs, e.Snippet = bs, e.SortBy = ws, e.Stats = Os, e.ToggleRefinement = Cs, e.VoiceSearch = b, e.connectAutoComplete = Pr, e.connectBreadcrumb = jr, e.connectConfigure = ae, e.connectCurrentRefinements = Nr, e.connectDynamicWidgets = a, e.connectGeoSearch = $r, e.connectHierarchicalMenu = ei, e.connectHighlight = ti, e.connectHitInsights = function (r) {
    return t({
      displayName: "AlgoliaInsights",
      $$type: "ais.insights",
      getProvidedProps: function (e, t, n) {
        n = d(n, {
          ais: e.contextValue,
          multiIndexContext: e.indexContextValue
        });
        return {
          insights: La(r, n, e.hit)
        };
      }
    });
  }, e.connectHits = ni, e.connectHitsPerPage = ui, e.connectInfiniteHits = gi, e.connectMenu = Ci, e.connectNumericMenu = Mi, e.connectPagination = Bi, e.connectPoweredBy = Qi, e.connectQueryRules = En, e.connectRange = Gi, e.connectRefinementList = ca, e.connectRelevantSort = ba, e.connectScrollTo = ua, e.connectSearchBox = da, e.connectSortBy = ja, e.connectStateResults = Ca, e.connectStats = Ea, e.connectToggleRefinement = Aa, e.createClassNames = I, e.createConnector = t, e.createInfiniteHitsSessionStorageCache = function () {
    return {
      read: function (e) {
        e = e.state;
        if (!Zs()) return null;
        try {
          var t = JSON.parse(window.sessionStorage.getItem(Js));
          return t && L(t.state, Ys(e)) ? t.hits : null;
        } catch (e) {
          if (e instanceof SyntaxError) try {
            window.sessionStorage.removeItem(Js);
          } catch (e) {}
          return null;
        }
      },
      write: function (e) {
        var t = e.state,
          e = e.hits;
        if (Zs()) try {
          window.sessionStorage.setItem(Js, JSON.stringify({
            state: Ys(t),
            hits: e
          }));
        } catch (e) {}
      }
    };
  }, e.createVoiceSearchHelper = Es, e.getInsightsAnonymousUserToken = function () {
    for (var e = "_ALGOLIA", t = "".concat(e, "="), n = document.cookie.split(";"), r = 0; r < n.length; r++) {
      for (var i = n[r]; " " === i.charAt(0);) i = i.substring(1);
      if (0 === i.indexOf(t)) return i.substring(t.length, i.length);
    }
  }, e.translatable = n, Object.defineProperty(e, "__esModule", {
    value: !0
  });
});
const {
  InstantSearch,
  SearchBox,
  Highlight,
  Configure,
  SortBy,
  connectRange,
  RangeInput,
  connectRefinementList,
  connectInfiniteHits,
  connectCurrentRefinements,
  ClearRefinements,
  connectAutoComplete,
  Index,
  connectSearchBox
} = ReactInstantSearchDOM;
const APPLICATION_ID = "35RQENUZNB";
const API_KEY = "b7c2503191bc928ac947acc0b5815029";
const INDEX_NAME = "a_products";
const searchClient = algoliasearch(APPLICATION_ID, API_KEY);
aa('init', {
  appId: APPLICATION_ID,
  apiKey: API_KEY,
  useCookie: true
});
aa('onUserTokenChange', userToken => {
  window.dataLayer.push({
    algoliaUserToken: userToken
  });
}, {
  immediate: true
});
const CustomizedCurrentRefinements = props => {
  return /*#__PURE__*/React.createElement("ul", {
    className: "refinements"
  }, props.items.map(item => /*#__PURE__*/React.createElement("li", {
    key: item.label
  }, item.items ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("ul", {
    className: "activeFilter"
  }, item.items.map(nested => /*#__PURE__*/React.createElement("li", {
    key: nested.label,
    className: "activeFilterOption"
  }, /*#__PURE__*/React.createElement("a", {
    href: "#",
    onClick: event => {
      event.preventDefault();
      props.refine(nested.value);
    }
  }, nested.label, " ", /*#__PURE__*/React.createElement("span", null, " x ")))))) : /*#__PURE__*/React.createElement("a", {
    className: "activeFilterOption priceFilter",
    href: "#",
    onClick: event => {
      event.preventDefault();
      props.refine(item.value);
    }
  }, item.label))));
};
const CustomCurrentRefinements = connectCurrentRefinements(CustomizedCurrentRefinements);
const InfiniteHits = props => {
  const hits = props.hits;
  const hasMore = props.hasMore;
  const windowWidth = props.windowWidth;
  const sentinel = React.useRef();
  const formHandler = id => {
    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['openForm', id]);
  };
  onSentinelIntersection = entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting && hasMore) {
        props.refineNext();
      }
    });
  };
  React.useEffect(() => {
    if (sentinel.current) {
      let observer = new IntersectionObserver(onSentinelIntersection);
      observer.observe(sentinel.current);
      return () => observer.disconnect();
    }
  }, [props]);
  // location.pathname.includes("train-like-a-freak")
  if (location.pathname.includes("train-like-a-freak")) {
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
      className: "ais-InfiniteHits minHeight"
    }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("ul", {
      className: "ais-InfiniteHits-list"
    }, hits.slice(0, 4).map(hit => /*#__PURE__*/React.createElement("li", {
      key: hit.objectID,
      className: "ais-InfiniteHits-item"
    }, /*#__PURE__*/React.createElement(ReactProductCard, {
      hit: hit,
      windowWidth: windowWidth
    }))), "  "), /*#__PURE__*/React.createElement(UnifiedBanner, {
      isVideo: true,
      type: "hero",
      deadline: "2024-12-25T00:00:00",
      currentDesktopSrc: "https://cdn.shopify.com/videos/c/o/v/2a54d453001e4ef0b1c473d01204e0ca.mp4",
      scheduledDesktopSrc: "https://cdn.shopify.com/videos/c/o/v/2a54d453001e4ef0b1c473d01204e0ca.mp4",
      currentMobileSrc: "https://cdn.shopify.com/videos/c/o/v/dea8a669a6724e9380c9c887419a2cb8.mp4",
      scheduledMobileSrc: "https://cdn.shopify.com/videos/c/o/v/dea8a669a6724e9380c9c887419a2cb8.mp4",
      currentDesktopPoster: "https://cdn.shopify.com/s/files/1/2665/0346/files/preview_images/2a54d453001e4ef0b1c473d01204e0ca.thumbnail.0000000000.jpg?v=1708035039",
      scheduledDesktopPoster: "https://cdn.shopify.com/s/files/1/2665/0346/files/preview_images/2a54d453001e4ef0b1c473d01204e0ca.thumbnail.0000000000.jpg?v=1708035039",
      currentMobilePoster: "https://cdn.shopify.com/s/files/1/2665/0346/files/preview_images/dea8a669a6724e9380c9c887419a2cb8.thumbnail.0000000000.jpg?v=1708035034",
      scheduledMobilePoster: "https://cdn.shopify.com/s/files/1/2665/0346/files/preview_images/dea8a669a6724e9380c9c887419a2cb8.thumbnail.0000000000.jpg?v=1708035034"
    }), /*#__PURE__*/React.createElement("div", {
      className: "divider"
    }), /*#__PURE__*/React.createElement("ul", {
      className: "ais-InfiniteHits-list"
    }, hits.slice(4, 8).map(hit => /*#__PURE__*/React.createElement("li", {
      key: hit.objectID,
      className: "ais-InfiniteHits-item"
    }, /*#__PURE__*/React.createElement(ReactProductCard, {
      hit: hit,
      windowWidth: windowWidth
    }))), "  "), /*#__PURE__*/React.createElement("img", {
      className: "hideonDesktop",
      alt: "Promotion Banner",
      src: "https://cdn.shopify.com/s/files/1/2665/0346/files/2024-0216_LP-Collection_TLAF-01_Mobile.gif?v=1708026512"
    }), /*#__PURE__*/React.createElement("div", {
      className: "doubleBanner hideonMobile"
    }, /*#__PURE__*/React.createElement("div", {
      className: "squareBanner-left"
    }, /*#__PURE__*/React.createElement("img", {
      alt: "Promotion Banner",
      src: "https://cdn.shopify.com/s/files/1/2665/0346/files/2024-0216_LP-Collection_TLAF-01_Desktop.jpg?v=1708026498"
    })), /*#__PURE__*/React.createElement("div", {
      className: "miniDivider hideonDesktop"
    }), /*#__PURE__*/React.createElement("div", {
      className: "squareBanner-right"
    }, /*#__PURE__*/React.createElement("img", {
      alt: "Promotion Banner",
      src: "https://cdn.shopify.com/s/files/1/2665/0346/files/2024-0216_LP-Collection_TLAF-02_Desktop.jpg?v=1708026498"
    }))), /*#__PURE__*/React.createElement("div", {
      className: "divider"
    }), /*#__PURE__*/React.createElement("ul", {
      className: "ais-InfiniteHits-list"
    }, hits.slice(8, 12).map(hit => /*#__PURE__*/React.createElement("li", {
      key: hit.objectID,
      className: "ais-InfiniteHits-item"
    }, /*#__PURE__*/React.createElement(ReactProductCard, {
      hit: hit,
      windowWidth: windowWidth
    }))), "  "), /*#__PURE__*/React.createElement("img", {
      className: "hideonDesktop",
      alt: "Promotion Banner",
      src: "https://cdn.shopify.com/s/files/1/2665/0346/files/2024-0216_LP-Collection_TLAF-02_Mobile.jpg?v=1708026512"
    }), /*#__PURE__*/React.createElement("img", {
      className: "hideonMobile",
      alt: "Promotion Banner",
      src: "https://cdn.shopify.com/s/files/1/2665/0346/files/2024-0216_LP-Collection_TLAF-03_Desktop.jpg?v=1708026498"
    }), /*#__PURE__*/React.createElement("div", {
      className: "divider"
    }), /*#__PURE__*/React.createElement("ul", {
      className: "ais-InfiniteHits-list"
    }, hits.slice(12, 16).map(hit => /*#__PURE__*/React.createElement("li", {
      key: hit.objectID,
      className: "ais-InfiniteHits-item"
    }, /*#__PURE__*/React.createElement(ReactProductCard, {
      hit: hit,
      windowWidth: windowWidth
    }))), "  "), /*#__PURE__*/React.createElement("img", {
      className: "hideonDesktop",
      alt: "Promotion Banner",
      src: "https://cdn.shopify.com/s/files/1/2665/0346/files/2024-0216_LP-Collection_TLAF-03_Mobile.jpg?v=1708026512"
    }), /*#__PURE__*/React.createElement("img", {
      className: "hideonMobile",
      alt: "Promotion Banner",
      src: "https://cdn.shopify.com/s/files/1/2665/0346/files/2024-0216_LP-Collection_TLAF-04_Desktop.jpg?v=1708026498"
    }), /*#__PURE__*/React.createElement("div", {
      className: "divider"
    }), /*#__PURE__*/React.createElement("ul", {
      className: "ais-InfiniteHits-list"
    }, hits.slice(16).map(hit => /*#__PURE__*/React.createElement("li", {
      key: hit.objectID,
      className: "ais-InfiniteHits-item"
    }, /*#__PURE__*/React.createElement(ReactProductCard, {
      hit: hit,
      windowWidth: windowWidth
    }))), /*#__PURE__*/React.createElement("li", {
      className: "ais-InfiniteHits-sentinel",
      ref: sentinel
    })))));
  } else if (location.pathname.includes("womens-coming-soon")) {
    return /*#__PURE__*/React.createElement("div", {
      className: "ais-InfiniteHits minHeight"
    }, /*#__PURE__*/React.createElement("ul", {
      className: "ais-InfiniteHits-list"
    }, hits.slice(0, 4).map(hit => /*#__PURE__*/React.createElement("li", {
      key: hit.objectID,
      className: "ais-InfiniteHits-item"
    }, /*#__PURE__*/React.createElement(ReactProductCard, {
      hit: hit,
      windowWidth: windowWidth
    }))), "  "), /*#__PURE__*/React.createElement("div", {
      onClick: () => formHandler('WQzwD7'),
      style: {
        cursor: "pointer"
      }
    }, /*#__PURE__*/React.createElement(UnifiedBanner, {
      isVideo: false,
      type: "hero",
      deadline: "2024-12-25T00:00:00",
      currentDesktopSrc: "https://cdn.shopify.com/s/files/1/2665/0346/files/2024-0409_CS-Banner_HP_Desktop.jpg?v=1712679288",
      scheduledDesktopSrc: "https://cdn.shopify.com/s/files/1/2665/0346/files/2024-0409_CS-Banner_HP_Desktop.jpg?v=1712679288",
      currentMobileSrc: "https://cdn.shopify.com/s/files/1/2665/0346/files/2024-0409_CS-Banner_HP_Mobile.jpg?v=1712679288",
      scheduledMobileSrc: "https://cdn.shopify.com/s/files/1/2665/0346/files/2024-0409_CS-Banner_HP_Mobile.jpg?v=1712679288",
      currentDesktopPoster: "https://cdn.shopify.com/s/files/1/2665/0346/files/2024-0409_CS-Banner_HP_Desktop.jpg?v=1712679288",
      scheduledDesktopPoster: "https://cdn.shopify.com/s/files/1/2665/0346/files/2024-0409_CS-Banner_HP_Desktop.jpg?v=1712679288",
      currentMobilePoster: "https://cdn.shopify.com/s/files/1/2665/0346/files/2024-0409_CS-Banner_HP_Mobile.jpg?v=1712679288",
      scheduledMobilePoster: "https://cdn.shopify.com/s/files/1/2665/0346/files/2024-0409_CS-Banner_HP_Mobile.jpg?v=1712679288"
    }, /*#__PURE__*/React.createElement("div", {
      className: "unified-banner-caption"
    }, "Tap Into Your Hyper-Power", /*#__PURE__*/React.createElement("h5", null, "Available Sitewide 04.25.24")), /*#__PURE__*/React.createElement("div", {
      className: "unified-banner-buttons-container"
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        width: "200px",
        margin: "auto"
      },
      className: "tlf-banner-buttons"
    }, "SIGN-UP NOW")))), /*#__PURE__*/React.createElement("div", {
      className: "divider"
    }));
  } else if (location.pathname.includes("dustin-poirier")) {
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
      className: "ais-InfiniteHits minHeight"
    }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("ul", {
      className: "ais-InfiniteHits-list"
    }, hits.slice(0, 4).map(hit => /*#__PURE__*/React.createElement("li", {
      key: hit.objectID,
      className: "ais-InfiniteHits-item"
    }, /*#__PURE__*/React.createElement(ReactProductCard, {
      hit: hit,
      windowWidth: windowWidth
    }))), "  "), /*#__PURE__*/React.createElement(UnifiedBanner, {
      isVideo: true,
      type: "hero",
      deadline: "2024-12-25T00:00:00",
      currentDesktopSrc: "https://cdn.shopify.com/videos/c/o/v/d5bccd205fa74d59ae273092233d1fa8.mp4",
      scheduledDesktopSrc: "https://cdn.shopify.com/videos/c/o/v/d5bccd205fa74d59ae273092233d1fa8.mp4",
      currentMobileSrc: "https://cdn.shopify.com/videos/c/o/v/67c98c1370994c17a87bd70ca49a2a6e.mp4",
      scheduledMobileSrc: "https://cdn.shopify.com/videos/c/o/v/67c98c1370994c17a87bd70ca49a2a6e.mp4",
      currentDesktopPoster: "https://cdn.shopify.com/s/files/1/2665/0346/files/preview_images/d5bccd205fa74d59ae273092233d1fa8.thumbnail.0000000000.jpg?v=1710338254",
      scheduledDesktopPoster: "https://cdn.shopify.com/s/files/1/2665/0346/files/preview_images/d5bccd205fa74d59ae273092233d1fa8.thumbnail.0000000000.jpg?v=1710338254",
      currentMobilePoster: "https://cdn.shopify.com/s/files/1/2665/0346/files/preview_images/67c98c1370994c17a87bd70ca49a2a6e.thumbnail.0000000000.jpg?v=1710338249",
      scheduledMobilePoster: "https://cdn.shopify.com/s/files/1/2665/0346/files/preview_images/67c98c1370994c17a87bd70ca49a2a6e.thumbnail.0000000000.jpg?v=1710338249"
    }), /*#__PURE__*/React.createElement("div", {
      className: "divider"
    }), /*#__PURE__*/React.createElement("ul", {
      className: "ais-InfiniteHits-list"
    }, hits.slice(4, 8).map(hit => /*#__PURE__*/React.createElement("li", {
      key: hit.objectID,
      className: "ais-InfiniteHits-item"
    }, /*#__PURE__*/React.createElement(ReactProductCard, {
      hit: hit,
      windowWidth: windowWidth
    }))), "  "), /*#__PURE__*/React.createElement("img", {
      className: "hideonDesktop",
      alt: "Promotion Banner",
      src: "https://cdn.shopify.com/s/files/1/2665/0346/files/2024-0301_LP-Collection_DP-01_Mobile.gif?v=1709237726"
    }), /*#__PURE__*/React.createElement("div", {
      className: "doubleBanner hideonMobile"
    }, /*#__PURE__*/React.createElement("div", {
      className: "squareBanner-left"
    }, /*#__PURE__*/React.createElement("img", {
      alt: "Promotion Banner",
      src: "https://cdn.shopify.com/s/files/1/2665/0346/files/2024-0301_LP-Collection_DP-01_Desktop.jpg?v=1709236348"
    })), /*#__PURE__*/React.createElement("div", {
      className: "miniDivider hideonDesktop"
    }), /*#__PURE__*/React.createElement("div", {
      className: "squareBanner-right"
    }, /*#__PURE__*/React.createElement("img", {
      alt: "Promotion Banner",
      src: "https://cdn.shopify.com/s/files/1/2665/0346/files/2024-0301_LP-Collection_DP-02_Desktop.jpg?v=1709236348"
    }))), /*#__PURE__*/React.createElement("div", {
      className: "divider"
    }), /*#__PURE__*/React.createElement("ul", {
      className: "ais-InfiniteHits-list"
    }, hits.slice(8, 12).map(hit => /*#__PURE__*/React.createElement("li", {
      key: hit.objectID,
      className: "ais-InfiniteHits-item"
    }, /*#__PURE__*/React.createElement(ReactProductCard, {
      hit: hit,
      windowWidth: windowWidth
    }))), "  "), /*#__PURE__*/React.createElement("img", {
      className: "hideonDesktop",
      alt: "Promotion Banner",
      src: "https://cdn.shopify.com/s/files/1/2665/0346/files/2024-0301_LP-Collection_DP-02_Mobile.jpg?v=1709237726"
    }), /*#__PURE__*/React.createElement("img", {
      className: "hideonMobile",
      alt: "Promotion Banner",
      src: "https://cdn.shopify.com/s/files/1/2665/0346/files/2024-0301_LP-Collection_DP-03_Desktop.jpg?v=1709236348"
    }), /*#__PURE__*/React.createElement("div", {
      className: "divider"
    }), /*#__PURE__*/React.createElement("ul", {
      className: "ais-InfiniteHits-list"
    }, hits.slice(12, 16).map(hit => /*#__PURE__*/React.createElement("li", {
      key: hit.objectID,
      className: "ais-InfiniteHits-item"
    }, /*#__PURE__*/React.createElement(ReactProductCard, {
      hit: hit,
      windowWidth: windowWidth
    }))), "  "), /*#__PURE__*/React.createElement("img", {
      className: "hideonDesktop",
      alt: "Promotion Banner",
      src: "https://cdn.shopify.com/s/files/1/2665/0346/files/2024-0301_LP-Collection_DP-03_Mobile.jpg?v=1709237726"
    }), /*#__PURE__*/React.createElement("img", {
      className: "hideonMobile",
      alt: "Promotion Banner",
      src: "https://cdn.shopify.com/s/files/1/2665/0346/files/2024-0301_LP-Collection_DP-04_Desktop.jpg?v=1709236348"
    }), /*#__PURE__*/React.createElement("div", {
      className: "divider"
    }), /*#__PURE__*/React.createElement("ul", {
      className: "ais-InfiniteHits-list"
    }, hits.slice(16).map(hit => /*#__PURE__*/React.createElement("li", {
      key: hit.objectID,
      className: "ais-InfiniteHits-item"
    }, /*#__PURE__*/React.createElement(ReactProductCard, {
      hit: hit,
      windowWidth: windowWidth
    }))), /*#__PURE__*/React.createElement("li", {
      className: "ais-InfiniteHits-sentinel",
      ref: sentinel
    })))));
  } else if (location.pathname.includes("mens-coming-soon")) {
    return /*#__PURE__*/React.createElement("div", {
      className: "ais-InfiniteHits minHeight"
    }, /*#__PURE__*/React.createElement("ul", {
      className: "ais-InfiniteHits-list"
    }, hits.slice(0, 4).map(hit => /*#__PURE__*/React.createElement("li", {
      key: hit.objectID,
      className: "ais-InfiniteHits-item"
    }, /*#__PURE__*/React.createElement(ReactProductCard, {
      hit: hit,
      windowWidth: windowWidth
    }))), "  "), /*#__PURE__*/React.createElement("div", {
      onClick: () => formHandler('WxUrar'),
      style: {
        cursor: "pointer"
      }
    }, /*#__PURE__*/React.createElement(UnifiedBanner, {
      isVideo: true,
      type: "hero",
      deadline: "2024-12-25T00:00:00",
      currentDesktopSrc: "https://cdn.shopify.com/videos/c/o/v/1aea124e9d284a288bf05501f77f86cc.mp4",
      scheduledDesktopSrc: "https://cdn.shopify.com/videos/c/o/v/1aea124e9d284a288bf05501f77f86cc.mp4",
      currentMobileSrc: "https://cdn.shopify.com/videos/c/o/v/21ecbf125bce4934bce81f962d50035a.mp4",
      scheduledMobileSrc: "https://cdn.shopify.com/videos/c/o/v/21ecbf125bce4934bce81f962d50035a.mp4",
      currentDesktopPoster: "https://cdn.shopify.com/s/files/1/2665/0346/files/preview_images/1aea124e9d284a288bf05501f77f86cc.thumbnail.0000000000.jpg?v=1709322105",
      scheduledDesktopPoster: "https://cdn.shopify.com/s/files/1/2665/0346/files/preview_images/1aea124e9d284a288bf05501f77f86cc.thumbnail.0000000000.jpg?v=1709322105",
      currentMobilePoster: "https://cdn.shopify.com/s/files/1/2665/0346/files/preview_images/21ecbf125bce4934bce81f962d50035a.thumbnail.0000000000.jpg?v=1709322466",
      scheduledMobilePoster: "https://cdn.shopify.com/s/files/1/2665/0346/files/preview_images/21ecbf125bce4934bce81f962d50035a.thumbnail.0000000000.jpg?v=1709322466"
    }, /*#__PURE__*/React.createElement("div", {
      className: "unified-banner-caption"
    }, "Coming Soon", /*#__PURE__*/React.createElement("h5", null, "Available Sitewide 03.28.24")), /*#__PURE__*/React.createElement("div", {
      className: "unified-banner-buttons-container"
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        width: "200px",
        margin: "auto"
      },
      className: "tlf-banner-buttons"
    }, "SIGN UP NOW")))), /*#__PURE__*/React.createElement("div", {
      className: "divider"
    }));
  } else if (location.pathname.includes("womens-seamless-collection")) {
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
      className: "ais-InfiniteHits minHeight"
    }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("ul", {
      className: "ais-InfiniteHits-list"
    }, hits.slice(0, 4).map(hit => /*#__PURE__*/React.createElement("li", {
      key: hit.objectID,
      className: "ais-InfiniteHits-item"
    }, /*#__PURE__*/React.createElement(ReactProductCard, {
      hit: hit,
      windowWidth: windowWidth
    }))), "  "), /*#__PURE__*/React.createElement(UnifiedBanner, {
      isVideo: true,
      type: "hero",
      deadline: "2024-12-25T00:00:00",
      currentDesktopSrc: "https://cdn.shopify.com/videos/c/o/v/6ae65509113a4d719928f609c7773362.mp4",
      scheduledDesktopSrc: "https://cdn.shopify.com/videos/c/o/v/6ae65509113a4d719928f609c7773362.mp4",
      currentMobileSrc: "https://cdn.shopify.com/videos/c/o/v/e840c97ae51e4ff886c3a511b4441e00.mp4",
      scheduledMobileSrc: "https://cdn.shopify.com/videos/c/o/v/e840c97ae51e4ff886c3a511b4441e00.mp4",
      currentDesktopPoster: "https://cdn.shopify.com/s/files/1/2665/0346/files/preview_images/6ae65509113a4d719928f609c7773362.thumbnail.0000000000.jpg?v=1709912821",
      scheduledDesktopPoster: "https://cdn.shopify.com/s/files/1/2665/0346/files/preview_images/6ae65509113a4d719928f609c7773362.thumbnail.0000000000.jpg?v=1709912821",
      currentMobilePoster: "https://cdn.shopify.com/s/files/1/2665/0346/files/preview_images/e840c97ae51e4ff886c3a511b4441e00.thumbnail.0000000000.jpg?v=1709912816",
      scheduledMobilePoster: "https://cdn.shopify.com/s/files/1/2665/0346/files/preview_images/e840c97ae51e4ff886c3a511b4441e00.thumbnail.0000000000.jpg?v=1709912816"
    }), /*#__PURE__*/React.createElement("div", {
      className: "divider"
    }), /*#__PURE__*/React.createElement("ul", {
      className: "ais-InfiniteHits-list"
    }, hits.slice(4, 8).map(hit => /*#__PURE__*/React.createElement("li", {
      key: hit.objectID,
      className: "ais-InfiniteHits-item"
    }, /*#__PURE__*/React.createElement(ReactProductCard, {
      hit: hit,
      windowWidth: windowWidth
    }))), "  "), /*#__PURE__*/React.createElement("img", {
      className: "hideonDesktop",
      alt: "Promotion Banner",
      src: "https://cdn.shopify.com/s/files/1/2665/0346/files/2024-0308_LP-Collection_01-Cosmic_Mobile.jpg?v=1709825674"
    }), /*#__PURE__*/React.createElement("img", {
      className: "hideonMobile",
      alt: "Promotion Banner",
      src: "https://cdn.shopify.com/s/files/1/2665/0346/files/2024-0308_LP-Collection_01-Cosmic_Desktop.jpg?v=1709825659"
    }), /*#__PURE__*/React.createElement("div", {
      className: "divider"
    }), /*#__PURE__*/React.createElement("ul", {
      className: "ais-InfiniteHits-list"
    }, hits.slice(8, 12).map(hit => /*#__PURE__*/React.createElement("li", {
      key: hit.objectID,
      className: "ais-InfiniteHits-item"
    }, /*#__PURE__*/React.createElement(ReactProductCard, {
      hit: hit,
      windowWidth: windowWidth
    }))), "  "), /*#__PURE__*/React.createElement("img", {
      className: "hideonDesktop",
      alt: "Promotion Banner",
      src: "https://cdn.shopify.com/s/files/1/2665/0346/files/2024-0308_LP-Collection_02_Cosmic_Mobile.gif?v=1709825673"
    }), /*#__PURE__*/React.createElement("div", {
      className: "doubleBanner hideonMobile"
    }, /*#__PURE__*/React.createElement("div", {
      className: "squareBanner-left"
    }, /*#__PURE__*/React.createElement("img", {
      alt: "Promotion Banner",
      src: "https://cdn.shopify.com/s/files/1/2665/0346/files/2024-0308_LP-Collection_02-Cosmic_Desktop.jpg?v=1709825658"
    })), /*#__PURE__*/React.createElement("div", {
      className: "miniDivider hideonDesktop"
    }), /*#__PURE__*/React.createElement("div", {
      className: "squareBanner-right"
    }, /*#__PURE__*/React.createElement("img", {
      alt: "Promotion Banner",
      src: "https://cdn.shopify.com/s/files/1/2665/0346/files/2024-0308_LP-Collection_03-Sculpt_Desktop.jpg?v=1709825658"
    }))), /*#__PURE__*/React.createElement("div", {
      className: "divider"
    }), /*#__PURE__*/React.createElement("ul", {
      className: "ais-InfiniteHits-list"
    }, hits.slice(12, 16).map(hit => /*#__PURE__*/React.createElement("li", {
      key: hit.objectID,
      className: "ais-InfiniteHits-item"
    }, /*#__PURE__*/React.createElement(ReactProductCard, {
      hit: hit,
      windowWidth: windowWidth
    }))), "  "), /*#__PURE__*/React.createElement("img", {
      className: "hideonDesktop",
      alt: "Promotion Banner",
      src: "https://cdn.shopify.com/s/files/1/2665/0346/files/2024-0308_LP-Collection_03-Cosmic_Mobile.jpg?v=1709825673"
    }), /*#__PURE__*/React.createElement("img", {
      className: "hideonMobile",
      alt: "Promotion Banner",
      src: "https://cdn.shopify.com/s/files/1/2665/0346/files/2024-0308_LP-Collection_04-Sculpt_Desktop.jpg?v=1709825658"
    }), /*#__PURE__*/React.createElement("div", {
      className: "divider"
    }), /*#__PURE__*/React.createElement("ul", {
      className: "ais-InfiniteHits-list"
    }, hits.slice(16).map(hit => /*#__PURE__*/React.createElement("li", {
      key: hit.objectID,
      className: "ais-InfiniteHits-item"
    }, /*#__PURE__*/React.createElement(ReactProductCard, {
      hit: hit,
      windowWidth: windowWidth
    }))), /*#__PURE__*/React.createElement("li", {
      className: "ais-InfiniteHits-sentinel",
      ref: sentinel
    })), /*#__PURE__*/React.createElement("div", {
      className: "divider"
    }))));
  } else if (location.pathname.includes("women-hyper-power-collection")) {
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
      className: "ais-InfiniteHits minHeight"
    }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("ul", {
      className: "ais-InfiniteHits-list"
    }, hits.slice(0, 4).map(hit => /*#__PURE__*/React.createElement("li", {
      key: hit.objectID,
      className: "ais-InfiniteHits-item"
    }, /*#__PURE__*/React.createElement(ReactProductCard, {
      hit: hit,
      windowWidth: windowWidth
    }))), "  "), /*#__PURE__*/React.createElement(UnifiedBanner, {
      isVideo: true,
      type: "hero",
      deadline: "2024-12-25T00:00:00",
      currentDesktopSrc: "https://cdn.shopify.com/videos/c/o/v/19278a39b0d744038266059650648ab2.mp4",
      scheduledDesktopSrc: "https://cdn.shopify.com/videos/c/o/v/19278a39b0d744038266059650648ab2.mp4",
      currentMobileSrc: "https://cdn.shopify.com/videos/c/o/v/ab299e7058b3425dbbf1ecdf429b05d7.mp4",
      scheduledMobileSrc: "https://cdn.shopify.com/videos/c/o/v/ab299e7058b3425dbbf1ecdf429b05d7.mp4",
      currentDesktopPoster: "https://cdn.shopify.com/s/files/1/2665/0346/files/preview_images/19278a39b0d744038266059650648ab2.thumbnail.0000000000.jpg?v=1713205250",
      scheduledDesktopPoster: "https://cdn.shopify.com/s/files/1/2665/0346/files/preview_images/19278a39b0d744038266059650648ab2.thumbnail.0000000000.jpg?v=1713205250",
      currentMobilePoster: "https://cdn.shopify.com/s/files/1/2665/0346/files/preview_images/ab299e7058b3425dbbf1ecdf429b05d7.thumbnail.0000000000.jpg?v=1713205245",
      scheduledMobilePoster: "https://cdn.shopify.com/s/files/1/2665/0346/files/preview_images/ab299e7058b3425dbbf1ecdf429b05d7.thumbnail.0000000000.jpg?v=1713205245"
    }), /*#__PURE__*/React.createElement("div", {
      className: "divider"
    }), /*#__PURE__*/React.createElement("ul", {
      className: "ais-InfiniteHits-list"
    }, hits.slice(4, 8).map(hit => /*#__PURE__*/React.createElement("li", {
      key: hit.objectID,
      className: "ais-InfiniteHits-item"
    }, /*#__PURE__*/React.createElement(ReactProductCard, {
      hit: hit,
      windowWidth: windowWidth
    }))), "  "), /*#__PURE__*/React.createElement("img", {
      className: "hideonDesktop",
      alt: "Promotion Banner",
      src: "https://cdn.shopify.com/s/files/1/2665/0346/files/2024-0415_LP-Collection_01-W-HP_Mobile.jpg?v=1713195766"
    }), /*#__PURE__*/React.createElement("img", {
      className: "hideonMobile",
      alt: "Promotion Banner",
      src: "https://cdn.shopify.com/s/files/1/2665/0346/files/2024-0415_LP-Collection_01-W-HP_Desktop.jpg?v=1713195730"
    }), /*#__PURE__*/React.createElement("div", {
      className: "divider"
    }), /*#__PURE__*/React.createElement("ul", {
      className: "ais-InfiniteHits-list"
    }, hits.slice(8, 12).map(hit => /*#__PURE__*/React.createElement("li", {
      key: hit.objectID,
      className: "ais-InfiniteHits-item"
    }, /*#__PURE__*/React.createElement(ReactProductCard, {
      hit: hit,
      windowWidth: windowWidth
    }))), "  "), /*#__PURE__*/React.createElement("img", {
      className: "hideonDesktop",
      alt: "Promotion Banner",
      src: "https://cdn.shopify.com/s/files/1/2665/0346/files/2024-0321_LP-Collection_02_W-HP_GIF.gif?v=1713195766"
    }), /*#__PURE__*/React.createElement("div", {
      className: "doubleBanner hideonMobile"
    }, /*#__PURE__*/React.createElement("div", {
      className: "squareBanner-left"
    }, /*#__PURE__*/React.createElement("img", {
      alt: "Promotion Banner",
      src: "https://cdn.shopify.com/s/files/1/2665/0346/files/2024-0415_LP-Collection_02-W-HP_Desktop.jpg?v=1713195730"
    })), /*#__PURE__*/React.createElement("div", {
      className: "miniDivider hideonDesktop"
    }), /*#__PURE__*/React.createElement("div", {
      className: "squareBanner-right"
    }, /*#__PURE__*/React.createElement("img", {
      alt: "Promotion Banner",
      src: "https://cdn.shopify.com/s/files/1/2665/0346/files/2024-0415_LP-Collection_03-W-HP_Desktop.jpg?v=1713195731"
    }))), /*#__PURE__*/React.createElement("div", {
      className: "divider"
    }), /*#__PURE__*/React.createElement("ul", {
      className: "ais-InfiniteHits-list"
    }, hits.slice(12, 16).map(hit => /*#__PURE__*/React.createElement("li", {
      key: hit.objectID,
      className: "ais-InfiniteHits-item"
    }, /*#__PURE__*/React.createElement(ReactProductCard, {
      hit: hit,
      windowWidth: windowWidth
    }))), "  "), /*#__PURE__*/React.createElement("img", {
      className: "hideonDesktop",
      alt: "Promotion Banner",
      src: "https://cdn.shopify.com/s/files/1/2665/0346/files/2024-0415_LP-Collection_03-W-HP_Mobile_V2.jpg?v=1713364734"
    }), /*#__PURE__*/React.createElement("img", {
      className: "hideonMobile",
      alt: "Promotion Banner",
      src: "https://cdn.shopify.com/s/files/1/2665/0346/files/2024-0415_LP-Collection_04-W-HP_Desktop_V2.jpg?v=1713364734"
    }), /*#__PURE__*/React.createElement("div", {
      className: "divider"
    }), /*#__PURE__*/React.createElement("ul", {
      className: "ais-InfiniteHits-list"
    }, hits.slice(16).map(hit => /*#__PURE__*/React.createElement("li", {
      key: hit.objectID,
      className: "ais-InfiniteHits-item"
    }, /*#__PURE__*/React.createElement(ReactProductCard, {
      hit: hit,
      windowWidth: windowWidth
    }))), /*#__PURE__*/React.createElement("li", {
      className: "ais-InfiniteHits-sentinel",
      ref: sentinel
    })), /*#__PURE__*/React.createElement("div", {
      className: "divider"
    }))));
  } else if (location.pathname.includes("tlf-performance-collection")) {
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
      className: "ais-InfiniteHits minHeight"
    }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("ul", {
      className: "ais-InfiniteHits-list"
    }, hits.slice(0, 4).map(hit => /*#__PURE__*/React.createElement("li", {
      key: hit.objectID,
      className: "ais-InfiniteHits-item"
    }, /*#__PURE__*/React.createElement(ReactProductCard, {
      hit: hit,
      windowWidth: windowWidth
    }))), "  "), /*#__PURE__*/React.createElement(UnifiedBanner, {
      isVideo: true,
      type: "hero",
      deadline: "2024-12-25T00:00:00",
      currentDesktopSrc: "https://cdn.shopify.com/videos/c/o/v/d5bccd205fa74d59ae273092233d1fa8.mp4",
      scheduledDesktopSrc: "https://cdn.shopify.com/videos/c/o/v/d5bccd205fa74d59ae273092233d1fa8.mp4",
      currentMobileSrc: "https://cdn.shopify.com/videos/c/o/v/67c98c1370994c17a87bd70ca49a2a6e.mp4",
      scheduledMobileSrc: "https://cdn.shopify.com/videos/c/o/v/67c98c1370994c17a87bd70ca49a2a6e.mp4",
      currentDesktopPoster: "https://cdn.shopify.com/s/files/1/2665/0346/files/preview_images/d5bccd205fa74d59ae273092233d1fa8.thumbnail.0000000000.jpg?v=1710338254",
      scheduledDesktopPoster: "https://cdn.shopify.com/s/files/1/2665/0346/files/preview_images/d5bccd205fa74d59ae273092233d1fa8.thumbnail.0000000000.jpg?v=1710338254",
      currentMobilePoster: "https://cdn.shopify.com/s/files/1/2665/0346/files/preview_images/67c98c1370994c17a87bd70ca49a2a6e.thumbnail.0000000000.jpg?v=1710338249",
      scheduledMobilePoster: "https://cdn.shopify.com/s/files/1/2665/0346/files/preview_images/67c98c1370994c17a87bd70ca49a2a6e.thumbnail.0000000000.jpg?v=1710338249"
    }), /*#__PURE__*/React.createElement("div", {
      className: "divider"
    }), /*#__PURE__*/React.createElement("ul", {
      className: "ais-InfiniteHits-list"
    }, hits.slice(4, 8).map(hit => /*#__PURE__*/React.createElement("li", {
      key: hit.objectID,
      className: "ais-InfiniteHits-item"
    }, /*#__PURE__*/React.createElement(ReactProductCard, {
      hit: hit,
      windowWidth: windowWidth
    }))), "  "), /*#__PURE__*/React.createElement("img", {
      className: "hideonDesktop",
      alt: "Promotion Banner",
      src: "https://cdn.shopify.com/s/files/1/2665/0346/files/2024-0321_LP-Collection_01-M-Performance_Mobile.jpg?v=1710877159"
    }), /*#__PURE__*/React.createElement("img", {
      className: "hideonMobile",
      alt: "Promotion Banner",
      src: "https://cdn.shopify.com/s/files/1/2665/0346/files/2024-0321_LP-Collection_01-M-Performance_Desktop.jpg?v=1710877153"
    }), /*#__PURE__*/React.createElement("div", {
      className: "divider"
    }), /*#__PURE__*/React.createElement("ul", {
      className: "ais-InfiniteHits-list"
    }, hits.slice(8, 12).map(hit => /*#__PURE__*/React.createElement("li", {
      key: hit.objectID,
      className: "ais-InfiniteHits-item"
    }, /*#__PURE__*/React.createElement(ReactProductCard, {
      hit: hit,
      windowWidth: windowWidth
    }))), "  "), /*#__PURE__*/React.createElement("img", {
      className: "hideonDesktop",
      alt: "Promotion Banner",
      src: "https://cdn.shopify.com/s/files/1/2665/0346/files/2024-0321_LP-Collection_02_M-Performance_Mobile.gif?v=1710877160"
    }), /*#__PURE__*/React.createElement("div", {
      className: "doubleBanner hideonMobile"
    }, /*#__PURE__*/React.createElement("div", {
      className: "squareBanner-left"
    }, /*#__PURE__*/React.createElement("img", {
      alt: "Promotion Banner",
      src: "https://cdn.shopify.com/s/files/1/2665/0346/files/2024-0321_LP-Collection_02-M-Performance_Desktop.jpg?v=1710877153"
    })), /*#__PURE__*/React.createElement("div", {
      className: "miniDivider hideonDesktop"
    }), /*#__PURE__*/React.createElement("div", {
      className: "squareBanner-right"
    }, /*#__PURE__*/React.createElement("img", {
      alt: "Promotion Banner",
      src: "https://cdn.shopify.com/s/files/1/2665/0346/files/2024-0321_LP-Collection_03-M-Performance_Desktop.jpg?v=1710877153"
    }))), /*#__PURE__*/React.createElement("div", {
      className: "divider"
    }), /*#__PURE__*/React.createElement("ul", {
      className: "ais-InfiniteHits-list"
    }, hits.slice(12, 16).map(hit => /*#__PURE__*/React.createElement("li", {
      key: hit.objectID,
      className: "ais-InfiniteHits-item"
    }, /*#__PURE__*/React.createElement(ReactProductCard, {
      hit: hit,
      windowWidth: windowWidth
    }))), "  "), /*#__PURE__*/React.createElement("img", {
      className: "hideonDesktop",
      alt: "Promotion Banner",
      src: "https://cdn.shopify.com/s/files/1/2665/0346/files/2024-0321_LP-Collection_03-M-Performance_Mobile.jpg?v=1710877159"
    }), /*#__PURE__*/React.createElement("img", {
      className: "hideonMobile",
      alt: "Promotion Banner",
      src: "https://cdn.shopify.com/s/files/1/2665/0346/files/2024-0321_LP-Collection_04-M-Performance_Desktop.jpg?v=1710877153"
    }), /*#__PURE__*/React.createElement("div", {
      className: "divider"
    }), /*#__PURE__*/React.createElement("ul", {
      className: "ais-InfiniteHits-list"
    }, hits.slice(16).map(hit => /*#__PURE__*/React.createElement("li", {
      key: hit.objectID,
      className: "ais-InfiniteHits-item"
    }, /*#__PURE__*/React.createElement(ReactProductCard, {
      hit: hit,
      windowWidth: windowWidth
    }))), /*#__PURE__*/React.createElement("li", {
      className: "ais-InfiniteHits-sentinel",
      ref: sentinel
    })))));
  } else if (location.pathname.includes("derek-lunsford-tlf-athlete")) {
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
      className: "ais-InfiniteHits minHeight"
    }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("ul", {
      className: "ais-InfiniteHits-list"
    }, hits.slice(0, 4).map(hit => /*#__PURE__*/React.createElement("li", {
      key: hit.objectID,
      className: "ais-InfiniteHits-item"
    }, /*#__PURE__*/React.createElement(ReactProductCard, {
      hit: hit,
      windowWidth: windowWidth
    }))), "  "), /*#__PURE__*/React.createElement("img", {
      className: "hideonDesktop",
      alt: "Promotion Banner",
      src: "https://cdn.shopify.com/s/files/1/2665/0346/files/2024-0503_LP-Collection_01-M-Performance_Mobile.jpg?v=1714757856"
    }), /*#__PURE__*/React.createElement("img", {
      className: "hideonMobile",
      alt: "Promotion Banner",
      src: "https://cdn.shopify.com/s/files/1/2665/0346/files/2024-0503_LP-Collection_01_DerekLunsford_Desktop.jpg?v=1714757857"
    }), /*#__PURE__*/React.createElement("div", {
      className: "divider"
    }), /*#__PURE__*/React.createElement("ul", {
      className: "ais-InfiniteHits-list"
    }, hits.slice(4, 8).map(hit => /*#__PURE__*/React.createElement("li", {
      key: hit.objectID,
      className: "ais-InfiniteHits-item"
    }, /*#__PURE__*/React.createElement(ReactProductCard, {
      hit: hit,
      windowWidth: windowWidth
    }))), "  "), /*#__PURE__*/React.createElement("img", {
      className: "hideonDesktop",
      alt: "Promotion Banner",
      src: "https://cdn.shopify.com/s/files/1/2665/0346/files/2024-0503_LP-Collection_02_DerekLunsford_Mobile.gif?v=1714757857"
    }), /*#__PURE__*/React.createElement("div", {
      className: "doubleBanner hideonMobile"
    }, /*#__PURE__*/React.createElement("div", {
      className: "squareBanner-left"
    }, /*#__PURE__*/React.createElement("img", {
      alt: "Promotion Banner",
      src: "https://cdn.shopify.com/s/files/1/2665/0346/files/2024-0503_LP-Collection_02_DerekLunsford_Desktop.jpg?v=1714757857"
    })), /*#__PURE__*/React.createElement("div", {
      className: "miniDivider hideonDesktop"
    }), /*#__PURE__*/React.createElement("div", {
      className: "squareBanner-right"
    }, /*#__PURE__*/React.createElement("img", {
      alt: "Promotion Banner",
      src: "https://cdn.shopify.com/s/files/1/2665/0346/files/2024-0503_LP-Collection_03_DerekLunsford_Desktop.jpg?v=1714757857"
    }))), /*#__PURE__*/React.createElement("div", {
      className: "divider"
    }), /*#__PURE__*/React.createElement("ul", {
      className: "ais-InfiniteHits-list"
    }, hits.slice(8, 12).map(hit => /*#__PURE__*/React.createElement("li", {
      key: hit.objectID,
      className: "ais-InfiniteHits-item"
    }, /*#__PURE__*/React.createElement(ReactProductCard, {
      hit: hit,
      windowWidth: windowWidth
    }))), "  "), /*#__PURE__*/React.createElement("img", {
      className: "hideonDesktop",
      alt: "Promotion Banner",
      src: "https://cdn.shopify.com/s/files/1/2665/0346/files/2024-0503_LP-Collection_03_DerekLunsford_Mobile.jpg?v=1714757857"
    }), /*#__PURE__*/React.createElement("img", {
      className: "hideonMobile",
      alt: "Promotion Banner",
      src: "https://cdn.shopify.com/s/files/1/2665/0346/files/2024-0503_LP-Collection_04_DerekLunsford_Desktop_862673e1-9483-424f-98d2-ca043a8d48ab.jpg?v=1714769095"
    }), /*#__PURE__*/React.createElement("div", {
      className: "divider"
    }), /*#__PURE__*/React.createElement("ul", {
      className: "ais-InfiniteHits-list"
    }, hits.slice(12, 16).map(hit => /*#__PURE__*/React.createElement("li", {
      key: hit.objectID,
      className: "ais-InfiniteHits-item"
    }, /*#__PURE__*/React.createElement(ReactProductCard, {
      hit: hit,
      windowWidth: windowWidth
    }))), "  "), /*#__PURE__*/React.createElement("img", {
      className: "hideonDesktop",
      alt: "Promotion Banner",
      src: "https://cdn.shopify.com/s/files/1/2665/0346/files/2024-0503_LP-Collection_04_DerekLunsford_Mobile.jpg?v=1714757857"
    }), /*#__PURE__*/React.createElement("img", {
      className: "hideonMobile",
      alt: "Promotion Banner",
      src: "https://cdn.shopify.com/s/files/1/2665/0346/files/2024-0503_LP-Collection_05_DerekLunsford_Desktop.jpg?v=1714757857"
    }), /*#__PURE__*/React.createElement("div", {
      className: "divider"
    }), /*#__PURE__*/React.createElement("ul", {
      className: "ais-InfiniteHits-list"
    }, hits.slice(16).map(hit => /*#__PURE__*/React.createElement("li", {
      key: hit.objectID,
      className: "ais-InfiniteHits-item"
    }, /*#__PURE__*/React.createElement(ReactProductCard, {
      hit: hit,
      windowWidth: windowWidth
    }))), /*#__PURE__*/React.createElement("li", {
      className: "ais-InfiniteHits-sentinel",
      ref: sentinel
    })), /*#__PURE__*/React.createElement("div", {
      className: "divider"
    }))));
  } else if (location.pathname.includes("regan-grimes-tlf-athlete-gym-to-street-wear-essentials")) {
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
      className: "ais-InfiniteHits minHeight"
    }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("ul", {
      className: "ais-InfiniteHits-list"
    }, hits.slice(0, 8).map(hit => /*#__PURE__*/React.createElement("li", {
      key: hit.objectID,
      className: "ais-InfiniteHits-item"
    }, /*#__PURE__*/React.createElement(ReactProductCard, {
      hit: hit,
      windowWidth: windowWidth
    }))), "  "), /*#__PURE__*/React.createElement("img", {
      className: "hideonDesktop",
      alt: "Promotion Banner",
      src: "https://cdn.shopify.com/s/files/1/2665/0346/files/2024-0508_LP-Collection_ReganGrimes-A_Mobile.jpg?v=1715285069"
    }), /*#__PURE__*/React.createElement("img", {
      className: "hideonMobile",
      alt: "Promotion Banner",
      src: "https://cdn.shopify.com/s/files/1/2665/0346/files/2024-0508_LP-Collection_ReganGrimes-A_Desktop.jpg?v=1715285069"
    }), /*#__PURE__*/React.createElement("div", {
      className: "divider"
    }), /*#__PURE__*/React.createElement("ul", {
      className: "ais-InfiniteHits-list"
    }, hits.slice(8, 16).map(hit => /*#__PURE__*/React.createElement("li", {
      key: hit.objectID,
      className: "ais-InfiniteHits-item"
    }, /*#__PURE__*/React.createElement(ReactProductCard, {
      hit: hit,
      windowWidth: windowWidth
    }))), "  "), /*#__PURE__*/React.createElement("img", {
      className: "hideonDesktop",
      alt: "Promotion Banner",
      src: "https://cdn.shopify.com/s/files/1/2665/0346/files/2024-0508_LP-Collection_ReganGrimes-B_Mobile.jpg?v=1715285069"
    }), /*#__PURE__*/React.createElement("img", {
      className: "hideonMobile",
      alt: "Promotion Banner",
      src: "https://cdn.shopify.com/s/files/1/2665/0346/files/2024-0508_LP-Collection_ReganGrimes-B_Desktop.jpg?v=1715285069"
    }), /*#__PURE__*/React.createElement("div", {
      className: "divider"
    }), /*#__PURE__*/React.createElement("ul", {
      className: "ais-InfiniteHits-list"
    }, hits.slice(16).map(hit => /*#__PURE__*/React.createElement("li", {
      key: hit.objectID,
      className: "ais-InfiniteHits-item"
    }, /*#__PURE__*/React.createElement(ReactProductCard, {
      hit: hit,
      windowWidth: windowWidth
    }))), /*#__PURE__*/React.createElement("li", {
      className: "ais-InfiniteHits-sentinel",
      ref: sentinel
    })), /*#__PURE__*/React.createElement("div", {
      className: "divider"
    }))));
  } else {
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
      className: "ais-InfiniteHits minHeight"
    }, /*#__PURE__*/React.createElement("ul", {
      className: "ais-InfiniteHits-list"
    }, hits.map(hit => /*#__PURE__*/React.createElement("li", {
      key: hit.objectID,
      className: "ais-InfiniteHits-item"
    }, /*#__PURE__*/React.createElement(ReactProductCard, {
      hit: hit,
      windowWidth: windowWidth
    }))), /*#__PURE__*/React.createElement("li", {
      className: "ais-InfiniteHits-sentinel",
      ref: sentinel
    }))));
  }
};
const CustomInfiniteHits = connectInfiniteHits(InfiniteHits);
const CustomizedHits = props => {
  const windowWidth = props.windowWidth;
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "ais-InfiniteHits"
  }, /*#__PURE__*/React.createElement("ul", {
    className: "ais-InfiniteHits-list headerSearch"
  }, props.hits.map(hit => /*#__PURE__*/React.createElement("li", {
    key: hit.objectID,
    className: "ais-InfiniteHits-item"
  }, /*#__PURE__*/React.createElement(ReactProductCard, {
    hit: hit,
    windowWidth: windowWidth
  }))))));
};
const CustomHits = connectInfiniteHits(CustomizedHits);
const CustomizedRefinementList = ({
  items,
  isFromSearch,
  refine,
  createURL,
  attribute
}) => {
  const [refined, setRefined] = React.useState(false);
  if (attribute == "option2") {
    const sizes = {
      "XS": 0,
      "S": 1,
      "M": 2,
      "L": 3,
      "XL": 4,
      "2XL": 5,
      "S/M": 6,
      "L/XL": 7
    };
    items.sort((a, b) => {
      const nameA = a.label; // ignore upper and lowercase
      const nameB = b.label; // ignore upper and lowercase
      if (sizes[nameA] < sizes[nameB]) {
        return -1;
      }
      if (sizes[nameA] > sizes[nameB]) {
        return 1;
      }
      return 0;
    });
    return /*#__PURE__*/React.createElement("ul", {
      className: "ais-RefinementList"
    }, items.map(item => /*#__PURE__*/React.createElement("li", {
      key: item.label
    }, /*#__PURE__*/React.createElement("input", {
      className: 'RefinementList-checkbox',
      type: "checkbox",
      checked: item.isRefined,
      onChange: () => refine(item.value)
    }), item.label)));
  }
  if (attribute == "named_tags.gender") {
    React.useEffect(() => {
      if (!refined) {
        if (document.referrer.includes("womens")) {
          refine(['WOMENS']) && setRefined(true);
        } else if (document.referrer.includes("mens")) {
          refine(['MENS']) && setRefined(true);
        }
      }
    }, []);
    return /*#__PURE__*/React.createElement("ul", {
      className: "ais-RefinementList"
    }, items.map(item => /*#__PURE__*/React.createElement("li", {
      key: item.label
    }, /*#__PURE__*/React.createElement("input", {
      className: 'RefinementList-checkbox',
      type: "checkbox",
      checked: item.isRefined,
      onChange: () => refine(item.value)
    }), item.label)));
  }
  return /*#__PURE__*/React.createElement("ul", {
    className: "ais-RefinementList"
  }, items.map(item => /*#__PURE__*/React.createElement("li", {
    key: item.label
  }, /*#__PURE__*/React.createElement("input", {
    className: 'RefinementList-checkbox',
    type: "checkbox",
    checked: item.isRefined,
    onChange: () => refine(item.value)
  }), item.label)));
};
const CustomRefinementList = connectRefinementList(CustomizedRefinementList);
const CustomizedColorRefinementList = ({
  items,
  isFromSearch,
  refine,
  createURL,
  attribute
}) => {
  return /*#__PURE__*/React.createElement("ul", {
    className: "noStyleList"
  }, items.map(item => /*#__PURE__*/React.createElement("li", {
    key: item.label,
    "data-insights-filter": `${attribute}:${item.value}`
  }, /*#__PURE__*/React.createElement("a", {
    href: createURL(item.value),
    style: {
      fontWeight: item.isRefined ? 'bold' : ''
    },
    onClick: event => {
      event.preventDefault();
      refine(item.value);
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "tlf-color-swatch-wrapper"
  }, /*#__PURE__*/React.createElement("div", {
    className: `tlf-color-swatch tlf-color-${item.label.replaceAll(" ", "-").toLowerCase()}`
  })), item.label))));
};
const ColorRefinementList = connectRefinementList(CustomizedColorRefinementList);
